// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Design tokens ────────────────────────────────────────────────────────────── */

:root {
    --sa-surface:    rgba(14, 14, 20, 0.97);
    --sa-surface-2:  rgba(20, 20, 28, 0.95);
    --sa-surface-3:  rgba(26, 26, 36, 0.92);
    --sa-border:     rgba(255, 255, 255, 0.055);
    --sa-radius:     12px;
    --sa-radius-lg:  16px;
    --sa-gap:        20px;
    --sa-shadow-panel: 0 1px 3px rgba(0,0,0,0.4), 0 8px 24px rgba(0,0,0,0.18);

    /* Brand accent (gold) — used at varying opacity via rgba(var(--sa-accent), X) */
    --sa-accent:     192, 159, 83;

    /* Gray text ladder (RGB triplets, no alpha — call sites vary opacity).
       Consolidated from ~34 near-duplicate one-off grays that had organically
       drifted in by ±10-20 units each with no real difference in intent;
       these 4 anchors are the dominant exact value already used within each
       brightness band, so most call sites needed no visual change at all. */
    --sa-text-dim:       130, 130, 130;
    --sa-text-muted:     160, 160, 160;
    --sa-text-secondary: 180, 180, 180;
    --sa-text:           210, 210, 210;

    /* Per-channel accent palette */
    --sa-c-green:    #4ade80;
    --sa-c-blue:     #60a5fa;
    --sa-c-amber:    #f9bf40;
    --sa-c-purple:   #a78bfa;
    --sa-c-teal:     #2dd4bf;
    --sa-c-red:      #f87171;

    /* Translucent accent backgrounds */
    --sa-bg-green:   rgba(74, 222, 128, 0.08);
    --sa-bg-blue:    rgba(96, 165, 250, 0.08);
    --sa-bg-amber:   rgba(249, 191, 64, 0.08);
    --sa-bg-purple:  rgba(167, 139, 250, 0.08);
    --sa-bg-teal:    rgba(45, 212, 191, 0.08);
}

/* ── Site Analytics report page ─────────────────────────────────────────────── */

.sa-page {
    padding: 8px 0 72px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* ── Live view panel ─────────────────────────────────────────────────────────── */

.sa-live {
    border: 1px solid rgba(74,222,128,0.15);
    border-radius: var(--sa-radius, 12px);
    background: rgba(10, 18, 12, 0.98);
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.5), 0 8px 24px rgba(0,0,0,0.22);
    display: flex;
    flex-direction: column;
}

/* ── Header ── */
.sa-live__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    gap: 12px;
    cursor: pointer;
    user-select: none;
    flex-shrink: 0;
}

.sa-live__header:hover { background: rgba(255,255,255,0.015); }

.sa-live__title {
    display: flex;
    align-items: center;
    gap: 9px;
}

.sa-live__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #4ade80;
    box-shadow: 0 0 0 0 rgba(74,222,128,0.6);
    animation: sa-pulse 2s ease-out infinite;
    flex-shrink: 0;
}

@keyframes sa-pulse {
    0%   { box-shadow: 0 0 0 0 rgba(74,222,128,0.6); }
    60%  { box-shadow: 0 0 0 6px rgba(74,222,128,0); }
    100% { box-shadow: 0 0 0 0 rgba(74,222,128,0); }
}

.sa-live__label {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(74,222,128,0.9);
}

.sa-live__window {
    font-size: 0.7rem;
    color: rgba(var(--sa-text-dim),0.6);
}

.sa-live__right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.sa-live__countdown {
    font-size: 0.68rem;
    color: rgba(var(--sa-text-dim),0.55);
    font-variant-numeric: tabular-nums;
}

.sa-live__toggle {
    background: none;
    border: none;
    color: rgba(var(--sa-text-dim),0.55);
    cursor: pointer;
    padding: 2px 4px;
    font-size: 0.7rem;
    line-height: 1;
    border-radius: 4px;
}

.sa-live__toggle:hover { background: rgba(255,255,255,0.06); color: #ccc; }

/* ── Body ── */
.sa-live__body {
    border-top: 1px solid rgba(74,222,128,0.1);
    padding: 14px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    overflow-y: auto;
}

/* ── Sparkline ── */
.sa-live__sparkline {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.sa-live__spark-hd {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.sa-live__spark-label {
    font-size: 0.68rem;
    font-weight: 500;
    color: rgba(var(--sa-text-dim),0.6);
}

.sa-live__spark-peak {
    font-size: 0.62rem;
    color: rgba(var(--sa-text-dim),0.5);
    font-variant-numeric: tabular-nums;
}

.sa-live__spark-bars {
    display: flex;
    align-items: flex-end;
    gap: 2px;
    height: 44px;
}

.sa-live__spark-bar {
    flex: 1;
    border-radius: 2px 2px 0 0;
    background: rgba(74,222,128,0.28);
    min-height: 2px;
    transition: height 0.3s ease;
}

.sa-live__spark-bar--last {
    background: rgba(74,222,128,0.75);
}

.sa-live__spark-times {
    display: flex;
    justify-content: space-between;
    font-size: 0.6rem;
    color: rgba(var(--sa-text-dim),0.5);
}

/* ── 2 × 2 KPI grid ── */
.sa-live__kpis {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.sa-live__kpi {
    background: rgba(255,255,255,0.025);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.sa-live__kpi-label {
    font-size: 0.65rem;
    font-weight: 500;
    color: rgba(130,130,145,0.65);
}

.sa-live__kpi-value {
    font-size: 1.45rem;
    font-weight: 700;
    color: rgba(228,240,228,0.95);
    line-height: 1;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
}

.sa-live__kpi-sub {
    font-size: 0.62rem;
    color: rgba(var(--sa-text-dim),0.55);
    margin-top: 1px;
}

/* ── Recent events feed ── */
.sa-live__feed-wrap { display: flex; flex-direction: column; gap: 6px; }

.sa-live__section-title {
    font-size: 0.65rem;
    font-weight: 500;
    color: rgba(110,110,125,0.6);
    margin: 0;
}

.sa-live__feed {
    display: flex;
    flex-direction: column;
    max-height: 224px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: rgba(255,255,255,0.08) transparent;
}

.sa-live__event {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 8px;
    padding: 5px 0;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    animation: sa-fade-in 0.35s ease;
}

.sa-live__event:last-child { border-bottom: none; }

.sa-live__event--custom .sa-live__event-path {
    color: rgba(var(--sa-accent),0.8);
}

.sa-live__event-name {
    font-family: inherit;
    font-size: 0.7rem;
    font-weight: 500;
    letter-spacing: 0;
}

@keyframes sa-fade-in {
    from { opacity: 0; transform: translateY(-3px); }
    to   { opacity: 1; transform: translateY(0); }
}

.sa-live__event-path {
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.7rem;
    color: rgba(170,205,170,0.82);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sa-live__event-meta {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-shrink: 0;
}

.sa-live__event-flag {
    font-size: 0.68rem;
    color: rgba(150,150,155,0.6);
}

.sa-live__event-level {
    font-size: 0.58rem;
    font-weight: 600;
    padding: 1px 4px;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.sa-live__event-level--full {
    background: rgba(74,222,128,0.12);
    color: rgba(74,222,128,0.8);
}

.sa-live__event-level--minimal {
    background: rgba(var(--sa-accent),0.1);
    color: rgba(var(--sa-accent),0.7);
}

.sa-live__event-time {
    font-size: 0.62rem;
    color: rgba(var(--sa-text-dim),0.5);
    font-variant-numeric: tabular-nums;
    min-width: 28px;
    text-align: right;
}

/* ── Cross-site hosts ── */
.sa-live__hosts { display: flex; flex-direction: column; gap: 6px; }

.sa-live__conversions-wrap {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.sa-live__conv-total {
    margin-left: 6px;
    font-size: 0.7rem;
    font-weight: 400;
    color: rgba(74,222,128,0.7);
}
.sa-live__conv-list {
    display: flex;
    flex-direction: column;
    gap: 3px;
}
.sa-live__conv-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 8px;
    border-radius: 6px;
    background: rgba(74,222,128,0.06);
    border: 1px solid rgba(74,222,128,0.12);
}
.sa-live__conv-label {
    font-size: 0.78rem;
    color: rgba(210,240,220,0.85);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 60%;
}
.sa-live__conv-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}
.sa-live__conv-value {
    font-size: 0.72rem;
    color: rgba(74,222,128,0.75);
}
.sa-live__conv-count {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(74,222,128,0.9);
    background: rgba(74,222,128,0.12);
    padding: 1px 6px;
    border-radius: 10px;
}
.sa-live__conv-empty {
    font-size: 0.75rem;
    color: rgba(130,130,150,0.45);
    margin: 0;
}

/* ── Countries grid used in Audience page ── */
.sa-aud-countries-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 12px;
    border-radius: 10px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
}

/* ── Notices ─────────────────────────────────────────────────────────────────── */

.sa-notice {
    margin: 0;
    padding: 18px 22px;
    border-radius: 12px;
    font-size: 0.9rem;
    color: rgba(var(--sa-text-secondary),0.85);
    background: rgba(0,0,0,0.15);
    border: 1px solid rgba(255,255,255,0.07);
}

.sa-notice--error {
    background: rgba(220,80,80,0.08);
    border-color: rgba(220,100,100,0.25);
    color: #f5aeae;
}

/* ── Analytics section nav — underline tab strip (Vercel/Mixpanel style) ──────── */

.sa-subnav {
    display: flex;
    align-items: flex-end;
    gap: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    overflow-x: auto;
    scrollbar-width: none;
    flex-wrap: nowrap;
    margin-bottom: 4px;
    padding-top: 2px;
}

.sa-subnav::-webkit-scrollbar { display: none; }

.sa-subnav__tab {
    flex-shrink: 0;
    padding: 0 4px 11px;
    margin-right: 28px;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    font-size: 0.8rem;
    font-weight: 500;
    color: rgba(155, 155, 175, 0.6);
    text-decoration: none;
    transition: color 0.12s, border-color 0.12s;
    white-space: nowrap;
    line-height: 1;
    letter-spacing: 0.01em;
}

.sa-subnav__tab:last-child { margin-right: 0; }

.sa-subnav__tab:hover {
    color: rgba(215, 215, 235, 0.9);
}

.sa-subnav__tab--active {
    color: rgba(249, 191, 64, 1);
    border-bottom-color: rgba(249, 191, 64, 0.75);
    font-weight: 600;
}

.sa-subnav__tab--active:hover {
    color: rgba(249, 191, 64, 1);
}

/* ── Dashboard mode badge ────────────────────────────────────────────────────── */

/* ── Foreign-domain warning banner ───────────────────────────────────────── */

.sa-foreign-banner {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    background: rgba(251,191,36,0.07);
    border: 1px solid rgba(251,191,36,0.22);
    border-radius: var(--sa-radius);
    font-size: 0.8rem;
    color: rgba(var(--sa-text),0.75);
    margin-bottom: 16px;
}

.sa-foreign-banner__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: rgba(251,191,36,0.9);
    flex-shrink: 0;
    animation: sa-pulse 2s ease-in-out infinite;
}

.sa-foreign-banner__text {
    flex: 1;
    min-width: 0;
}

.sa-foreign-banner__text strong {
    color: rgba(251,191,36,0.9);
    font-weight: 600;
}

.sa-foreign-banner__link {
    font-size: 0.78rem;
    color: rgba(251,191,36,0.85);
    text-decoration: none;
    white-space: nowrap;
    font-weight: 500;
    flex-shrink: 0;
}

.sa-foreign-banner__link:hover { text-decoration: underline; }

/* ── Cross-site tracking settings rows ───────────────────────────────────── */

.sa-foreign-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 8px;
    margin-bottom: 6px;
    font-size: 0.82rem;
}

.sa-foreign-row--pending {
    background: rgba(251,191,36,0.06);
    border: 1px solid rgba(251,191,36,0.15);
}

.sa-foreign-row--approved {
    background: rgba(52,211,153,0.05);
    border: 1px solid rgba(52,211,153,0.15);
}

.sa-foreign-row__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(52,211,153,0.8);
    flex-shrink: 0;
}

.sa-foreign-row__domain {
    font-weight: 600;
    color: rgba(var(--sa-text),0.9);
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sa-foreign-row__meta {
    font-size: 0.75rem;
    color: rgba(var(--sa-text-secondary),0.45);
    white-space: nowrap;
}

.sa-foreign-row__actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.sa-btn--approve {
    background: rgba(52,211,153,0.15);
    border-color: rgba(52,211,153,0.3);
    color: rgba(52,211,153,0.9);
}

.sa-btn--approve:hover {
    background: rgba(52,211,153,0.22);
}

/* ── Mode badge ───────────────────────────────────────────────────────────── */

.sa-mode-badge {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.72rem;
    color: rgba(120,120,140,0.65);
}

.sa-mode-badge__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(249,191,64,0.7);
    flex-shrink: 0;
}

.sa-mode-badge strong {
    color: rgba(var(--sa-text),0.85);
    font-weight: 600;
}

.sa-mode-badge__link {
    color: rgba(var(--sa-accent),0.65);
    text-decoration: none;
    margin-left: 4px;
}

.sa-mode-badge__link:hover {
    color: rgba(var(--sa-accent),0.9);
    text-decoration: underline;
}

/* ── Business type selector cards (Settings) ─────────────────────────────────── */

.sa-biztype-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 8px;
}

.sa-biztype-card {
    background: rgba(255,255,255,0.025);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    padding: 13px 15px;
    text-align: left;
    cursor: pointer;
    transition: border-color 0.14s, background 0.14s;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.sa-biztype-card:hover {
    background: rgba(255,255,255,0.045);
    border-color: rgba(255,255,255,0.12);
}

.sa-biztype-card--active {
    background: rgba(var(--sa-accent),0.05);
    border-color: rgba(var(--sa-accent),0.35);
}

.sa-biztype-card__name {
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(200,200,220,0.88);
}

.sa-biztype-card--active .sa-biztype-card__name {
    color: rgba(249,191,64,0.95);
}

.sa-biztype-card__tagline {
    font-size: 0.69rem;
    color: rgba(120,120,140,0.65);
    line-height: 1.45;
}

.sa-biztype-card__pills {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 5px;
}

.sa-biztype-card__pill {
    font-size: 0.6rem;
    font-weight: 600;
    padding: 2px 7px;
    border-radius: 3px;
    background: rgba(255,255,255,0.06);
    color: rgba(140,140,160,0.72);
}

.sa-biztype-card--active .sa-biztype-card__pill {
    background: rgba(var(--sa-accent),0.1);
    color: rgba(249,191,64,0.82);
}

/* ── Meta row ────────────────────────────────────────────────────────────────── */

.sa-meta-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.sa-site-key-badge {
    font-size: 0.72rem;
    color: rgba(var(--sa-text-dim),0.6);
}

.sa-site-key-badge code {
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.72rem;
    color: rgba(var(--sa-text-secondary),0.7);
    background: rgba(255,255,255,0.05);
    padding: 1px 6px;
    border-radius: 4px;
}

/* ── KPI cards ───────────────────────────────────────────────────────────────── */

.sa-kpi {
    position: relative;
    padding: 20px 20px 18px 22px;
    border-radius: var(--sa-radius, 12px);
    border: 1px solid var(--sa-border, rgba(255,255,255,0.055));
    background: var(--sa-surface-3, rgba(26,26,36,0.92));
    box-shadow: var(--sa-shadow-panel);
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.sa-kpi:hover {
    box-shadow: 0 1px 3px rgba(0,0,0,0.5), 0 12px 32px rgba(0,0,0,0.26);
    border-color: rgba(255,255,255,0.1);
}

/* Left accent bar — replaces dated top stripe */
.sa-kpi::before {
    content: '';
    position: absolute;
    top: 14px; left: 0; bottom: 14px;
    width: 3px;
    border-radius: 0 3px 3px 0;
    background: rgba(249, 191, 64, 0.8);
}

/* Color carries meaning, not decoration: warn = a metric crossed a bad
   threshold, live = a healthy/active-right-now metric, revenue = money.
   Every other KPI card keeps the default gold accent bar/icon above —
   there used to be a positional rainbow here (2nd card blue, 3rd green,
   4th purple, purely by slot) plus hardcoded blue/purple/teal variants
   with no actual meaning; removed in favor of one consistent accent. */
.sa-kpi--warn::before { background: rgba(248,113,113,0.85) !important; }
.sa-kpi--live::before { background: rgba(74,222,128,0.85) !important; }
.sa-kpi--revenue::before { background: rgba(52,211,153,0.85) !important; }

.sa-kpi__head {
    display: flex;
    align-items: center;
    gap: 7px;
}

.sa-kpi__icon {
    display: inline-flex;
    color: rgba(var(--sa-accent),0.65);
}

.sa-kpi--warn .sa-kpi__icon    { color: rgba(248,113,113,0.7) !important; }
.sa-kpi--live .sa-kpi__icon    { color: rgba(74,222,128,0.7) !important; }
.sa-kpi--revenue .sa-kpi__icon { color: rgba(52,211,153,0.7) !important; }

.sa-kpi__icon svg {
    width: 14px;
    height: 14px;
}

.sa-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    color: rgba(var(--sa-accent),0.6);
}

.sa-kpi__label {
    font-size: 0.72rem;
    font-weight: 500;
    letter-spacing: 0;
    text-transform: none;
    color: rgba(var(--sa-text-muted),0.7);
}

.sa-kpi__value {
    font-size: 2rem;
    font-weight: 700;
    color: rgba(240, 240, 252, 0.95);
    line-height: 1;
    letter-spacing: -0.03em;
}

.sa-kpi--warn .sa-kpi__value { color: rgba(252,165,55,0.95); }

.sa-kpi__trend {
    display: inline-block;
    margin-left: 8px;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0;
    vertical-align: middle;
}

.sa-kpi__trend--up   { color: rgba(74,222,128,0.9); }
.sa-kpi__trend--down { color: rgba(248,113,113,0.9); }

.sa-kpi__sub {
    font-size: 0.69rem;
    color: rgba(var(--sa-text-dim),0.6);
    line-height: 1.4;
}

.sa-kpi__cross-check {
    display: block;
    margin-top: 4px;
    color: rgba(var(--sa-text-dim),0.5);
}

/* ── Chart section ───────────────────────────────────────────────────────────── */

.sa-chart-section {
    background: var(--sa-surface-3, rgba(26,26,36,0.92));
    border: 1px solid var(--sa-border, rgba(255,255,255,0.055));
    border-radius: var(--sa-radius, 12px);
    padding: 22px 24px 20px;
    box-shadow: var(--sa-shadow-panel);
}

.sa-area-chart { width: 100%; }

.sa-chart-section__hd {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 12px;
}

.sa-chart-section__title {
    margin: 0;
    font-size: 0.82rem;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    color: rgba(var(--sa-text),0.9);
    display: flex;
    align-items: center;
    gap: 7px;
}

.sa-chart-section__period {
    font-size: 0.69rem;
    color: rgba(130,130,150,0.6);
    white-space: nowrap;
}

.sa-chart {
    width: 100%;
    height: auto;
    position: relative;
}

.sa-chart--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    color: rgba(var(--sa-text-dim),0.6);
}

.sa-chart__legend {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    font-size: 0.7rem;
    color: rgba(var(--sa-text-dim),0.65);
}

.sa-chart__legend-dot {
    width: 8px;
    height: 8px;
    border-radius: 2px;
    flex-shrink: 0;
}

.sa-chart__legend-dot--full    { background: rgba(74,222,128,0.75); }
.sa-chart__legend-dot--minimal { background: rgba(var(--sa-accent),0.55); }

.sa-trend-insights {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.sa-trend-insights__chip {
    font-size: 0.72rem;
    color: rgba(var(--sa-text-muted),0.75);
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 8px;
    padding: 4px 10px;
}

.sa-trend-insights__chip b {
    color: #ececec;
    font-weight: 700;
}

/* ── Dashboard grid ──────────────────────────────────────────────────────────── */

.sa-dashboard-grid {
    display: grid;
    gap: 12px;
    align-items: start;
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas:
        "kpi1   kpi2    kpi3      kpi4"
        "chart  chart   chart     live"
        "pages  pages   consent   countries"
        "brows  brows   utm       utm"
        "os     os      screens   screens";
}

.sa-dashboard-grid--no-utm {
    grid-template-areas:
        "kpi1   kpi2    kpi3      kpi4"
        "chart  chart   chart     live"
        "pages  pages   consent   countries"
        "brows  brows   os        screens";
}

/* Grid area assignments */
.sa-ga-kpi0      { grid-area: kpi0; }
.sa-ga-kpi1      { grid-area: kpi1; }
.sa-ga-kpi2      { grid-area: kpi2; }
.sa-ga-kpi3      { grid-area: kpi3; }
.sa-ga-kpi4      { grid-area: kpi4; }
.sa-ga-kpi5      { grid-area: kpi5; }
.sa-ga-chart     { grid-area: chart; align-self: start; }
.sa-ga-live      { grid-area: live; }
.sa-ga-pages     { grid-area: pages; }
.sa-ga-consent   { grid-area: consent; }
.sa-ga-countries { grid-area: countries; }
.sa-ga-brows     { grid-area: brows; }
.sa-ga-utm       { grid-area: utm; }
.sa-ga-os        { grid-area: os; }
.sa-ga-screens   { grid-area: screens; }

@media (max-width: 1100px) {
    .sa-dashboard-grid,
    .sa-dashboard-grid--no-utm {
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas:
            "kpi1    kpi2"
            "kpi3    kpi4"
            "chart   chart"
            "live    live"
            "pages   pages"
            "consent countries"
            "brows   utm"
            "os      screens";
    }
    .sa-dashboard-grid--no-utm {
        grid-template-areas:
            "kpi1    kpi2"
            "kpi3    kpi4"
            "chart   chart"
            "live    live"
            "pages   pages"
            "consent countries"
            "brows   brows"
            "os      screens";
    }
}

@media (max-width: 620px) {
    .sa-dashboard-grid,
    .sa-dashboard-grid--no-utm {
        grid-template-columns: 1fr;
        grid-template-areas:
            "kpi1" "kpi2" "kpi3" "kpi4"
            "chart" "live"
            "pages" "consent" "countries"
            "brows" "utm" "os" "screens";
    }
}

/* ── Generic panel card ──────────────────────────────────────────────────────── */

.sa-panel {
    background: var(--sa-surface-3, rgba(26,26,36,0.92));
    border: 1px solid var(--sa-border, rgba(255,255,255,0.055));
    border-radius: var(--sa-radius, 12px);
    padding: 20px 22px;
    box-shadow: var(--sa-shadow-panel);
}

.sa-panel__title {
    margin: 0 0 14px;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    color: rgba(var(--sa-text),0.85);
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Divider between stacked sub-sections within a panel */
.sa-panel__divider {
    height: 1px;
    background: rgba(255,255,255,0.06);
    margin: 14px 0;
}

.sa-panel__sub-title {
    margin: 0 0 10px;
    font-size: 0.69rem;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    color: rgba(var(--sa-text-dim),0.6);
}

.sa-panel__consent-note {
    font-size: 0.62rem;
    font-weight: 500;
    color: rgba(var(--sa-text-dim),0.55);
    text-transform: none;
    letter-spacing: 0;
    margin-left: 4px;
}

.sa-panel__footer-link {
    display: inline-block;
    margin-top: 12px;
    font-size: 0.78rem;
    font-weight: 600;
    color: rgba(var(--sa-accent),0.9);
    text-decoration: none;
}

.sa-panel__footer-link:hover {
    text-decoration: underline;
}

.sa-table__link {
    color: rgba(var(--sa-accent),0.9);
    text-decoration: none;
    font-weight: 600;
}

.sa-table__link:hover {
    text-decoration: underline;
}

/* ── Tables ──────────────────────────────────────────────────────────────────── */

.sa-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.82rem;
}

.sa-table th {
    text-align: left;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-dim),0.6);
    padding: 0 8px 8px 0;
    border-bottom: 1px solid rgba(255,255,255,0.06);
}

.sa-table td {
    padding: 7px 8px 7px 0;
    color: rgba(var(--sa-text),0.88);
    border-bottom: 1px solid rgba(255,255,255,0.04);
    vertical-align: middle;
}

.sa-table tbody tr:last-child td { border-bottom: none; }

.sa-table tbody tr {
    transition: background 0.1s ease;
}
.sa-table tbody tr:hover td {
    background: rgba(255,255,255,0.025);
}

.sa-table__num {
    text-align: right !important;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    color: rgba(var(--sa-text),0.75);
}

.sa-table__path {
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.77rem;
    color: rgba(180,210,180,0.85);
}

.sa-table__bar {
    width: 72px;
    padding-left: 10px !important;
}

/* ── Table pager ─────────────────────────────────────────────────────────────── */

.sa-pager {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 10px;
}

.sa-pager__label {
    font-size: 0.78rem;
    color: rgba(var(--sa-text-muted),0.75);
    white-space: nowrap;
}

/* ── Mini bar ────────────────────────────────────────────────────────────────── */

.sa-mini-bar {
    height: 5px;
    border-radius: 3px;
    background: rgba(255,255,255,0.05);
    overflow: hidden;
}

.sa-mini-bar__fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s ease;
}

/* ── Consent + device bars ───────────────────────────────────────────────────── */

.sa-consent-list {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

.sa-consent-row {
    display: grid;
    grid-template-columns: max-content 1fr 32px;
    align-items: center;
    gap: 10px;
}

.sa-consent-row__label {
    font-size: 0.78rem;
    color: rgba(185,185,185,0.85);
    white-space: nowrap;
}

.sa-consent-row__pct {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.7);
    text-align: right;
    font-variant-numeric: tabular-nums;
}

.sa-bar {
    height: 8px;
    border-radius: 4px;
    background: rgba(255,255,255,0.05);
    overflow: hidden;
    display: flex;
}

.sa-bar__seg {
    height: 100%;
    transition: width 0.3s ease;
}

/* ── World map ───────────────────────────────────────────────────────────────── */

.sa-map {
    margin-bottom: 14px;
}

.sa-map__inner {
    width: 100%;
    height: 100%;
    min-height: 220px;
    border-radius: 8px;
    overflow: hidden;
    background: rgba(0,0,0,0.12);
    border: 1px solid rgba(255,255,255,0.05);
}

.sa-map__caption {
    margin: 6px 2px 0;
    font-size: 0.72rem;
    color: rgba(var(--sa-text-muted),0.65);
}

.sa-map--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 160px;
    font-size: 0.875rem;
    color: rgba(var(--sa-text-dim),0.6);
    background: rgba(0,0,0,0.1);
    border: 1px solid rgba(255,255,255,0.05);
    border-radius: 8px;
}

/* ── Copy button ─────────────────────────────────────────────────────────────── */

.sa-copy-btn {
    padding: 5px 13px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.12);
    background: rgba(255,255,255,0.05);
    color: rgba(var(--sa-text),0.9);
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    white-space: nowrap;
}

.sa-copy-btn:hover { background: rgba(255,255,255,0.09); border-color: rgba(255,255,255,0.2); }
.sa-copy-btn--done { background: rgba(74,222,128,0.12); border-color: rgba(74,222,128,0.3); color: #6ee7a0; }

/* ── Setup / empty state card ────────────────────────────────────────────────── */

.sa-setup {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
    padding: 56px 32px;
    border-radius: 16px;
    border: 1px dashed rgba(255,255,255,0.1);
    background: rgba(0,0,0,0.1);
}

.sa-setup__icon { color: rgba(var(--sa-accent),0.8); }

.sa-setup__icon svg {
    width: 36px;
    height: 36px;
}

.sa-setup__title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #ececec;
}

.sa-setup__body {
    margin: 0;
    max-width: 520px;
    font-size: 0.9rem;
    line-height: 1.65;
    color: rgba(175,175,175,0.85);
}

.sa-setup__loading {
    margin: 0;
    font-size: 0.875rem;
    color: rgba(var(--sa-text-muted),0.65);
}

.sa-setup__gen-btn {
    display: inline-flex;
    align-items: center;
    padding: 10px 24px;
    border-radius: 10px;
    border: 1px solid rgba(var(--sa-accent),0.45);
    background: rgba(var(--sa-accent),0.1);
    color: rgba(227,200,130,0.95);
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.sa-setup__gen-btn:hover:not(:disabled) {
    background: rgba(var(--sa-accent),0.2);
    border-color: rgba(var(--sa-accent),0.65);
}

.sa-setup__gen-btn:disabled { opacity: 0.45; cursor: not-allowed; }

.sa-setup__snippet-wrap {
    width: 100%;
    max-width: 640px;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sa-setup__snippet-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.sa-setup__snippet-label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(var(--sa-accent),0.8);
}

.sa-setup__snippet {
    margin: 0;
    padding: 14px 16px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.07);
    background: rgba(0,0,0,0.28);
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.78rem;
    line-height: 1.7;
    color: #c9e9a0;
    white-space: pre-wrap;
    word-break: break-all;
}

.sa-setup__hint {
    margin: 0;
    font-size: 0.78rem;
    color: rgba(var(--sa-text-dim),0.65);
    line-height: 1.5;
}

.sa-setup__hint code {
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.82em;
    background: rgba(255,255,255,0.07);
    border-radius: 4px;
    padding: 1px 5px;
    color: #d4b896;
}

/* ── Overview bento layout ────────────────────────────────────────────────────── */

.sa-overview {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* KPI strip — equal-width cards, expands to 6 when quality-leads is present */
.sa-kpi-strip-wrap {
    position: relative;
}
.sa-kpi-strip {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
}
.sa-kpi-strip--4 {
    grid-template-columns: repeat(4, 1fr);
}
.sa-kpi-strip--6 {
    grid-template-columns: repeat(6, 1fr);
}

.sa-customize-btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    margin-top: 8px;
    padding: 4px 10px;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    background: transparent;
    color: rgba(180,180,200,0.6);
    font-size: 0.72rem;
    cursor: pointer;
    transition: color 0.15s, border-color 0.15s;
}
.sa-customize-btn:hover {
    color: rgba(200,200,220,0.9);
    border-color: rgba(255,255,255,0.2);
}

.sa-customize-backdrop {
    position: fixed;
    inset: 0;
    z-index: 200;
    background: rgba(0,0,0,0.45);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 120px;
}
.sa-customize-panel {
    background: #1e1e2e;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    width: 340px;
    padding: 20px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.6);
}
.sa-customize-panel__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}
.sa-customize-panel__title {
    font-size: 0.9rem;
    font-weight: 600;
    color: rgba(220,220,240,0.95);
}
.sa-customize-panel__close {
    background: none;
    border: none;
    color: rgba(180,180,200,0.5);
    font-size: 0.85rem;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 4px;
}
.sa-customize-panel__close:hover { color: rgba(220,220,240,0.9); }
.sa-customize-panel__sub {
    font-size: 0.75rem;
    color: rgba(150,150,175,0.6);
    margin: 0 0 14px;
}
.sa-customize-panel__list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 16px;
}
.sa-customize-panel__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid transparent;
    transition: background 0.12s, border-color 0.12s;
}
.sa-customize-panel__item:hover {
    background: rgba(255,255,255,0.04);
}
.sa-customize-panel__item--on {
    background: rgba(96,165,250,0.07);
    border-color: rgba(96,165,250,0.2);
}
.sa-customize-panel__check {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
    accent-color: rgba(96,165,250,0.9);
    cursor: pointer;
}
.sa-customize-panel__item-label {
    font-size: 0.82rem;
    font-weight: 500;
    color: rgba(210,210,230,0.9);
    flex: 1;
}
.sa-customize-panel__item-desc {
    font-size: 0.72rem;
    color: rgba(140,140,165,0.55);
}
.sa-customize-panel__actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}
.sa-customize-panel__reset {
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid rgba(255,255,255,0.1);
    background: transparent;
    color: rgba(160,160,185,0.7);
    font-size: 0.78rem;
    cursor: pointer;
}
.sa-customize-panel__reset:hover { color: rgba(200,200,220,0.9); }
.sa-customize-panel__apply {
    padding: 6px 14px;
    border-radius: 6px;
    border: none;
    background: rgba(96,165,250,0.85);
    color: #fff;
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
}
.sa-customize-panel__apply:hover { background: rgba(96,165,250,1); }

/* Row 1: main chart (60 %) + live feed (40 %) */
.sa-overview-main {
    display: grid;
    grid-template-columns: 3fr 2fr;
    gap: 12px;
    align-items: start;
}

/* Row 2: world-map (wide) | top countries | devices */
.sa-overview-geo {
    display: grid;
    grid-template-columns: 2.2fr 2fr 1.5fr;
    gap: 12px;
    align-items: start;
}

/* Row 3: traffic sources | top pages */
.sa-overview-bottom {
    display: grid;
    grid-template-columns: 5fr 4fr;
    gap: 12px;
    align-items: start;
}

@media (max-width: 1200px) {
    .sa-kpi-strip    { grid-template-columns: repeat(3, 1fr); }
    .sa-kpi-strip--4 { grid-template-columns: repeat(2, 1fr); }
    .sa-kpi-strip--6 { grid-template-columns: repeat(3, 1fr); }
    .sa-overview-geo { grid-template-columns: 1fr 1fr; }
}

@media (max-width: 900px) {
    .sa-overview-main   { grid-template-columns: 1fr; }
    .sa-overview-bottom { grid-template-columns: 1fr; }
}

@media (max-width: 680px) {
    .sa-kpi-strip, .sa-kpi-strip--4, .sa-kpi-strip--6 { grid-template-columns: repeat(2, 1fr); }
    .sa-overview-geo { grid-template-columns: 1fr; }
}

/* ── Audience sub-page grid ──────────────────────────────────────────────────── */

.sa-audience-grid {
    display: grid;
    gap: 12px;
    align-items: start;
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
        "kpis       kpis"
        "nvr        nvr"
        "interests  interests"
        "countries  countries"
        "browsers   os"
        "screens    devices"
        "lang       tz";
}

.sa-aud-kpis      { grid-area: kpis;      display: flex; gap: 12px; flex-wrap: wrap; }
.sa-aud-kpis .sa-kpi { flex: 1 1 200px; }
.sa-aud-nvr       { grid-area: nvr;       }
.sa-aud-interests  { grid-area: interests; }
.sa-aud-countries { grid-area: countries; }
.sa-aud-browsers  { grid-area: browsers;  }
.sa-aud-os        { grid-area: os;        }
.sa-aud-devices   { grid-area: devices;   }
.sa-aud-screens   { grid-area: screens;   }
.sa-aud-lang      { grid-area: lang;      }
.sa-aud-tz        { grid-area: tz;        }

/* ── Interest rule rows (engagement-scored on/off-topic split) ───────────── */

.sa-int-rules-list {
    display: flex;
    flex-direction: column;
}

.sa-int-rule-row {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 11px 0;
    border-bottom: 1px solid rgba(255,255,255,0.05);
}
.sa-int-rule-row:last-of-type { border-bottom: none; }

.sa-int-rule-row__header {
    display: flex;
    align-items: center;
    gap: 8px;
}
.sa-int-rule-row__label {
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(220,230,245,0.9);
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.sa-int-rule-row__stats {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 0.78rem;
    color: rgba(180,180,200,0.5);
    flex-shrink: 0;
}
.sa-int-rule-row__score {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
}

.sa-int-rule-row__bar {
    height: 8px;
    background: rgba(255,255,255,0.06);
    border-radius: 4px;
    overflow: hidden;
}
.sa-int-rule-row__bar-on {
    height: 100%;
    background: rgba(16,185,129,0.55);
    border-radius: 4px;
    transition: width 0.4s ease;
    min-width: 2px;
}

.sa-int-rule-row__legend {
    display: flex;
    gap: 14px;
    font-size: 0.75rem;
    font-variant-numeric: tabular-nums;
}
.sa-int-rule-row__on  { color: rgba(16,185,129,0.75); }
.sa-int-rule-row__off { color: rgba(180,180,200,0.38); }

/* ── Skeleton / shimmer loader ─────────────────────────────────────────────── */
@keyframes sa-shimmer {
    0%   { background-position: -200% 0; }
    100% { background-position:  200% 0; }
}
.sa-skeleton {
    border-radius: 4px;
    background: linear-gradient(
        90deg,
        rgba(255,255,255,0.04) 25%,
        rgba(255,255,255,0.09) 50%,
        rgba(255,255,255,0.04) 75%
    );
    background-size: 200% 100%;
    animation: sa-shimmer 1.5s ease-in-out infinite;
    flex-shrink: 0;
}
.sa-skeleton-rows {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 4px 0;
}
.sa-skeleton-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

/* ── Shared dark-theme form primitives (interest rules, etc.) ──────────────── */

.ia-input {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    color: rgba(220,230,245,0.9);
    font-size: 0.83rem;
    padding: 7px 10px;
    width: 100%;
    outline: none;
    box-sizing: border-box;
    transition: border-color 0.15s;
}
.ia-input::placeholder {
    color: rgba(180,180,200,0.35);
}
.ia-input:focus {
    border-color: rgba(var(--sa-accent),0.5);
}

.ia-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 6px;
    font-size: 0.82rem;
    font-weight: 600;
    padding: 7px 14px;
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.15s;
}
.ia-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}
.ia-btn--primary {
    background: rgba(var(--sa-accent),0.7);
    color: #111118;
}
.ia-btn--primary:not(:disabled):hover {
    background: rgba(var(--sa-accent),0.9);
}

.sa-interest-form {
    display: grid;
    grid-template-columns: 1fr 1fr auto auto;
    gap: 10px;
    align-items: end;
    margin-top: 4px;
}

@media (max-width: 700px) {
    .sa-interest-form {
        grid-template-columns: 1fr 1fr;
    }
}

/* ── Error boundary inline card ──────────────────────────────────────────── */

.sa-boundary-error {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    border-radius: 6px;
    background: rgba(239,68,68,0.08);
    border: 1px solid rgba(239,68,68,0.2);
    color: rgba(252,165,165,0.85);
    font-size: 13px;
}
.sa-boundary-error__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: rgba(239,68,68,0.25);
    color: rgba(252,165,165,0.9);
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
}

.sa-aud-nvr-bars { display: flex; gap: 8px; }
.sa-aud-nvr-bars > div { flex: 1; }

@media (max-width: 620px) {
    .sa-audience-grid {
        grid-template-columns: 1fr;
        grid-template-areas:
            "kpis" "nvr" "interests" "countries" "browsers" "os"
            "devices" "screens" "lang" "tz";
    }
    .sa-aud-nvr-bars { flex-direction: column; }
    .sa-int-rule-row__stats { gap: 5px; font-size: 0.72rem; }
}

/* ── User flow diagram ────────────────────────────────────────────────────────── */

.sa-flow-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 4px;
}

.sa-flow-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 14px;
}

.sa-flow-tabs {
    display: flex;
    gap: 4px;
    background: rgba(255, 255, 255, 0.04);
    border-radius: 8px;
    padding: 3px;
}

.sa-flow-tab {
    background: transparent;
    border: none;
    color: rgba(var(--sa-text-secondary),0.7);
    font-size: 0.76rem;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
}

.sa-flow-tab.--active {
    background: rgba(var(--sa-accent), 0.18);
    color: rgba(230, 210, 160, 0.95);
}

.sa-flow-clear {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 10px;
    padding: 5px 12px;
    background: rgba(var(--sa-accent), 0.14);
    border: 1px solid rgba(var(--sa-accent), 0.35);
    border-radius: 999px;
    color: rgba(230, 210, 160, 0.95);
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
}

.sa-flow-clear:hover {
    background: rgba(var(--sa-accent), 0.22);
}

.sa-flow-trace-loading {
    display: inline-block;
    margin-bottom: 10px;
    margin-left: 8px;
    font-size: 0.75rem;
    color: rgba(var(--sa-text-secondary),0.6);
}

/* ── Google Analytics sub-page stack ─────────────────────────────────────────── */

.sa-ga4-stack {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.ga4-two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
}

@media (max-width: 700px) {
    .ga4-two-col { grid-template-columns: 1fr; }
}

/* New vs Returning */
.ga4-nvr {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.ga4-nvr__bar-track {
    display: flex;
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    background: rgba(255,255,255,0.05);
}
.ga4-nvr__bar-new {
    background: rgba(96,165,250,0.55);
    border-radius: 4px 0 0 4px;
    transition: width 0.4s ease;
}
.ga4-nvr__bar-ret {
    background: rgba(52,211,153,0.45);
    border-radius: 0 4px 4px 0;
    transition: width 0.4s ease;
}
.ga4-nvr__legend {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.78rem;
    color: rgba(var(--sa-text-muted),0.7);
}
.ga4-nvr__dot {
    width: 8px; height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
}
.ga4-nvr__dot--new { background: rgba(96,165,250,0.7); }
.ga4-nvr__dot--ret { background: rgba(52,211,153,0.6); }
.ga4-nvr__label strong { color: rgba(210,215,230,0.9); }
.ga4-nvr__label { margin-right: 8px; }

/* Channel table inline bar */
.ga4-ch-bar-cell {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 140px;
}
.ga4-ch-bar-track {
    flex: 1;
    height: 5px;
    background: rgba(255,255,255,0.05);
    border-radius: 3px;
    overflow: hidden;
}
.ga4-ch-bar-fill {
    height: 100%;
    background: rgba(145,158,180,0.35);
    border-radius: 3px;
    transition: width 0.3s ease;
}
.ga4-ch-bar-pct {
    font-size: 0.72rem;
    color: rgba(145,158,180,0.55);
    white-space: nowrap;
    min-width: 36px;
    text-align: right;
}

/* ── Search Console sub-page stack ───────────────────────────────────────────── */

.sa-gsc-stack {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

/* Generic KPI row — a flat strip of KpiCards, for pages (Search Console,
   Audience, Acquisition) that don't need a named-grid-area layout. */
.sa-kpi-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.sa-kpi-row .sa-kpi {
    flex: 1 1 200px;
}

/* ── Acquisition sub-page grid ───────────────────────────────────────────────── */

.sa-acq-grid {
    display: grid;
    gap: 12px;
    align-items: start;
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
        "kpis      kpis"
        "pages     utm"
        "referrers hosts";
}

.sa-acq-kpis      { grid-area: kpis; display: flex; gap: 12px; flex-wrap: wrap; }
.sa-acq-kpis .sa-kpi { flex: 1 1 200px; }
.sa-acq-pages     { grid-area: pages;     }
.sa-acq-utm       { grid-area: utm;       }
.sa-acq-referrers { grid-area: referrers; }
.sa-acq-hosts     { grid-area: hosts;     }

@media (max-width: 760px) {
    .sa-acq-grid {
        grid-template-columns: 1fr;
        grid-template-areas: "kpis" "pages" "utm" "referrers" "hosts";
    }
}

/* ── Ad Spend sub-page grid ──────────────────────────────────────────────────── */

.sa-as-grid {
    display: grid;
    gap: 12px;
    align-items: start;
    grid-template-columns: repeat(3, 1fr);
    grid-template-areas:
        "kpi0      kpi1      kpi2"
        "chart     chart     chart"
        "platforms platforms platforms"
        "domains   domains   domains";
}

.sa-as-kpi0      { grid-area: kpi0; }
.sa-as-kpi1      { grid-area: kpi1; }
.sa-as-kpi2      { grid-area: kpi2; }
.sa-as-chart     { grid-area: chart; align-self: start; }
.sa-as-platforms { grid-area: platforms; }
.sa-as-domains   { grid-area: domains; }

@media (max-width: 760px) {
    .sa-as-grid {
        grid-template-columns: 1fr;
        grid-template-areas: "kpi0" "kpi1" "kpi2" "chart" "platforms" "domains";
    }
}

.sa-channel-cards {
    display: grid;
    gap: 14px;
    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
    margin-top: 12px;
}

.sa-channel-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 10px;
    padding: 12px 14px 14px;
}

.sa-channel-card__title {
    margin: 0 0 10px;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.85);
}

.sa-channel-card__tiles {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 6px;
    margin-bottom: 10px;
}

.sa-channel-tile {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 10px;
    border-radius: 8px;
    border: none;
    background: rgba(255,255,255,0.05);
    cursor: pointer;
    text-align: left;
    font: inherit;
}

.sa-channel-tile--active {
    box-shadow: 0 0 0 1px rgba(255,255,255,0.15) inset;
}

.sa-channel-tile--active .sa-channel-tile__label,
.sa-channel-tile--active .sa-channel-tile__value {
    color: #fff;
}

.sa-channel-tile--static {
    cursor: default;
}

.sa-channel-tile__label {
    font-size: 0.62rem;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-secondary),0.7);
}

.sa-channel-tile__value {
    font-size: 0.95rem;
    font-weight: 700;
    color: rgba(230,230,230,0.92);
}

@media (max-width: 620px) {
    .sa-channel-card__tiles {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* ── Consent sub-page grid ───────────────────────────────────────────────────── */

.sa-consent-page-grid {
    display: grid;
    gap: 12px;
    align-items: start;
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas:
        "kpi1 kpi2 kpi3 kpi4"
        "bars bars bars bars";
}

.sa-cg-kpi1 { grid-area: kpi1; }
.sa-cg-kpi2 { grid-area: kpi2; }
.sa-cg-kpi3 { grid-area: kpi3; }
.sa-cg-kpi4 { grid-area: kpi4; }
.sa-cg-bars { grid-area: bars; }

@media (max-width: 1100px) {
    .sa-consent-page-grid {
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas:
            "kpi1 kpi2"
            "kpi3 kpi4"
            "bars bars";
    }
}

@media (max-width: 620px) {
    .sa-consent-page-grid {
        grid-template-columns: 1fr;
        grid-template-areas:
            "kpi1" "kpi2" "kpi3" "kpi4" "bars";
    }
}

/* ── Heatmap sub-page grid ───────────────────────────────────────────────────── */

/* Screenshot is the hero — fixed 340 px sidebar holds data panels;
   viewport takes all remaining width. */
.sa-heatmap-grid {
    display: grid;
    gap: 12px;
    align-items: start;
    grid-template-columns: 1fr 340px;
    grid-template-areas:
        "controls controls"
        "viewport sidecar";
}

.sa-heatmap__controls {
    grid-area: controls;
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

/* Path selector stretches to fill available space in the controls row */
.sa-heatmap__path-select { flex: 1; min-width: 180px; }

/* ── Viewport — the hero screenshot area ── */
.sa-heatmap__viewport {
    grid-area: viewport;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    overflow: hidden;
    background: rgba(0,0,0,0.22);
    border: 1px solid rgba(255,255,255,0.07);
    /* Always fill most of the screen so the screenshot is the main attraction */
    min-height: calc(100vh - 210px);
}

/* Thin amber label strip — replaces the heavy panel h3 */
.sa-heatmap__viewport-label {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 11px 16px;
    font-size: 0.78rem;
    font-weight: 500;
    color: rgba(var(--sa-accent),0.85);
    border-bottom: 1px solid rgba(255,255,255,0.06);
    flex-shrink: 0;
}

/* ── Data sidebar ── */
.sa-heatmap__sidecar {
    grid-area: sidecar;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* ≤ 1500px — covers all 13" MacBook variants (1280–1470 px logical).
   Viewport is full-width hero; sidecar panels sit side-by-side below. */
@media (max-width: 1500px) {
    .sa-heatmap-grid {
        grid-template-columns: 1fr;
        grid-template-areas:
            "controls"
            "viewport"
            "sidecar";
    }
    .sa-heatmap__sidecar { flex-direction: row; }
    .sa-heatmap__sidecar > .sa-panel { flex: 1; min-width: 0; }
}

@media (max-width: 900px) {
    .sa-heatmap__sidecar { flex-direction: column; }
    .sa-heatmap__sidecar > .sa-panel { flex: none; }
}

.sa-select {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: rgba(var(--sa-text),0.9);
    font-size: 0.82rem;
    padding: 7px 10px;
    min-width: 220px;
}

.sa-heatmap__device-tabs {
    display: flex;
    gap: 4px;
    background: rgba(255,255,255,0.04);
    border-radius: 8px;
    padding: 3px;
}

.sa-heatmap__device-tab {
    background: transparent;
    border: none;
    color: rgba(var(--sa-text-secondary),0.7);
    font-size: 0.76rem;
    padding: 6px 12px;
    border-radius: 6px;
    cursor: pointer;
}

.sa-heatmap__device-tab.--active {
    background: rgba(var(--sa-accent),0.18);
    color: rgba(230,210,160,0.95);
}

/* frame-outer fills the viewport panel via flex: 1; the parent's min-height
   is the floor. min-height: 0 overrides the browser default so flexbox can
   actually shrink it when the viewport panel is smaller than the screenshot. */
.sa-heatmap__frame-outer {
    flex: 1;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
    scrollbar-color: rgba(var(--sa-accent),0.35) rgba(0,0,0,0.18);
}
.sa-heatmap__frame-outer::-webkit-scrollbar       { width: 5px; }
.sa-heatmap__frame-outer::-webkit-scrollbar-track { background: rgba(0,0,0,0.18); }
.sa-heatmap__frame-outer::-webkit-scrollbar-thumb { background: rgba(var(--sa-accent),0.35); border-radius: 3px; }

/* Positioning context for the SVG overlay — no overflow: hidden so the
   scroll container (frame-outer) handles clipping. */
.sa-heatmap__frame-wrap {
    position: relative;
    width: 100%;
}

.sa-heatmap__frame-img {
    display: block;
    width: 100%;
    height: auto;
    pointer-events: none;
    user-select: none;
}

.sa-heatmap__frame-fallback {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px;
    font-size: 0.8rem;
    color: rgba(var(--sa-text-muted),0.6);
}
.sa-heatmap__frame-fallback.--error { color: #f5aeae; }

/* Height is injected via inline style (JS calculates rendered image height)
   so the viewBox maps precisely to the full image, not just the visible area. */
.sa-heatmap__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
}

.sa-scroll-funnel {
    display: flex;
    flex-direction: column;
    gap: 9px;
}

/* ── Recording player ────────────────────────────────────────────────────────── */

.sa-recording-player {
    width: 100%;
    min-height: 520px;
    display: flex;
    justify-content: center;
}

/* ── Bots sub-page grid ──────────────────────────────────────────────────────── */

.sa-bots-grid {
    display: grid;
    gap: 12px;
    align-items: start;
    grid-template-columns: repeat(4, 1fr);
    grid-template-areas:
        "kpi1  kpi2  category   category"
        "list  list  list       list"
        "asns  asns  suspicious suspicious"
        "pages pages recent     recent";
}

.sa-bots-kpi1       { grid-area: kpi1;       }
.sa-bots-kpi2       { grid-area: kpi2;       }
.sa-bots-category   { grid-area: category;   }
.sa-bots-list       { grid-area: list;       }
.sa-bots-asns       { grid-area: asns;       }
.sa-bots-suspicious { grid-area: suspicious; }
.sa-bots-pages      { grid-area: pages;      }
.sa-bots-recent     { grid-area: recent;     }

@media (max-width: 1100px) {
    .sa-bots-grid {
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas:
            "kpi1       kpi2"
            "category   category"
            "list       list"
            "asns       suspicious"
            "pages      pages"
            "recent     recent";
    }
}

@media (max-width: 620px) {
    .sa-bots-grid {
        grid-template-columns: 1fr;
        grid-template-areas:
            "kpi1" "kpi2" "category" "list" "asns" "suspicious" "pages" "recent";
    }
}

/* ── Conversions section (ConversionsPanel, embedded on the Overview page) ───── */

.sa-section {
    background: rgba(26,26,30,0.75);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
    padding: 18px 20px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.18);
}

.sa-panel__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.sa-section__title {
    margin: 0;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-muted),0.65);
    display: flex;
    align-items: center;
    gap: 8px;
}

.sa-panel__sub {
    color: rgba(var(--sa-text-dim),0.55);
    font-size: 0.82rem;
    margin: 0;
}

.sa-add-event-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(var(--sa-accent),0.12);
    border: 1px solid rgba(var(--sa-accent),0.3);
    color: rgba(230,210,160,0.95);
    font-size: 0.78rem;
    font-weight: 600;
    padding: 7px 12px;
    border-radius: 8px;
    cursor: pointer;
}

.sa-add-event-btn:hover {
    background: rgba(var(--sa-accent),0.2);
}

.sa-event-form {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 14px;
    margin-bottom: 14px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
}

.sa-event-form__input,
.sa-event-form__select {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 8px;
    color: rgba(var(--sa-text),0.9);
    font-size: 0.82rem;
    padding: 7px 10px;
}

.sa-event-form__input {
    flex: 1;
    min-width: 160px;
}

.sa-event-form__submit {
    background: rgba(var(--sa-accent),0.55);
    border: none;
    color: #1a1a1e;
    font-weight: 600;
    font-size: 0.82rem;
    padding: 7px 16px;
    border-radius: 8px;
    cursor: pointer;
}

.sa-event-form__submit:disabled { opacity: 0.5; cursor: not-allowed; }

.sa-event-form__hint {
    flex-basis: 100%;
    margin: 2px 0 0;
    font-size: 0.76rem;
    color: rgba(var(--sa-accent),0.85);
}

.sa-events-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.sa-event-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 4px;
    border-bottom: 1px solid rgba(255,255,255,0.05);
}

.sa-event-row:last-child { border-bottom: none; }

.sa-event-row__icon {
    color: rgba(var(--sa-accent),0.8);
    flex-shrink: 0;
    margin-top: 2px;
}

.sa-event-row__icon svg { width: 18px; height: 18px; }

.sa-event-row__body { flex: 1; min-width: 0; }

.sa-event-row__top {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.sa-event-row__name {
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.92);
}

.sa-event-row__kind {
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-muted),0.65);
    background: rgba(255,255,255,0.05);
    padding: 2px 6px;
    border-radius: 4px;
}

.sa-event-row__unregistered {
    font-size: 0.68rem;
    color: rgba(220,160,60,0.85);
}

.sa-event-row__stats {
    display: flex;
    gap: 14px;
    margin-top: 4px;
    font-size: 0.78rem;
    color: rgba(var(--sa-text-secondary),0.75);
    font-variant-numeric: tabular-nums;
}

.sa-event-row__consent-note {
    color: rgba(var(--sa-text-dim),0.55);
}

.sa-event-row__toggles {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 6px;
    margin-left: -8px;
}

.sa-event-row__snippet-toggle {
    background: none;
    border: none;
    color: rgba(150,180,220,0.75);
    font-size: 0.72rem;
    padding: 6px 8px;
    min-height: 32px;
    border-radius: 4px;
    cursor: pointer;
}

.sa-event-row__snippet-toggle:hover { background: rgba(255,255,255,0.06); }

.sa-event-row__snippet {
    margin-top: 6px;
    padding: 8px 10px;
    background: rgba(0,0,0,0.25);
    border-radius: 6px;
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.74rem;
    color: rgba(180,210,180,0.85);
    overflow-x: auto;
}

.sa-event-row__payloads {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.sa-event-row__payloads-empty {
    font-size: 0.74rem;
    color: rgba(var(--sa-text-muted),0.65);
}

.sa-event-row__payload {
    padding: 8px 10px;
    background: rgba(0,0,0,0.25);
    border-radius: 6px;
}

.sa-event-row__payload-meta {
    display: flex;
    gap: 10px;
    font-size: 0.68rem;
    color: rgba(var(--sa-text-muted),0.7);
    font-variant-numeric: tabular-nums;
    margin-bottom: 4px;
}

.sa-event-row__payload-path {
    color: rgba(150,180,220,0.75);
    overflow-wrap: anywhere;
}

.sa-event-row__payload-data {
    margin: 0;
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.74rem;
    color: rgba(180,210,180,0.85);
    overflow-x: auto;
}

.sa-event-row__delete {
    background: none;
    border: none;
    color: rgba(200,120,120,0.6);
    cursor: pointer;
    padding: 4px;
    flex-shrink: 0;
}

.sa-event-row__delete:hover { color: rgba(230,140,140,0.9); }
.sa-event-row__delete svg { width: 16px; height: 16px; }

/* ── Funnel builder ───────────────────────────────────────────────────────────── */

.sa-funnel-form { flex-direction: column; align-items: stretch; }

.sa-funnel-form__steps {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.sa-funnel-form__step {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.sa-funnel-form__step-index {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    border-radius: 50%;
    background: rgba(var(--sa-accent),0.16);
    color: rgba(230,210,160,0.95);
    font-size: 0.72rem;
    font-weight: 700;
}

.sa-funnel-form__step-actions {
    display: flex;
    gap: 4px;
    margin-left: auto;
}

.sa-funnel-form__step-actions button {
    background: none;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    color: rgba(var(--sa-text),0.8);
    font-size: 0.78rem;
    padding: 4px 7px;
    cursor: pointer;
}

.sa-funnel-form__step-actions button:hover:not(:disabled) { border-color: rgba(var(--sa-accent),0.4); color: rgba(230,210,160,0.95); }
.sa-funnel-form__step-actions button:disabled { opacity: 0.35; cursor: not-allowed; }
.sa-funnel-form__step-actions button svg { width: 14px; height: 14px; }

.sa-funnel-form__actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 4px;
}

.sa-funnel-form__cancel {
    background: none;
    border: none;
    color: rgba(150,180,220,0.75);
    font-size: 0.8125rem;
    cursor: pointer;
    padding: 0;
}

.sa-funnel-form__cancel:hover { color: rgba(180,205,235,0.95); }

/* ── Quality leads KPI (only rendered once lead quality is configured) ───────── */

.sa-lead-kpi-wrap {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
}

.sa-lead-kpi-wrap > .sa-kpi {
    grid-column: span 1;
}

@media (max-width: 1100px) {
    .sa-lead-kpi-wrap { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 620px) {
    .sa-lead-kpi-wrap { grid-template-columns: 1fr; }
}

/* ── Conversions sub-page submenu (same visual language as the app's
   Settings sidebar — vertical list, gold inset-left-border active state —
   scoped to this page instead of the global fixed SideNav) ─────────────── */

.sa-conv-layout {
    display: flex;
    align-items: flex-start;
    gap: 24px;
}

.sa-conv-submenu {
    flex: 0 0 180px;
    position: sticky;
    top: 16px;
}

.sa-conv-submenu__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.sa-conv-submenu__item {
    margin: 0;
}

.sa-conv-submenu__link {
    display: block;
    width: 100%;
    text-align: left;
    appearance: none;
    border: none;
    background: transparent;
    color: rgba(var(--sa-text-muted),0.75);
    font-size: 0.82rem;
    font-weight: 600;
    padding: 9px 12px;
    border-radius: 6px;
    cursor: pointer;
}

.sa-conv-submenu__link:hover:not(.--active) {
    background-color: rgba(255,255,255,0.06);
    color: rgb(255,255,255);
}

.sa-conv-submenu__link.--active {
    background: rgba(255,255,255,0.08);
    color: rgb(255,255,255);
    box-shadow: inset 3px 0 0 0 rgb(var(--sa-accent));
}

.sa-conv-submenu-content {
    flex: 1;
    min-width: 0;
}

@media (max-width: 900px) {
    .sa-conv-layout {
        flex-direction: column;
        gap: 12px;
    }
    .sa-conv-submenu {
        flex: none;
        width: 100%;
        position: static;
    }
    .sa-conv-submenu__list {
        flex-direction: row;
        flex-wrap: wrap;
    }
    .sa-conv-submenu__link.--active {
        box-shadow: inset 0 -3px 0 0 rgb(var(--sa-accent));
    }
}

/* ── Conversions sub-page grid ────────────────────────────────────────────────── */

.sa-conv-grid {
    display: grid;
    gap: 12px;
    align-items: start;
}

.sa-conv-grid--overview {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
        "kpi1  kpi2"
        "trend trend"
        "map   map";
}

.sa-conv-grid--deepdive {
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
        "ttc         channels"
        "funnel      funnel"
        "campaigns   campaigns";
}

.sa-conv-kpi1          { grid-area: kpi1;      }
.sa-conv-kpi2          { grid-area: kpi2;      }
.sa-conv-trend         { grid-area: trend;     }
.sa-conv-map           { grid-area: map;       }
.sa-conv-ttc           { grid-area: ttc;       }
.sa-conv-channels      { grid-area: channels;  }
.sa-conv-funnel-panel  { grid-area: funnel;    }
.sa-conv-campaigns     { grid-area: campaigns; }

@media (max-width: 900px) {
    .sa-conv-grid--overview {
        grid-template-columns: 1fr;
        grid-template-areas: "kpi1" "kpi2" "trend" "map";
    }
    .sa-conv-grid--deepdive {
        grid-template-columns: 1fr;
        grid-template-areas: "ttc" "channels" "funnel" "campaigns";
    }
}

.sa-map__mode-toggle {
    margin-left: auto;
    display: inline-flex;
    gap: 2px;
    padding: 2px;
    border-radius: 8px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.07);
}

.sa-map__mode-toggle button {
    appearance: none;
    border: none;
    background: transparent;
    color: rgba(var(--sa-text-muted),0.7);
    font-size: 0.66rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 4px 9px;
    border-radius: 6px;
    cursor: pointer;
}

.sa-map__mode-toggle button.is-active {
    background: rgba(var(--sa-accent),0.18);
    color: #e8d9b5;
}

/* ── Time-to-convert breakdown ──────────────────────────────────────────────── */

.sa-ttc-row {
    grid-template-columns: 90px 1fr 40px;
}

.sa-ttc-note {
    margin: 12px 0 0;
}

.sa-funnel-note {
    margin: 12px 0 0;
}

/* ── Checkout funnel ─────────────────────────────────────────────────────────── */

.sa-funnel-step {
    margin-top: 4px;
}

.sa-funnel-step__dropoff {
    font-size: 0.68rem;
    font-weight: 600;
    color: rgba(239,120,120,0.8);
    padding: 4px 0 4px 4px;
}

.sa-funnel-step__row {
    display: grid;
    grid-template-columns: 130px 1fr 90px;
    align-items: center;
    gap: 10px;
}

.sa-funnel-step__label {
    font-size: 0.8rem;
    color: rgba(var(--sa-text),0.9);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sa-funnel-step__track {
    height: 22px;
    border-radius: 6px;
    background: rgba(255,255,255,0.05);
    overflow: hidden;
}

.sa-funnel-step__fill {
    height: 100%;
    min-width: 3px;
    border-radius: 6px;
    background: linear-gradient(90deg, rgba(var(--sa-accent),0.85), rgba(var(--sa-accent),0.55));
    transition: width 0.3s ease;
}

.sa-funnel-step__value {
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.85);
    text-align: right;
    font-variant-numeric: tabular-nums;
}

.sa-funnel-step__pct {
    font-weight: 500;
    color: rgba(var(--sa-text-muted),0.65);
    margin-left: 4px;
}

/* ── Campaign table (expandable rows) ───────────────────────────────────────── */

.sa-campaign-row {
    cursor: pointer;
}

.sa-campaign-row:hover td {
    background: rgba(255,255,255,0.02);
}

.sa-campaign-row--flat {
    cursor: default;
}

.sa-campaign-row--flat:hover td {
    background: transparent;
}

.sa-campaign-row__toggle {
    width: 20px;
    padding-right: 0 !important;
}

.sa-campaign-row__toggle .sa-icon {
    transition: transform 0.15s ease;
}

.sa-campaign-row__chevron--open {
    transform: rotate(-180deg);
}

.sa-campaign-row__detail td {
    border-bottom: 1px solid rgba(255,255,255,0.04);
    padding-top: 0;
    padding-bottom: 10px;
}

.sa-campaign-events {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.sa-campaign-event-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.72rem;
    color: rgba(var(--sa-text-secondary),0.8);
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 999px;
    padding: 3px 10px 3px 12px;
}

.sa-campaign-event-chip b {
    color: #ececec;
    font-weight: 700;
}
/* ─── GA4 server-side badge ──────────────────────────────────────────────── */
.ga4-ss-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    background: rgba(var(--sa-accent),0.12);
    border: 1px solid rgba(var(--sa-accent),0.3);
    border-radius: 20px;
    font-size: 0.71rem;
    font-weight: 600;
    color: rgba(var(--sa-accent),0.95);
    letter-spacing: 0.01em;
}

/* Platform breakdown */
.ga4-platform-breakdown {
    margin-top: 16px;
    padding-top: 14px;
    border-top: 1px solid rgba(255,255,255,0.06);
}
.ga4-platform-breakdown__title {
    margin: 0 0 10px;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(145,158,180,0.65);
}
.ga4-platform-breakdown__rows {
    display: flex;
    flex-direction: column;
    gap: 7px;
}
.ga4-pb-row {
    display: grid;
    grid-template-columns: 160px 1fr 52px 70px;
    align-items: center;
    gap: 10px;
    font-size: 0.8rem;
}
.ga4-pb-row__name {
    color: rgba(185,195,215,0.85);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.ga4-pb-row--ss .ga4-pb-row__name {
    color: rgba(var(--sa-accent),0.9);
    font-weight: 600;
}
.ga4-pb-row__ss-icon {
    margin-right: 4px;
}
.ga4-pb-row__ss-hint {
    font-size: 0.7rem;
    font-weight: 400;
    color: rgba(140,145,200,0.65);
    margin-left: 4px;
}
.ga4-pb-row__bar-wrap {
    height: 8px;
    background: rgba(255,255,255,0.05);
    border-radius: 4px;
    overflow: hidden;
}
.ga4-pb-row__bar {
    height: 100%;
    border-radius: 4px;
    transition: width 0.3s ease;
}
.ga4-pb-row__share {
    text-align: right;
    color: rgba(145,160,185,0.75);
    font-size: 0.75rem;
}
.ga4-pb-row__count {
    text-align: right;
    color: rgba(185,195,215,0.7);
    font-size: 0.75rem;
    font-variant-numeric: tabular-nums;
}

/* ─── Channel Analytics Redesigned Layout ───────────────────────────────── */

/* Compact page header */
.ca-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
    flex-wrap: wrap;
}
.ca-page-header__left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}
.ca-page-header__title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 700;
    color: rgba(235,240,255,0.96);
    display: flex;
    align-items: center;
    gap: 10px;
}
.ca-page-header__channel {
    color: rgba(200,210,240,0.9);
    font-weight: 600;
}
.ca-back-btn {
    background: none;
    border: none;
    padding: 0;
    font-size: 0.82rem;
    font-weight: 600;
    color: rgba(145,160,200,0.75);
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.12s;
}
.ca-back-btn:hover { color: rgba(200,210,240,0.95); }
.ca-compare-pill {
    display: inline-block;
    padding: 3px 10px;
    background: rgba(var(--sa-accent),0.12);
    border: 1px solid rgba(var(--sa-accent),0.25);
    border-radius: 20px;
    font-size: 0.71rem;
    color: rgba(var(--sa-accent),0.95);
}
.ca-reconcile-link {
    display: inline-block;
    padding: 6px 14px;
    background: rgba(var(--sa-accent),0.1);
    border: 1px solid rgba(var(--sa-accent),0.25);
    border-radius: 8px;
    font-size: 0.77rem;
    font-weight: 600;
    color: rgba(var(--sa-accent),0.95);
    text-decoration: none;
    transition: background 0.13s;
    white-space: nowrap;
}
.ca-reconcile-link:hover { background: rgba(var(--sa-accent),0.18); color: rgba(var(--sa-accent),1); }

/* Consent KPI strip */
.ca-kpi-strip {
    display: flex;
    gap: 0;
    margin-bottom: 16px;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 12px;
    overflow: hidden;
}
.ca-kpi {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 12px 8px;
    border-right: 1px solid rgba(255,255,255,0.06);
    cursor: default;
    min-width: 0;
    transition: background 0.12s;
}
.ca-kpi:last-child { border-right: none; }
.ca-kpi:hover { background: rgba(255,255,255,0.035); }
.ca-kpi__value {
    font-size: 1.3rem;
    font-weight: 700;
    color: rgba(232,236,248,0.95);
    letter-spacing: -0.025em;
    line-height: 1.1;
    white-space: nowrap;
}
.ca-kpi--warn .ca-kpi__value { color: rgba(252,165,50,0.92); }
.ca-kpi__label {
    font-size: 0.64rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(140,155,180,0.6);
    margin-top: 3px;
    text-align: center;
    line-height: 1.2;
}
.ca-kpi__compare {
    margin-top: 3px;
    font-size: 0.7rem;
}

/* Table section header with inline toolbar */
.ca-table-section { margin-bottom: 0; }
.ca-table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}
.ca-table-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

/* Collapsed context section */
.ca-context-details {
    margin: 16px 0 4px;
}
.ca-context-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(170,180,210,0.8);
    list-style: none;
    user-select: none;
    transition: background 0.12s;
}
.ca-context-summary::-webkit-details-marker { display: none; }
.ca-context-summary::before {
    content: "▸";
    font-size: 0.7rem;
    color: rgba(140,155,180,0.5);
    transition: transform 0.15s;
}
details[open] .ca-context-summary::before { content: "▾"; }
.ca-context-summary:hover { background: rgba(255,255,255,0.055); }
.ca-context-summary__hint {
    font-size: 0.69rem;
    font-weight: 400;
    color: rgba(130,145,170,0.55);
    margin-left: 4px;
}
.ca-context-details[open] .ca-context-summary {
    border-radius: 10px 10px 0 0;
    border-bottom: none;
}

/* ─── GA4 Coverage & Blindspots ─────────────────────────────────────────── */

.ga4-coverage {
    margin: 20px 0 0;
    padding: 16px 20px;
    background: rgba(255,255,255,0.025);
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.07);
}
.ga4-coverage__header {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 14px;
}
.ga4-coverage__title {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(var(--sa-accent),0.9);
}
.ga4-coverage__subtitle {
    font-size: 0.72rem;
    color: rgba(140,155,180,0.65);
}
.ga4-coverage__metrics {
    display: flex;
    gap: 0;
    flex-wrap: wrap;
    margin-bottom: 14px;
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 8px;
    overflow: hidden;
}
.ga4-coverage__metric {
    flex: 1;
    min-width: 90px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 12px;
    border-right: 1px solid rgba(255,255,255,0.07);
    gap: 3px;
}
.ga4-coverage__metric:last-child { border-right: none; }
.ga4-coverage__metric--dark { background: rgba(239,68,68,0.05); }
.ga4-coverage__metric-value {
    font-size: 1.05rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: rgba(235,240,255,0.95);
    letter-spacing: -0.01em;
}
.ga4-coverage__metric--dark .ga4-coverage__metric-value {
    color: rgba(239,68,68,0.85);
}
.ga4-coverage__metric-label {
    font-size: 0.67rem;
    color: rgba(140,155,180,0.7);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
/* Stacked bar */
.ga4-coverage__bar-track {
    position: relative;
    height: 10px;
    background: rgba(239,68,68,0.2);
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 6px;
}
.ga4-coverage__bar-fill {
    position: absolute;
    left: 0; top: 0; bottom: 0;
    background: linear-gradient(90deg, rgba(74,222,128,0.75), rgba(34,197,94,0.65));
    border-radius: 6px;
    transition: width 0.4s ease;
    min-width: 2px;
}
.ga4-coverage__bar-legend {
    display: flex;
    gap: 16px;
    margin-bottom: 10px;
    font-size: 0.7rem;
}
.ga4-coverage__legend-consent::before {
    content: "■";
    color: rgba(74,222,128,0.75);
    margin-right: 4px;
}
.ga4-coverage__legend-dark::before {
    content: "■";
    color: rgba(239,68,68,0.4);
    margin-right: 4px;
}
.ga4-coverage__legend-consent { color: rgba(165,185,215,0.75); }
.ga4-coverage__legend-dark    { color: rgba(165,185,215,0.75); }
.ga4-coverage__note {
    margin: 0;
    font-size: 0.71rem;
    color: rgba(130,145,170,0.6);
    line-height: 1.5;
}

/* ─── GA4 Channel Cross-reference ───────────────────────────────────────── */

.ga4-xref {
    margin: 20px 0 0;
    padding: 16px 20px 12px;
    background: rgba(255,255,255,0.02);
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.07);
}
.ga4-xref__header {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 12px;
    flex-wrap: wrap;
}
.ga4-xref__title {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(var(--sa-accent),0.9);
}
.ga4-xref__subtitle {
    font-size: 0.69rem;
    color: rgba(130,145,170,0.55);
}
.ga4-xref__scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 10px;
}
.ga4-xref__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.78rem;
}
.ga4-xref__th {
    padding: 6px 10px;
    text-align: left;
    font-size: 0.68rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(140,155,180,0.7);
    border-bottom: 1px solid rgba(255,255,255,0.08);
    white-space: nowrap;
}
.ga4-xref__th--num { text-align: right; }
.ga4-xref__td {
    padding: 7px 10px;
    color: rgba(215,225,245,0.85);
    border-bottom: 1px solid rgba(255,255,255,0.04);
    vertical-align: middle;
}
.ga4-xref__td--num {
    text-align: right;
    font-variant-numeric: tabular-nums;
}
.ga4-xref__td--channels {
    font-size: 0.72rem;
    color: rgba(180,195,225,0.7);
    max-width: 220px;
}
.ga4-xref__row--blind {
    background: rgba(239,68,68,0.04);
}
.ga4-xref__row--blind .ga4-xref__td { color: rgba(220,230,250,0.85); }
.ga4-xref__blind-badge {
    display: inline-block;
    font-size: 0.6rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(239,68,68,0.9);
    background: rgba(239,68,68,0.12);
    border: 1px solid rgba(239,68,68,0.3);
    border-radius: 4px;
    padding: 1px 5px;
    margin-right: 6px;
    vertical-align: middle;
}
.ga4-xref__no-match {
    color: rgba(130,145,170,0.45);
    font-style: italic;
}
.ga4-xref__cov--low  { color: rgba(239,68,68,0.85);  font-weight: 600; }
.ga4-xref__cov--mid  { color: rgba(251,191,36,0.85); font-weight: 600; }
.ga4-xref__cov--high { color: rgba(74,222,128,0.85); font-weight: 600; }
.ga4-xref__note {
    margin: 0;
    font-size: 0.7rem;
    color: rgba(120,135,160,0.55);
    line-height: 1.5;
}

/* ── Page Experiments — visual editor ───────────────────────────────────────── */

.pxp-editor {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: calc(100vh - 160px);
    min-height: 500px;
}

.pxp-editor--results {
    height: auto;
    min-height: 0;
}

.pxp-editor__toolbar {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

.pxp-back-link {
    appearance: none;
    border: none;
    background: transparent;
    color: rgba(var(--sa-text-muted),0.75);
    font-size: 0.8rem;
    cursor: pointer;
    padding: 0;
}
.pxp-back-link:hover { color: #ececec; }

.pxp-variant-tabs {
    display: flex;
    gap: 4px;
    flex: 1;
    flex-wrap: wrap;
}

.pxp-mode-tabs {
    display: flex;
    gap: 4px;
}

.pxp-settings-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 12px;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(26,26,30,0.75);
}

.pxp-goal-field {
    display: flex;
    align-items: center;
    gap: 10px;
}

.pxp-goal-field__label {
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-muted),0.65);
    white-space: nowrap;
}

.pxp-settings-row__status {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
}

.pxp-status-note {
    font-size: 0.78rem;
    font-weight: 500;
    color: rgba(var(--sa-text-secondary),0.8);
    white-space: nowrap;
}

.pxp-variant-tab {
    appearance: none;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.03);
    color: rgba(var(--sa-text-secondary),0.8);
    font-size: 0.78rem;
    font-weight: 600;
    padding: 6px 12px;
    border-radius: 7px;
    cursor: pointer;
    outline: none;
}
.pxp-variant-tab.--active {
    background: rgba(var(--sa-accent),0.2);
    color: #e8d9b5;
    border-color: rgba(var(--sa-accent),0.3);
}
.pxp-variant-tab:focus-visible {
    outline: 2px solid rgba(var(--sa-accent),0.5);
    outline-offset: 2px;
}
.pxp-variant-tab--add {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: rgba(var(--sa-text-dim),0.7);
    border-style: dashed;
}

.pxp-editor__body {
    display: flex;
    gap: 12px;
    flex: 1;
    min-height: 0;
}

.pxp-editor__canvas {
    flex: 1;
    min-width: 0;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(20,20,24,0.6);
}

.pxp-editor__iframe {
    width: 100%;
    height: 100%;
    border: none;
    background: #fff;
}

.pxp-editor__panel {
    flex: 0 0 300px;
    overflow-y: auto;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(26,26,30,0.75);
}

.pxp-launch-btn {
    appearance: none;
    border: 1px solid rgba(74,222,128,0.35);
    background: rgba(74,222,128,0.12);
    color: #b6f2c8;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 8px 14px;
    border-radius: 8px;
    cursor: pointer;
}
.pxp-launch-btn--pause {
    border-color: rgba(220,100,100,0.35);
    background: rgba(220,80,80,0.1);
    color: #f0a3a3;
}
.pxp-launch-btn:disabled {
    opacity: 0.5;
    cursor: default;
}

.pxp-select-btn {
    display: block;
    width: 100%;
    appearance: none;
    border: 1px solid rgba(var(--sa-accent),0.35);
    background: rgba(var(--sa-accent),0.12);
    color: #e8d9b5;
    font-size: 0.8rem;
    font-weight: 600;
    padding: 9px 12px;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 14px;
}
.pxp-select-btn.--active {
    background: rgba(var(--sa-accent),0.3);
}
.pxp-select-btn:disabled {
    opacity: 0.5;
    cursor: default;
}

.pxp-inspector {
    margin-bottom: 16px;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
}

.pxp-inspector__selector {
    font-family: "SF Mono","Fira Code","Cascadia Code",monospace;
    font-size: 0.72rem;
    color: rgba(180,210,180,0.85);
    background: rgba(255,255,255,0.04);
    padding: 6px 8px;
    border-radius: 6px;
    margin: 0 0 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pxp-inspector__label {
    display: block;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-dim),0.6);
    margin-bottom: 6px;
}

.pxp-changes-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.pxp-style-panel {
    margin-bottom: 14px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.pxp-style-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.pxp-style-field {
    display: grid;
    grid-template-columns: 100px 1fr;
    align-items: center;
    gap: 8px;
}

.pxp-style-field__label {
    font-size: 0.74rem;
    color: rgba(var(--sa-text-secondary),0.8);
}

.pxp-style-field__input {
    width: 100%;
}

.pxp-style-field__color {
    width: 36px;
    height: 26px;
    padding: 0;
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
}

.pxp-style-field__range {
    width: 100%;
}

.pxp-style-field__range-value {
    grid-column: 2;
    font-size: 0.68rem;
    color: rgba(var(--sa-text-dim),0.7);
    margin-top: -4px;
}

/* ── Results / report panel ──────────────────────────────────────────────── */

.pxp-report {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.pxp-report__pages {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 12px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(26,26,30,0.75);
}

.pxp-report__page {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 0.82rem;
}

.pxp-report__page-name {
    font-weight: 600;
    color: #ececec;
    flex-shrink: 0;
}

.pxp-report__page-url {
    color: rgba(var(--sa-accent),0.85);
    font-family: monospace;
    font-size: 0.78rem;
    overflow-wrap: anywhere;
}

.pxp-report__page-name--link {
    cursor: pointer;
    text-decoration: underline dotted rgba(236,236,236,0.35);
    text-underline-offset: 3px;
}

.pxp-report__page-name--link:hover {
    color: rgba(var(--sa-accent),0.95);
}

.pxp-report__variant-name {
    cursor: pointer;
}

.pxp-report__variant-name:hover {
    color: rgba(var(--sa-accent),0.95);
}

.sa-infotip {
    display: inline-flex;
    margin-left: 5px;
    color: rgba(var(--sa-text-muted),0.6);
    font-size: 0.9em;
    line-height: 1;
    cursor: help;
    vertical-align: middle;
}

.sa-infotip:hover {
    color: rgba(var(--sa-accent),0.9);
}

.sa-benchmark-note {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 6px;
    font-size: 0.72rem;
    color: rgba(var(--sa-text-dim),0.75);
}

.sa-benchmark-note__diff {
    font-weight: 700;
}

.sa-benchmark-note__diff--up   { color: rgba(74,222,128,0.9); }
.sa-benchmark-note__diff--down { color: rgba(248,113,113,0.9); }

/* ── Variant detail page ──────────────────────────────────────────────────── */
.pxp-detail__title {
    display: flex;
    align-items: center;
    gap: 10px;
}

.pxp-detail__section-title {
    margin: 22px 0 10px;
    font-size: 0.85rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.85);
}

.pxp-detail-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
}

.pxp-detail-stat {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 12px 10px;
    border-radius: 10px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.03);
    text-align: center;
}

.pxp-detail-stat__value {
    font-size: 1.15rem;
    font-weight: 700;
    color: #ececec;
}

.pxp-detail-stat__label {
    font-size: 0.68rem;
    color: rgba(var(--sa-text-muted),0.7);
}

.pxp-detail-clicks {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.pxp-detail-clicks__row {
    display: flex;
    align-items: baseline;
    gap: 8px;
    font-size: 0.8rem;
    padding: 8px 10px;
    border-radius: 8px;
    background: rgba(255,255,255,0.03);
}

.pxp-detail-clicks__selector {
    color: rgba(var(--sa-accent),0.9);
    font-size: 0.76rem;
    flex-shrink: 0;
}

.pxp-detail-clicks__text {
    color: rgba(var(--sa-text-secondary),0.75);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.pxp-detail-clicks__n {
    margin-left: auto;
    color: rgba(var(--sa-text),0.6);
    font-size: 0.72rem;
    flex-shrink: 0;
}

/* ── Enhanced click table ──────────────────────────────────────────────── */
.pxp-clicks-table {
    min-width: 560px;
}

.pxp-clicks-table td {
    vertical-align: middle;
}

.pxp-clicks-table .pxp-detail-clicks__selector {
    display: inline;
    margin-right: 5px;
}

.pxp-clicks-table .pxp-detail-clicks__text {
    display: inline;
    font-size: 0.73rem;
    color: rgba(var(--sa-text-secondary),0.65);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    vertical-align: middle;
}

.pxp-clicks-table__page {
    white-space: nowrap;
}

.pxp-clicks-table__path {
    font-family: monospace;
    font-size: 0.75rem;
    color: rgba(136,176,232,0.85);
    white-space: nowrap;
}

.pxp-clicks-table__pos {
    white-space: nowrap;
}

.pxp-clicks-table__pos-chip {
    font-size: 0.72rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.pxp-clicks-table__pos-pct {
    font-size: 0.66rem;
    font-weight: 400;
    opacity: 0.6;
    font-variant-numeric: tabular-nums;
}

.pxp-clicks-table__n {
    position: relative;
    font-variant-numeric: tabular-nums;
    min-width: 90px;
}

.pxp-clicks-table__bar-wrap {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    padding: 0 12px;
    pointer-events: none;
}

.pxp-clicks-table__bar {
    height: 3px;
    border-radius: 2px;
    background: rgba(var(--sa-accent),0.35);
    min-width: 2px;
    position: absolute;
    bottom: 6px;
    left: 12px;
    transition: width 0.3s;
}

.pxp-report__filters {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.pxp-report__filter {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px;
    border-radius: 12px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(26,26,30,0.75);
    color: rgba(var(--sa-accent),0.85);
}

.pxp-report__filter-text {
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.pxp-report__filter-value {
    font-size: 0.82rem;
    font-weight: 600;
    color: #ececec;
}

.pxp-report__filter-label {
    font-size: 0.68rem;
    color: rgba(var(--sa-text-muted),0.65);
}

.pxp-report__card {
    background: rgba(26,26,30,0.75);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
    padding: 18px 20px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.18);
}

.pxp-report__card-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
}

.pxp-report__metric-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 26px;
    height: 22px;
    padding: 0 6px;
    border-radius: 6px;
    font-size: 0.7rem;
    font-weight: 700;
    color: #4a3a12;
    background: rgba(var(--sa-accent),0.85);
}

.pxp-report__metric-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 700;
    color: #ececec;
}

.pxp-collecting {
    margin-bottom: 16px;
    padding: 14px 16px;
    border-radius: 10px;
    background: rgba(252,165,55,0.06);
    border: 1px solid rgba(252,165,55,0.18);
}

.pxp-collecting__head {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.8rem;
    color: rgba(230,200,150,0.9);
    margin-bottom: 10px;
}
.pxp-collecting__head .sa-icon { color: rgba(252,165,55,0.8); }

.pxp-collecting__track {
    display: flex;
    gap: 3px;
    height: 8px;
    border-radius: 5px;
    overflow: hidden;
}

.pxp-collecting__seg {
    height: 100%;
    border-radius: 3px;
}

.pxp-report__table-scroll {
    overflow-x: auto;
}

.pxp-report__table {
    min-width: 640px;
}

.pxp-report__variant-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 8px;
}

.pxp-report__baseline-chip,
.pxp-report__collecting-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: 8px;
    padding: 2px 7px;
    border-radius: 5px;
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    background: rgba(255,255,255,0.06);
    color: rgba(var(--sa-text-muted),0.75);
}

.pxp-report__table td .pxp-report__collecting-chip {
    margin-left: 0;
    text-transform: none;
    font-weight: 600;
    letter-spacing: 0;
}

.pxp-report__uplift--pos { color: #86e7a4; font-weight: 600; }
.pxp-report__uplift--neg { color: #f0a3a3; font-weight: 600; }

.pxp-report__prob {
    display: inline-flex;
    padding: 2px 8px;
    border-radius: 999px;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
}
.pxp-report__prob--good    { background: rgba(74,222,128,0.15); color: #86e7a4; }
.pxp-report__prob--bad     { background: rgba(239,68,68,0.15);  color: #f0a3a3; }
.pxp-report__prob--neutral { background: rgba(255,255,255,0.06); color: rgba(var(--sa-text),0.8); }

.pxp-report__total-row td {
    font-weight: 700;
    color: rgba(var(--sa-text),0.9);
    border-top: 1px solid rgba(255,255,255,0.1);
    border-bottom: none !important;
}

/* ── Engagement comparison table ─────────────────────────────────────── */
.pxp-engagement-table {
    min-width: 420px;
}

.pxp-engagement-table__metric {
    font-size: 0.8rem;
    color: rgba(var(--sa-text),0.8);
}

.pxp-engagement-table__target {
    font-size: 0.75rem;
    color: rgba(var(--sa-accent),0.7);
    font-variant-numeric: tabular-nums;
}

.pxp-engagement-table__cell {
    font-variant-numeric: tabular-nums;
    position: relative;
}

.pxp-engagement-table__winner {
    font-weight: 700;
    color: #f2f2f2;
}

.pxp-engagement-table__best-chip {
    display: inline-block;
    margin-left: 5px;
    padding: 1px 5px;
    border-radius: 4px;
    font-size: 0.62rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    background: rgba(74,222,128,0.18);
    color: #86e7a4;
    vertical-align: middle;
}

.pxp-target-pass {
    color: #86e7a4;
    margin-right: 4px;
    font-size: 0.8rem;
}

.pxp-target-fail {
    color: #f0a3a3;
    margin-right: 4px;
    font-size: 0.8rem;
}

/* ── Targets edit button ──────────────────────────────────────────────── */
.pxp-targets-edit-btn {
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 7px;
    padding: 5px 12px;
    color: rgba(var(--sa-text),0.7);
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
}

.pxp-targets-edit-btn:hover {
    background: rgba(255,255,255,0.1);
    color: rgba(var(--sa-text),0.9);
}

/* ── Targets inline editor ────────────────────────────────────────────── */
.pxp-targets-editor {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    padding: 14px 16px;
    margin-bottom: 16px;
}

.pxp-targets-editor__hint {
    font-size: 0.78rem;
    color: rgba(var(--sa-text-secondary),0.6);
    margin: 0 0 12px;
}

.pxp-targets-editor__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 10px;
    margin-bottom: 14px;
}

.pxp-targets-editor__field {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.pxp-targets-editor__label {
    font-size: 0.72rem;
    font-weight: 600;
    color: rgba(var(--sa-text-secondary),0.65);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.pxp-targets-editor__input-wrap {
    display: flex;
    align-items: center;
    gap: 5px;
}

.pxp-targets-editor__input {
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.14);
    border-radius: 6px;
    padding: 5px 8px;
    color: #f2f2f2;
    font-size: 0.8rem;
    width: 80px;
    outline: none;
    font-variant-numeric: tabular-nums;
}

.pxp-targets-editor__input:focus {
    border-color: rgba(255,255,255,0.28);
}

.pxp-targets-editor__unit {
    font-size: 0.75rem;
    color: rgba(var(--sa-text-muted),0.5);
}

.pxp-targets-editor__actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

/* ── Graph tabs + charts ─────────────────────────────────────────────────── */

.pxp-graph-tabs {
    display: flex;
    gap: 18px;
    margin-bottom: 14px;
    border-bottom: 1px solid rgba(255,255,255,0.08);
}

.pxp-graph-tab {
    appearance: none;
    border: none;
    background: transparent;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0 2px 10px;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(var(--sa-text-muted),0.7);
    border-bottom: 2px solid transparent;
    cursor: pointer;
}
.pxp-graph-tab .sa-icon { color: inherit; }
.pxp-graph-tab.--active {
    color: #e8d9b5;
    border-bottom-color: rgba(var(--sa-accent),0.85);
}

.pxp-graph {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.pxp-graph-scroll {
    overflow-x: auto;
}

.pxp-graph__svg {
    width: 100%;
    min-width: 560px;
    height: auto;
    display: block;
}

.pxp-graph__legend {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}

.pxp-graph__legend-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 0.76rem;
    color: rgba(var(--sa-text-secondary),0.85);
}

.pxp-graph__legend-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    flex-shrink: 0;
}

/* ── Traffic split panel ──────────────────────────────────────────────────── */
.pxp-split-panel {
    padding: 20px 24px;
    margin-bottom: 16px;
    background: rgba(26,26,30,0.75);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 14px;
}

.pxp-split-panel__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 14px;
}

.pxp-split-panel__title {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    font-weight: 600;
    color: #ececec;
}

.pxp-split-panel__total {
    font-size: 0.85rem;
    font-weight: 700;
    font-variant-numeric: tabular-nums;
    color: rgba(134,231,164,0.9);
}

.pxp-split-panel__total--bad {
    color: rgba(240,163,163,0.9);
}

.pxp-split-panel__rows {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.pxp-split-panel__row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.pxp-split-panel__label {
    flex: 1;
    font-size: 0.82rem;
    color: rgba(var(--sa-text),0.9);
}

.pxp-split-panel__input {
    width: 70px;
    margin: 0;
    text-align: right;
}

.pxp-split-panel__pct-sign {
    color: rgba(var(--sa-text-muted),0.7);
    font-size: 0.82rem;
}

.pxp-split-panel__hint {
    margin: 10px 0 0;
    font-size: 0.76rem;
    color: rgba(240,163,163,0.85);
}

.pxp-split-panel__actions {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-top: 14px;
}

/* ── URL split test panel ──────────────────────────────────────────────────── */
.pxp-url-split-panel {
    padding: 24px;
}

.pxp-url-split-variants {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.pxp-url-split-row {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 8px;
    padding: 14px 16px;
}

.pxp-url-split-row__meta {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 130px;
    flex-shrink: 0;
}

.pxp-url-split-row__label {
    font-weight: 600;
    font-size: 14px;
    color: rgba(255,255,255,0.9);
}

.pxp-url-split-row__label-input {
    font-weight: 600;
    font-size: 14px;
    width: 140px;
    margin: 0;
    flex-shrink: 0;
}

.pxp-url-split-row__control-note {
    flex: 1;
    font-size: 13px;
    color: rgba(var(--sa-text),0.7);
    margin: 0;
}

.pxp-url-split-row__control-note code {
    color: rgba(var(--sa-text),0.9);
    font-family: monospace;
    font-size: 12px;
}

.pxp-url-split-row__input {
    flex: 1;
    margin: 0;
}

/* ── Test type tag in list ─────────────────────────────────────────────────── */
.sa-event-row__tag {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.03em;
    color: rgba(var(--sa-text),0.7);
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 4px;
    padding: 2px 7px;
    text-transform: uppercase;
}

/* ── Create form: test type selector ──────────────────────────────────────── */
.sa-event-form__type-row {
    display: flex;
    gap: 10px;
    margin: 4px 0;
}

.sa-event-form__type-opt {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1.5px solid rgba(255,255,255,0.1);
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    color: rgba(var(--sa-text),0.8);
    background: rgba(255,255,255,0.03);
    transition: border-color 0.15s, background 0.15s;
    user-select: none;
}

.sa-event-form__type-opt input[type="radio"] {
    display: none;
}

.sa-event-form__type-opt--active {
    border-color: rgba(var(--sa-accent),0.7);
    background: rgba(var(--sa-accent),0.08);
    color: rgba(255,255,255,0.95);
}

.sa-event-form__type-hint {
    font-size: 11px;
    font-weight: 400;
    color: rgba(var(--sa-text-secondary),0.6);
}

.sa-event-form__type-opt--active .sa-event-form__type-hint {
    color: rgba(var(--sa-text-secondary),0.8);
}

/* ── Create form: whole-site wildcard toggle ──────────────────────────────── */
.sa-event-form__checkbox {
    display: flex;
    align-items: center;
    gap: 7px;
    margin: -2px 0 4px;
    font-size: 12.5px;
    font-weight: 500;
    color: rgba(var(--sa-text),0.75);
    cursor: pointer;
    user-select: none;
}

/* ── Cohort retention matrix ─────────────────────────────────────────────── */
.sa-cohorts-wrap {
    width: 100%;
}

.sa-cohort-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.82rem;
    white-space: nowrap;
}

.sa-cohort-table th,
.sa-cohort-table td {
    padding: 6px 10px;
    border: 1px solid rgba(255,255,255,0.06);
    text-align: center;
    color: rgba(220,230,245,0.85);
}

.sa-cohort-table th {
    background: rgba(255,255,255,0.04);
    font-weight: 600;
    font-size: 0.78rem;
    color: rgba(160,174,192,0.8);
}

.sa-cohort-table__week {
    text-align: left !important;
    min-width: 90px;
}

.sa-cohort-table__size {
    text-align: right !important;
    color: rgba(160,174,192,0.7);
    min-width: 60px;
}

.sa-cohort-table__cell {
    min-width: 54px;
    border-radius: 0;
    font-size: 0.8rem;
    font-variant-numeric: tabular-nums;
}

.sa-cohort-legend {
    margin-top: 12px;
    font-size: 0.78rem;
    color: rgba(160,174,192,0.6);
}

.sa-panel__sub {
    font-size: 0.8rem;
    color: rgba(160,174,192,0.6);
    margin: 0 0 14px;
    line-height: 1.5;
}

/* ── Analytics alerts ────────────────────────────────────────────────────── */
.sa-alerts-grid {
    display: grid;
    grid-template-columns: 1fr 400px;
    gap: 20px;
    align-items: start;
}

@media (max-width: 960px) {
    .sa-alerts-grid {
        grid-template-columns: 1fr;
    }
}

.sa-alert-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sa-alert-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    padding: 12px 14px;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 8px;
}

.sa-alert-edit-form {
    width: 100%;
    border-top: 1px solid rgba(255,255,255,0.07);
    padding-top: 14px;
    margin-top: 4px;
}

.sa-alert-edit-form__grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 12px;
}

.sa-alert-edit-form__actions {
    display: flex;
    gap: 8px;
    margin-top: 12px;
}

.sa-alert-row--disabled {
    opacity: 0.5;
}

.sa-alert-row__meta {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
}

.sa-alert-row__name {
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(220,230,245,0.9);
}

.sa-alert-row__rule {
    font-size: 0.78rem;
    color: rgba(160,174,192,0.7);
}

.sa-alert-row__last {
    font-size: 0.75rem;
    color: rgba(160,174,192,0.45);
}

.sa-alert-row__actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.sa-alert-form {
    position: sticky;
    top: 70px;
}

.sa-alert-form__fields {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.sa-form-label {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(160,174,192,0.8);
}

.sa-form-select,
.sa-form-input {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 6px;
    padding: 7px 10px;
    color: rgba(220,230,245,0.9);
    font-size: 0.85rem;
    outline: none;
    width: 100%;
}

.sa-form-select:focus,
.sa-form-input:focus {
    border-color: rgba(var(--sa-accent),0.5);
}

.sa-form-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.83rem;
    color: rgba(200,210,225,0.75);
    cursor: pointer;
}

.sa-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    border-radius: 6px;
    border: 1px solid rgba(var(--sa-accent),0.4);
    background: rgba(var(--sa-accent),0.12);
    color: rgba(var(--sa-accent),0.95);
    font-size: 0.83rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s;
}

.sa-btn:hover:not(:disabled) {
    background: rgba(var(--sa-accent),0.22);
}

.sa-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.sa-btn--sm {
    padding: 5px 10px;
    font-size: 0.77rem;
}

.sa-btn--ghost {
    border-color: rgba(180,180,180,0.15);
    background: transparent;
    color: rgba(var(--sa-text-secondary),0.5);
}

.sa-btn--ghost:hover:not(:disabled) {
    background: rgba(180,180,180,0.08);
    color: rgba(var(--sa-text-secondary),0.75);
}

.sa-btn--danger {
    border-color: rgba(239,68,68,0.35);
    background: rgba(239,68,68,0.08);
    color: rgba(239,68,68,0.85);
}

.sa-btn--danger:hover:not(:disabled) {
    background: rgba(239,68,68,0.16);
}

/* ── Attribution comparison panel ───────────────────────────────────────── */
.sa-attr-comparison {
    grid-column: 1 / -1;
}

.sa-attr-cols {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
}

@media (max-width: 700px) {
    .sa-attr-cols {
        grid-template-columns: 1fr;
    }
}

.sa-attr-col {
    min-width: 0;
}

/* ── Consent impact estimator ────────────────────────────────────────────── */
.sa-consent-impact {
    grid-column: 1 / -1;
}

.sa-ci-kpis {
    display: flex;
    gap: 28px;
    flex-wrap: wrap;
    margin-bottom: 18px;
}

.sa-ci-kpi {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 120px;
}

.sa-ci-kpi__label {
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(160,174,192,0.7);
}

.sa-ci-kpi__value {
    font-size: 1.4rem;
    font-weight: 700;
    color: rgba(220,230,245,0.95);
    font-variant-numeric: tabular-nums;
}

.sa-ci-kpi__note {
    font-size: 0.75rem;
    color: rgba(239,68,68,0.65);
}

.sa-ci-bar-wrap {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.sa-ci-bar {
    display: flex;
    height: 18px;
    border-radius: 4px;
    overflow: hidden;
    background: rgba(255,255,255,0.05);
}

.sa-ci-bar__observed {
    background: rgba(74,222,128,0.55);
    transition: width 0.4s ease;
}

.sa-ci-bar__hidden {
    background: rgba(239,68,68,0.35);
    transition: width 0.4s ease;
}

.sa-ci-bar-labels {
    display: flex;
    justify-content: space-between;
    font-size: 0.74rem;
    color: rgba(160,174,192,0.5);
}

/* ── Segment filter bar ──────────────────────────────────────────────────── */
.sa-seg-filter {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    padding: 10px 0 2px;
}

.sa-seg-filter__label {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(160,174,192,0.55);
    white-space: nowrap;
}

.sa-seg-filter__select,
.sa-seg-filter__country {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 5px;
    padding: 5px 8px;
    color: rgba(210,220,235,0.85);
    font-size: 0.78rem;
    outline: none;
    cursor: pointer;
}

.sa-seg-filter__country {
    width: 90px;
    text-transform: uppercase;
}

.sa-seg-filter__select:focus,
.sa-seg-filter__country:focus {
    border-color: rgba(var(--sa-accent),0.4);
}

.sa-seg-filter__clear {
    padding: 4px 10px;
    border-radius: 5px;
    border: 1px solid rgba(239,68,68,0.3);
    background: rgba(239,68,68,0.07);
    color: rgba(239,68,68,0.8);
    font-size: 0.76rem;
    font-weight: 600;
    cursor: pointer;
}

.sa-seg-filter__clear:hover {
    background: rgba(239,68,68,0.14);
}

/* ── Ad Spend sync bar ───────────────────────────────────────────────────── */
.sa-as-sync-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 4px;
}

.sa-as-sync-btn {
    padding: 5px 12px;
    border-radius: 5px;
    border: 1px solid rgba(var(--sa-accent),0.35);
    background: rgba(var(--sa-accent),0.08);
    color: rgba(var(--sa-accent),0.85);
    font-size: 0.78rem;
    font-weight: 600;
    cursor: pointer;
}

.sa-as-sync-btn:hover:not(:disabled) {
    background: rgba(var(--sa-accent),0.16);
}

.sa-as-sync-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.sa-as-sync-msg {
    font-size: 0.78rem;
    color: rgba(160,174,192,0.65);
}


/* ── Saved Reports (My Reports list page) ────────────────────────────────── */

.sa-reports-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 16px;
}

.sa-reports-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 14px;
}

.sa-report-card {
    background: rgba(26,26,30,0.75);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    padding: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 7px;
    transition: border-color .15s, box-shadow .15s;
    min-height: 200px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

.sa-report-card:hover {
    border-color: rgba(var(--sa-accent),0.35);
    box-shadow: 0 4px 18px rgba(0,0,0,0.28);
}

.sa-report-card__type {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.67rem;
    color: rgba(var(--sa-text-dim),0.6);
    font-weight: 700;
    letter-spacing: .07em;
    text-transform: uppercase;
}

.sa-report-card__name {
    font-size: 0.92rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.9);
    line-height: 1.3;
}

.sa-report-card__meta {
    font-size: 0.74rem;
    color: rgba(var(--sa-text-muted),0.6);
}

.sa-report-card__preview {
    flex: 1;
    display: flex;
    border-radius: 6px;
    overflow: hidden;
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.06);
    min-height: 72px;
    margin-top: 4px;
}

.sa-report-card__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2px;
}

.sa-report-card__date {
    font-size: 0.70rem;
    color: rgba(var(--sa-text-dim),0.5);
}

.sa-report-card__actions {
    display: flex;
    gap: 5px;
}

.sa-report-card__action-btn {
    font-size: 0.70rem;
    padding: 3px 8px;
    border-radius: 4px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.04);
    color: rgba(var(--sa-text-muted),0.7);
    cursor: pointer;
    transition: background .12s, color .12s;
}

.sa-report-card__action-btn:hover {
    background: rgba(255,255,255,0.09);
    color: rgba(var(--sa-text),0.9);
}

.sa-report-card__action-btn--del {
    border-color: rgba(220,80,80,0.2);
    color: rgba(220,100,100,0.65);
}

.sa-report-card__action-btn--del:hover {
    background: rgba(220,80,80,0.08);
    color: rgba(245,140,140,0.9);
}

.sa-report-card--new {
    border-style: dashed;
    border-color: rgba(255,255,255,0.1);
    background: rgba(255,255,255,0.015);
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 5px;
}

.sa-report-card--new:hover {
    border-color: rgba(var(--sa-accent),0.3);
    background: rgba(var(--sa-accent),0.04);
}

.sa-report-card--new__plus {
    font-size: 1.8rem;
    line-height: 1;
    color: rgba(var(--sa-text-muted),0.4);
}

.sa-report-card--new:hover .sa-report-card--new__plus {
    color: rgba(var(--sa-accent),0.7);
}

.sa-report-card--new__label {
    font-size: 0.84rem;
    font-weight: 600;
    color: rgba(var(--sa-text-muted),0.6);
}

.sa-report-card--new:hover .sa-report-card--new__label {
    color: rgba(var(--sa-accent),0.85);
}

.sa-reports-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 20px;
    text-align: center;
}

.sa-reports-empty__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 14px;
    color: rgba(var(--sa-accent),0.45);
}

.sa-reports-empty__title {
    font-size: 1rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.85);
    margin-bottom: 6px;
}

.sa-reports-empty__sub {
    font-size: 0.82rem;
    color: rgba(var(--sa-text-muted),0.6);
    max-width: 340px;
    line-height: 1.5;
}

/* ── sa-btn--primary (gold filled) ──────────────────────────────────────── */
.sa-btn--primary {
    border-color: rgba(var(--sa-accent),0.55);
    background: rgba(var(--sa-accent),0.18);
    color: rgba(var(--sa-accent),1);
}

.sa-btn--primary:hover:not(:disabled) {
    background: rgba(var(--sa-accent),0.28);
}

/* ── Report Builder ──────────────────────────────────────────────────────── */

/* Back link inside StickyPageTitle */
.sa-rb-back {
    background: none;
    border: none;
    color: rgba(var(--sa-text-muted),0.65);
    cursor: pointer;
    font-size: 0.82rem;
    font-weight: 500;
    padding: 0;
    white-space: nowrap;
    transition: color .12s;
}
.sa-rb-back:hover { color: rgba(var(--sa-text),0.9); }

/* Report name input inside the sticky title */
.sa-rb-name-input {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 0.88rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.9);
    outline: none;
    width: 280px;
    transition: border-color .15s;
}
.sa-rb-name-input::placeholder { color: rgba(var(--sa-text-dim),0.45); font-weight: 400; }
.sa-rb-name-input:focus { border-color: rgba(var(--sa-accent),0.4); }

/* Two-column page grid */
.sa-rb-grid {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 16px;
    align-items: start;
}

@media (max-width: 860px) {
    .sa-rb-grid { grid-template-columns: 1fr; }
}

/* Config column: panels stack naturally, sticky on desktop */
.sa-rb-config-col {
    display: flex;
    flex-direction: column;
    gap: 12px;
    position: sticky;
    top: 70px;
}

/* Preview column: panels stack naturally */
.sa-rb-preview-col {
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 0;
}

/* Save / cancel actions block */
.sa-rb-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

/* Chart type grid */
.sa-rb-chart-types {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 4px;
}

.sa-rb-ct-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px 4px 7px;
    border-radius: 6px;
    border: 1px solid rgba(255,255,255,0.07);
    background: rgba(255,255,255,0.03);
    color: rgba(var(--sa-text-muted),0.65);
    cursor: pointer;
    font-size: 0.63rem;
    font-weight: 600;
    letter-spacing: .02em;
    transition: all .12s;
}
.sa-rb-ct-btn:hover {
    background: rgba(255,255,255,0.06);
    color: rgba(var(--sa-text),0.88);
    border-color: rgba(255,255,255,0.12);
}
.sa-rb-ct-btn--active {
    border-color: rgba(var(--sa-accent),0.45);
    background: rgba(var(--sa-accent),0.1);
    color: rgba(var(--sa-accent),0.95);
}
.sa-rb-ct-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
}

/* Metrics & breakdown lists */
.sa-rb-metric-list,
.sa-rb-breakdown-list {
    display: flex;
    flex-direction: column;
    gap: 1px;
}
.sa-rb-metric-item,
.sa-rb-breakdown-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 5px 4px;
    border-radius: 5px;
    cursor: pointer;
    transition: background .1s;
}
.sa-rb-metric-item:hover,
.sa-rb-breakdown-item:hover { background: rgba(255,255,255,0.04); }

.sa-rb-check {
    width: 15px;
    height: 15px;
    border-radius: 3px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(255,255,255,0.03);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.6rem;
    font-weight: 700;
    color: rgba(var(--sa-accent),0.9);
    flex-shrink: 0;
    transition: all .1s;
}
.sa-rb-check--on {
    background: rgba(var(--sa-accent),0.15);
    border-color: rgba(var(--sa-accent),0.5);
}
.sa-rb-radio {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(255,255,255,0.03);
    flex-shrink: 0;
    position: relative;
    transition: all .1s;
}
.sa-rb-radio--sel {
    border-color: rgba(var(--sa-accent),0.55);
    background: rgba(var(--sa-accent),0.1);
}
.sa-rb-radio--sel::after {
    content: "";
    position: absolute;
    inset: 3px;
    border-radius: 50%;
    background: rgba(var(--sa-accent),0.9);
}
.sa-rb-metric-label {
    font-size: 0.81rem;
    color: rgba(var(--sa-text),0.75);
}

/* Filters */
.sa-rb-filter-rows { display: flex; flex-direction: column; gap: 6px; margin-bottom: 8px; }
.sa-rb-filter-row  { display: flex; align-items: center; gap: 4px; }
.sa-rb-filter-remove {
    background: none;
    border: none;
    color: rgba(var(--sa-text-dim),0.5);
    cursor: pointer;
    font-size: 1rem;
    padding: 0 2px;
    line-height: 1;
    transition: color .1s;
}
.sa-rb-filter-remove:hover { color: rgba(220,100,100,0.75); }
.sa-rb-add-filter {
    font-size: 0.76rem;
    color: rgba(var(--sa-text-muted),0.55);
    background: none;
    border: 1px dashed rgba(255,255,255,0.09);
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    width: 100%;
    text-align: left;
    transition: color .12s, border-color .12s;
}
.sa-rb-add-filter:hover {
    color: rgba(var(--sa-accent),0.8);
    border-color: rgba(var(--sa-accent),0.25);
}

/* KPI strip above the main chart */
.sa-rb-kpi-strip {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}
.sa-rb-kpi {
    background: rgba(26,26,30,0.75);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    padding: 12px 16px;
    min-width: 110px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.18);
}
.sa-rb-kpi__label {
    font-size: 0.63rem;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-dim),0.6);
    font-weight: 700;
}
.sa-rb-kpi__value {
    font-size: 1.45rem;
    font-weight: 700;
    color: rgba(var(--sa-text),0.92);
    margin-top: 4px;
    letter-spacing: -.01em;
}

/* KPI grid (kpi chart type) */
.sa-rb-kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 12px;
}

/* Horizontal bar rows */
.sa-rb-bar-chart { display: flex; flex-direction: column; gap: 7px; padding: 4px 0; }
.sa-rb-bar-row   { display: flex; align-items: center; gap: 8px; }
.sa-rb-bar-label {
    font-size: 0.77rem;
    color: rgba(var(--sa-text-muted),0.7);
    width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}
.sa-rb-bar-track {
    flex: 1;
    height: 5px;
    border-radius: 3px;
    background: rgba(255,255,255,0.07);
    overflow: hidden;
}
.sa-rb-bar-fill {
    height: 100%;
    border-radius: 3px;
    background: rgba(var(--sa-accent),0.75);
    transition: width .35s;
}
.sa-rb-bar-val {
    font-size: 0.77rem;
    color: rgba(var(--sa-text-muted),0.7);
    width: 54px;
    text-align: right;
    flex-shrink: 0;
}

/* Donut */
.sa-rb-donut-wrap   { display: flex; align-items: center; gap: 28px; padding: 8px 0; flex-wrap: wrap; }
.sa-rb-donut-legend { display: flex; flex-direction: column; gap: 8px; min-width: 220px; }
.sa-rb-donut-row    { display: flex; align-items: center; gap: 8px; }
.sa-rb-donut-dot    { width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0; }
.sa-rb-donut-label  { font-size: 0.81rem; color: rgba(var(--sa-text),0.85); flex: 1; min-width: 80px; }
.sa-rb-donut-count  { font-size: 0.77rem; color: rgba(var(--sa-text-muted),0.6); width: 52px; text-align: right; flex-shrink: 0; }
.sa-rb-donut-pct    { font-size: 0.77rem; font-weight: 700; color: rgba(var(--sa-accent),0.9); width: 38px; text-align: right; flex-shrink: 0; }

.sa-rb-no-data { font-size: 0.82rem; color: rgba(var(--sa-text-dim),0.5); padding: 24px 0; text-align: center; }

/* ── Template library ────────────────────────────────────────────────────── */

.sa-tpl-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;
}

.sa-tpl-body {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.sa-tpl-category__label {
    font-size: 0.67rem;
    font-weight: 700;
    letter-spacing: .09em;
    text-transform: uppercase;
    margin-bottom: 8px;
}

.sa-tpl-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
}

.sa-tpl-card {
    background: rgba(255,255,255,0.025);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 10px;
    padding: 14px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 5px;
    transition: background .12s, border-color .12s;
}

.sa-tpl-card:hover {
    background: rgba(var(--sa-accent),0.06);
    border-color: rgba(var(--sa-accent),0.25);
}

.sa-tpl-card__header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 2px;
}

.sa-tpl-card__icon {
    display: flex;
    align-items: center;
    opacity: 0.85;
}

.sa-tpl-card__cat {
    font-size: 0.63rem;
    font-weight: 700;
    letter-spacing: .07em;
    text-transform: uppercase;
}

.sa-tpl-card__name {
    font-size: 0.85rem;
    font-weight: 600;
    color: rgba(var(--sa-text),0.9);
    line-height: 1.25;
}

.sa-tpl-card__desc {
    font-size: 0.75rem;
    color: rgba(var(--sa-text-muted),0.6);
    line-height: 1.45;
}

.sa-tpl-card__meta {
    font-size: 0.70rem;
    color: rgba(var(--sa-text-dim),0.5);
    margin-top: 2px;
}

.sa-tpl-card__use {
    font-size: 0.73rem;
    font-weight: 600;
    color: rgba(var(--sa-accent),0.7);
    margin-top: 4px;
    opacity: 0;
    transition: opacity .12s;
}

.sa-tpl-card:hover .sa-tpl-card__use {
    opacity: 1;
}

/* ── Template library controls (search + tabs) ─────────────────────────── */

.sa-tpl-controls {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 14px;
    flex-wrap: wrap;
}

.sa-tpl-tabs {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    flex: 1;
}

.sa-tpl-tab {
    background: transparent;
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 0.75rem;
    font-weight: 500;
    color: rgba(var(--sa-text-muted),0.65);
    cursor: pointer;
    transition: background .12s, border-color .12s, color .12s;
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
}

.sa-tpl-tab:hover {
    background: rgba(255,255,255,0.04);
    color: rgba(var(--sa-text),0.85);
    border-color: rgba(255,255,255,0.14);
}

.sa-tpl-tab--active {
    background: rgba(var(--sa-accent),0.12);
    border-color: rgba(var(--sa-accent),0.35);
    color: rgba(var(--sa-accent),0.9);
}

.sa-tpl-tab__count {
    font-size: 0.65rem;
    background: rgba(255,255,255,0.07);
    border-radius: 20px;
    padding: 1px 5px;
    color: rgba(var(--sa-text-dim),0.6);
}

.sa-tpl-tab--active .sa-tpl-tab__count {
    background: rgba(var(--sa-accent),0.18);
    color: rgba(var(--sa-accent),0.7);
}

.sa-tpl-search {
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 6px;
    padding: 5px 10px;
    font-size: 0.78rem;
    color: rgba(var(--sa-text),0.85);
    outline: none;
    width: 180px;
    transition: border-color .12s, background .12s;
}

.sa-tpl-search::placeholder {
    color: rgba(var(--sa-text-dim),0.45);
}

.sa-tpl-search:focus {
    border-color: rgba(var(--sa-accent),0.35);
    background: rgba(var(--sa-accent),0.04);
}

/* ── Report View (sa-rv-*) ──────────────────────────────────────────────── */

.sa-rv-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 16px;
}

.sa-rv-meta {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}

.sa-rv-meta__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
}

.sa-rv-meta__updated {
    font-size: 0.72rem;
    color: rgba(var(--sa-text-dim),0.5);
}

.sa-rv-chip {
    display: inline-flex;
    align-items: center;
    background: rgba(var(--sa-accent),0.1);
    border: 1px solid rgba(var(--sa-accent),0.22);
    border-radius: 20px;
    padding: 3px 9px;
    font-size: 0.72rem;
    font-weight: 500;
    color: rgba(var(--sa-accent),0.85);
    white-space: nowrap;
}

.sa-rv-chip--dim {
    background: rgba(255,255,255,0.04);
    border-color: rgba(255,255,255,0.08);
    color: rgba(var(--sa-text-muted),0.65);
}

.sa-rv-chip--filter {
    background: rgba(99,179,237,0.08);
    border-color: rgba(99,179,237,0.2);
    color: rgba(99,179,237,0.75);
}

.sa-rv-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-shrink: 0;
}

.sa-rv-kpi-strip {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 10px;
    margin-bottom: 16px;
}

.sa-rv-kpi {
    background: rgba(26,26,30,0.75);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 10px;
    padding: 14px 16px;
}

.sa-rv-kpi__label {
    font-size: 0.63rem;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-dim),0.6);
    margin-bottom: 6px;
}

.sa-rv-kpi__value {
    font-size: 1.55rem;
    font-weight: 700;
    color: rgba(var(--sa-text),0.92);
    letter-spacing: -.01em;
}

.sa-rv-bar-chart {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.sa-rv-bar-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.sa-rv-bar-label {
    width: 120px;
    font-size: 0.78rem;
    color: rgba(var(--sa-text-muted),0.75);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 0;
}

.sa-rv-bar-track {
    flex: 1;
    height: 7px;
    background: rgba(255,255,255,0.06);
    border-radius: 4px;
    overflow: hidden;
}

.sa-rv-bar-fill {
    height: 100%;
    background: rgba(var(--sa-accent),0.7);
    border-radius: 4px;
    transition: width .3s ease;
}

.sa-rv-bar-val {
    width: 52px;
    text-align: right;
    font-size: 0.78rem;
    font-variant-numeric: tabular-nums;
    color: rgba(var(--sa-text),0.75);
    flex-shrink: 0;
}

/* ── Report Builder — metric groups + ad notice ─────────────────────────── */

.sa-rb-metric-group-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.65rem;
    font-weight: 700;
    letter-spacing: .09em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-dim),0.5);
    padding: 4px 0 2px;
    margin-bottom: 2px;
    border-top: 1px solid rgba(255,255,255,0.05);
}

.sa-rb-metric-group-label:first-of-type {
    border-top: none;
    padding-top: 0;
}

.sa-rb-metric-group-badge {
    font-size: 0.58rem;
    font-weight: 500;
    letter-spacing: 0;
    text-transform: none;
    background: rgba(239,68,68,0.1);
    border: 1px solid rgba(239,68,68,0.2);
    color: rgba(239,68,68,0.65);
    border-radius: 20px;
    padding: 1px 5px;
}

.sa-rb-ad-notice {
    background: rgba(239,68,68,0.06);
    border: 1px solid rgba(239,68,68,0.18);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 0.78rem;
    color: rgba(var(--sa-text),0.7);
    margin-bottom: 4px;
}

.sa-rb-ad-notice strong {
    color: rgba(239,68,68,0.8);
    font-weight: 600;
}

/* ── Report builder hint text ───────────────────────────────────────────── */

.sa-rb-hint {
    font-size: 0.73rem;
    color: rgba(var(--sa-text-dim),0.55);
    line-height: 1.5;
    margin: 0 0 10px;
}

/* ── Conversion Attribution table ─────────────────────────────────────────── */

.sa-attr-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.82rem;
}

.sa-attr-th {
    text-align: left;
    padding: 8px 12px;
    font-size: 0.72rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(var(--sa-text-dim),0.6);
    border-bottom: 1px solid rgba(255,255,255,0.07);
    white-space: nowrap;
}

.sa-attr-td {
    padding: 10px 12px;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    color: rgba(var(--sa-text),0.85);
    vertical-align: middle;
}

.sa-attr-row:last-child .sa-attr-td {
    border-bottom: none;
}

.sa-attr-row:hover .sa-attr-td {
    background: rgba(255,255,255,0.02);
}

/* ── Small action button variant ─────────────────────────────────────────── */

.sa-btn--sm {
    padding: 3px 10px;
    font-size: 0.75rem;
}

/* ── Ad Spend toolbar (currency picker + sync) ───────────────────────────── */

.sa-as-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.sa-currency-picker {
    display: flex;
    gap: 4px;
    background: rgba(255,255,255,0.04);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 8px;
    padding: 3px;
}

.sa-currency-btn {
    padding: 4px 11px;
    border-radius: 5px;
    background: transparent;
    border: none;
    color: rgba(var(--sa-text-secondary),0.6);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    letter-spacing: 0.02em;
}

.sa-currency-btn:hover {
    background: rgba(255,255,255,0.06);
    color: rgba(var(--sa-text),0.9);
}

.sa-currency-btn--active {
    background: rgba(var(--sa-accent),0.18);
    color: rgba(var(--sa-accent),1);
}

/* ── Forms dashboard ──────────────────────────────────────────────────────────── */

.sa-form-id {
    display: block;
    font-size: 13px;
    color: rgba(210,210,220,0.9);
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 280px;
}

.sa-table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

@media (max-width: 680px) {
    .sa-form-id { max-width: 160px; }
}

.sa-rage__detail {
    max-width: 220px;
    line-height: 1.4;
}
.sa-rage__id {
    display: block;
    font-size: 11px;
    font-family: monospace;
    color: rgba(var(--sa-accent),0.9);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}
.sa-rage__cls {
    display: block;
    font-size: 11px;
    font-family: monospace;
    color: rgba(100,210,160,0.8);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
}
.sa-rage__none {
    color: rgba(120,120,140,0.5);
    font-size: 12px;
}

.sa-form-action {
    display: block;
    font-size: 11px;
    color: rgba(var(--sa-text-muted),0.6);
    margin-top: 2px;
}

/* ── Forms page grid ──────────────────────────────────────────────────────────── */

.sa-forms-grid {
    display: grid;
    gap: 14px;
    margin-bottom: 14px;
    min-width: 0;
}

.sa-forms-grid > * {
    min-width: 0;
    overflow: hidden;
}

.sa-forms-grid--main {
    grid-template-columns: 3fr 2fr;
}

.sa-forms-grid--bottom {
    grid-template-columns: repeat(3, 1fr);
}

.sa-forms-grid--insights {
    grid-template-columns: 3fr 2fr;
}

.sa-forms-grid--acq {
    grid-template-columns: 3fr 2fr;
}

@media (max-width: 1100px) {
    .sa-forms-grid--main     { grid-template-columns: 1fr; }
    .sa-forms-grid--bottom   { grid-template-columns: 1fr 1fr; }
    .sa-forms-grid--insights { grid-template-columns: 1fr; }
    .sa-forms-grid--acq      { grid-template-columns: 1fr; }
}

@media (max-width: 680px) {
    .sa-forms-grid--main     { grid-template-columns: 1fr; }
    .sa-forms-grid--bottom   { grid-template-columns: 1fr; }
    .sa-forms-grid--insights { grid-template-columns: 1fr; }
    .sa-forms-grid--acq      { grid-template-columns: 1fr; }
    .sa-forms-grid { gap: 10px; margin-bottom: 10px; }
}

.sa-section-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 24px 0 4px;
    color: rgba(var(--sa-text-muted),0.6);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}
.sa-section-divider::before,
.sa-section-divider::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(255,255,255,0.07);
}

.sa-field-name {
    font-family: monospace;
    font-size: 12px;
    color: rgba(var(--sa-accent),0.9);
    background: rgba(var(--sa-accent),0.08);
    padding: 1px 5px;
    border-radius: 3px;
}

.sa-error-type {
    display: inline-block;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
}
.sa-error-type--validation {
    color: rgba(234,179,8,0.95);
    background: rgba(234,179,8,0.1);
}
.sa-error-type--network {
    color: rgba(239,68,68,0.95);
    background: rgba(239,68,68,0.1);
}
.sa-error-type--server {
    color: rgba(249,115,22,0.95);
    background: rgba(249,115,22,0.1);
}

.sa-muted {
    color: rgba(120,120,140,0.5);
    font-size: 12px;
}

.sa-http-desc {
    display: block;
    font-size: 11px;
    color: rgba(var(--sa-text-muted),0.65);
    margin-top: 2px;
    line-height: 1.3;
}

.sa-panel__desc {
    font-size: 12px;
    color: rgba(var(--sa-text-muted),0.65);
    margin: -4px 0 12px;
}

.sa-table__page {
    font-size: 11px;
    color: rgba(var(--sa-text-muted),0.7);
    max-width: 280px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.sa-empty {
    color: rgba(var(--sa-text-muted),0.6);
    font-size: 13px;
    padding: 32px 0;
    text-align: center;
}

.sa-loading {
    color: rgba(var(--sa-text-muted),0.6);
    font-size: 13px;
    padding: 32px 0;
    text-align: center;
}

/* ── Auto-collected / enhanced measurement block ──────────────────────────────── */

.sa-enhanced-block {
    background: linear-gradient(135deg, rgba(var(--sa-accent),0.08) 0%, rgba(16,185,129,0.05) 100%);
    border: 1px solid rgba(var(--sa-accent),0.2);
    border-radius: 12px;
    padding: 18px 20px 16px;
    margin-bottom: 24px;
}

.sa-enhanced-block__head {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 14px;
}

.sa-enhanced-block__sparkle {
    font-size: 18px;
    line-height: 1;
    color: rgba(var(--sa-accent),0.9);
    flex-shrink: 0;
    margin-top: 1px;
}

.sa-enhanced-block__titles {
    flex: 1;
    min-width: 0;
}

.sa-enhanced-block__title {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: rgba(220,220,230,0.95);
    margin-bottom: 3px;
}

.sa-enhanced-block__sub {
    display: block;
    font-size: 11.5px;
    color: rgba(var(--sa-text-muted),0.7);
    line-height: 1.4;
}

.sa-enhanced-block__badge {
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    color: rgba(var(--sa-accent),0.9);
    background: rgba(var(--sa-accent),0.12);
    border: 1px solid rgba(var(--sa-accent),0.25);
    border-radius: 4px;
    padding: 2px 7px;
    align-self: center;
}

.sa-enhanced-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.sa-auto-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px 4px 7px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 20px;
    font-size: 12px;
    color: rgba(var(--sa-text),0.9);
    white-space: nowrap;
    transition: background 0.15s, border-color 0.15s;
    cursor: default;
}

.sa-auto-chip:hover {
    background: rgba(255,255,255,0.08);
    border-color: rgba(255,255,255,0.16);
}

.sa-auto-chip--dim {
    opacity: 0.45;
}

.sa-auto-chip--dim:hover {
    opacity: 0.65;
}

.sa-auto-chip--more {
    cursor: pointer;
    color: rgba(var(--sa-accent),0.9);
    border-color: rgba(var(--sa-accent),0.25);
    background: rgba(var(--sa-accent),0.07);
    font-weight: 500;
}

.sa-auto-chip--more:hover {
    background: rgba(var(--sa-accent),0.14);
    border-color: rgba(var(--sa-accent),0.4);
}

.sa-auto-chip__icon {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.sa-auto-chip__label {
    font-size: 12px;
}

.sa-auto-chip__count {
    font-size: 11px;
    font-weight: 600;
    color: rgba(160,160,175,0.8);
    margin-left: 1px;
}

.sa-panel__head--mt {
    margin-top: 8px;
}

/* ── Performance dashboard ────────────────────────────────────────────── */
.sa-perf-cwv-row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    margin-bottom: 14px;
}
.sa-perf-cwv-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-top-width: 3px;
    border-radius: 8px;
    padding: 18px 20px 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.sa-perf-cwv-card__label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(180,180,200,0.6);
}
.sa-perf-cwv-card__value {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -0.02em;
}
.sa-perf-cwv-card__rating {
    font-size: 12px;
    font-weight: 600;
}
.sa-perf-cwv-card__desc {
    margin-top: 6px;
    font-size: 11px;
    color: rgba(var(--sa-text-muted),0.6);
    line-height: 1.4;
}
.sa-perf-timing-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    margin-bottom: 14px;
}
.sa-perf-timing-card {
    background: rgba(255,255,255,0.02);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 6px;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.sa-perf-timing-card__label {
    font-size: 13px;
    font-weight: 700;
    color: rgba(200,200,220,0.85);
}
.sa-perf-timing-card__sub {
    font-size: 10px;
    color: rgba(var(--sa-text-muted),0.55);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.sa-perf-timing-card__value {
    margin-top: 4px;
    font-size: 15px;
    font-weight: 600;
}
.sa-perf-rating-wrap {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.sa-perf-rating-bar {
    display: flex;
    height: 10px;
    border-radius: 5px;
    overflow: hidden;
    background: rgba(255,255,255,0.06);
}
.sa-perf-rating-bar__seg { height: 100%; transition: width 0.3s; }
.sa-perf-rating-bar__seg--good { background: rgba(34,197,94,0.75); }
.sa-perf-rating-bar__seg--ni   { background: rgba(234,179,8,0.75); }
.sa-perf-rating-bar__seg--poor { background: rgba(239,68,68,0.75); }
.sa-perf-rating-legend {
    display: flex;
    gap: 20px;
    font-size: 12px;
    color: rgba(160,160,180,0.7);
}
.sa-perf-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
    vertical-align: middle;
}
.sa-perf-dot--good { background: rgba(34,197,94,0.75); }
.sa-perf-dot--ni   { background: rgba(234,179,8,0.75); }
.sa-perf-dot--poor { background: rgba(239,68,68,0.75); }
.sa-perf-empty {
    padding: 40px 24px;
    text-align: center;
    color: rgba(160,160,180,0.7);
}
.sa-perf-empty h3 { margin: 0 0 10px; color: rgba(200,200,220,0.8); }
.sa-perf-empty p  { margin: 0 0 8px; font-size: 14px; }
.sa-table__sortable { user-select: none; }
.sa-table__sortable--active { color: rgba(var(--sa-accent),0.9); }
.sa-perf-badge {
    display: inline-block;
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 4px;
    background: rgba(255,255,255,0.07);
    color: rgba(180,180,200,0.75);
    border: 1px solid rgba(255,255,255,0.08);
    white-space: nowrap;
}
.sa-perf-badge--warn {
    background: rgba(234,179,8,0.1);
    color: rgba(234,179,8,0.8);
    border-color: rgba(234,179,8,0.2);
}
.sa-table-pager {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 8px 4px 2px;
}
.sa-table-pager__btn {
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    color: rgba(200,200,220,0.85);
    font-size: 16px;
    line-height: 1;
    padding: 2px 10px 4px;
    cursor: pointer;
}
.sa-table-pager__btn:disabled {
    opacity: 0.3;
    cursor: default;
}
.sa-table-pager__btn:not(:disabled):hover {
    background: rgba(255,255,255,0.13);
}
.sa-table-pager__info {
    font-size: 12px;
    color: rgba(160,160,180,0.7);
    min-width: 40px;
    text-align: center;
}
.sa-perf-thumb {
    display: block;
    width: 88px;
    height: 56px;
    object-fit: cover;
    border-radius: 5px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.04);
}
.sa-perf-thumb-shimmer {
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.07) 50%, rgba(255,255,255,0.03) 100%);
    background-size: 200% 100%;
    animation: sa-shimmer 1.6s infinite;
    border-radius: 3px;
}
@keyframes sa-shimmer {
    0%   { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}
.sa-perf-thumb-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 88px;
    height: 56px;
    border-radius: 5px;
    border: 1px solid rgba(255,255,255,0.08);
    background: rgba(255,255,255,0.04);
    font-size: 11px;
    color: rgba(200,200,220,0.4);
    font-family: monospace;
}
/* ── Country detail back bar ─────────────────────────────────────────── */
.sa-perf-back {
    display: flex;
    align-items: center;
    gap: 20px;
    padding: 10px 0 4px;
}
.sa-perf-back__btn {
    background: none;
    border: 1px solid rgba(255,255,255,0.12);
    border-radius: 6px;
    color: rgba(200,200,220,0.7);
    cursor: pointer;
    font-size: 13px;
    padding: 5px 12px;
    transition: border-color 0.15s, color 0.15s;
    white-space: nowrap;
}
.sa-perf-back__btn:hover { border-color: rgba(255,255,255,0.28); color: rgba(220,220,240,0.95); }
.sa-perf-back__title {
    font-size: 18px;
    font-weight: 700;
    color: rgba(220,220,240,0.9);
    display: flex;
    align-items: center;
}

/* ── 2-column panel grid ─────────────────────────────────────────────── */
.sa-perf-2col {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 20px;
    align-items: start;
}

/* ── Sparkline trend grid ─────────────────────────────────────────────── */
.sa-perf-sparklines {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
}
.sa-perf-sparkline-card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 8px;
    padding: 14px 16px 10px;
}
.sa-perf-sparkline-card__header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 10px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(200,200,220,0.55);
}

@media (max-width: 1000px) {
    .sa-perf-cwv-row    { grid-template-columns: 1fr 1fr; }
    .sa-perf-timing-row { grid-template-columns: 1fr 1fr; }
    .sa-perf-sparklines { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
    .sa-perf-cwv-row    { grid-template-columns: 1fr; }
    .sa-perf-timing-row { grid-template-columns: 1fr 1fr; }
    .sa-perf-sparklines { grid-template-columns: 1fr; }
}

/* ── Section labels ───────────────────────────────────────────────────────── */
.sa-perf-section-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(160,160,180,0.45);
    margin-bottom: 8px;
    padding-left: 2px;
}

/* ── Period-over-period delta chip ────────────────────────────────────────── */
.sa-perf-delta {
    display: inline-block;
    font-size: 13px;
    font-weight: 600;
    margin-left: 8px;
    vertical-align: middle;
}
.sa-perf-cwv-card__value .sa-perf-delta {
    font-size: 14px;
}
.sa-perf-timing-card__value .sa-perf-delta {
    font-size: 11px;
    margin-left: 5px;
}

/* ── Sparkline band chart label ───────────────────────────────────────────── */
.sa-perf-sparkline-p75 {
    font-size: 9px;
    opacity: 0.5;
    font-weight: 400;
}

/* ── Percentile range bar ─────────────────────────────────────────────────── */
.sa-pctile-range-wrap {
    position: relative;
    height: 10px;
    background: rgba(255,255,255,0.04);
    border-radius: 3px;
    overflow: visible;
    min-width: 100px;
}
.sa-pctile-range-bg {
    position: absolute;
    inset: 0;
    display: flex;
    border-radius: 3px;
    overflow: hidden;
}
.sa-pctile-range-bar {
    position: absolute;
    top: 1px;
    bottom: 1px;
    background: rgba(var(--sa-accent),0.35);
    border-radius: 2px;
    min-width: 3px;
}
.sa-pctile-range-tick {
    position: absolute;
    top: -1px;
    bottom: -1px;
    width: 2px;
    background: rgba(var(--sa-accent),0.85);
    border-radius: 1px;
    transform: translateX(-50%);
}

/* ── PageTable LCP range bar ──────────────────────────────────────────────── */
.sa-page-lcp-bar {
    position: relative;
    height: 8px;
    background: rgba(255,255,255,0.06);
    border-radius: 3px;
    min-width: 80px;
    overflow: visible;
}

/* ── LongTask total-block horizontal bar ──────────────────────────────────── */
.sa-blocker-bar-wrap {
    flex: 1;
    height: 6px;
    background: rgba(255,255,255,0.06);
    border-radius: 3px;
    overflow: hidden;
    min-width: 40px;
    max-width: 80px;
}
.sa-blocker-bar {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s;
    min-width: 2px;
}

/* ── Scope / data-gap notes ───────────────────────────────────────────────── */
.sa-perf-scope-note {
    font-size: 11px;
    color: rgba(150,150,170,0.6);
    margin: 0 0 10px;
    font-style: italic;
}
.sa-perf-gap-panel {
    border-color: rgba(234,179,8,0.12) !important;
    background: rgba(234,179,8,0.03) !important;
}
.sa-perf-gap-panel .sa-panel__title {
    color: rgba(234,179,8,0.65);
}
.sa-perf-gap-panel code {
    font-size: 11px;
    background: rgba(255,255,255,0.06);
    padding: 1px 4px;
    border-radius: 3px;
}

/* ── Business impact ──────────────────────────────────────────────────────── */
.sa-perf-bi-empty {
    padding: 16px 0 8px;
    color: rgba(150,150,170,0.75);
    font-size: 13px;
    line-height: 1.5;
}
.sa-perf-bi-empty code {
    font-size: 11px;
    background: rgba(255,255,255,0.07);
    padding: 1px 5px;
    border-radius: 3px;
    color: rgba(200,200,220,0.7);
}
.sa-perf-bi-callout {
    background: rgba(34,197,94,0.06);
    border: 1px solid rgba(34,197,94,0.14);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 13px;
    color: rgba(190,220,200,0.9);
    margin-bottom: 16px;
    line-height: 1.5;
}
.sa-perf-bi-callout--neutral {
    background: rgba(234,179,8,0.05);
    border-color: rgba(234,179,8,0.14);
    color: rgba(220,200,160,0.8);
}
.sa-perf-bi-rows {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.sa-perf-bi-row {
    display: grid;
    grid-template-columns: 170px 1fr 56px 180px;
    align-items: center;
    gap: 14px;
}
.sa-perf-bi-label {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 13px;
    font-weight: 600;
}
.sa-perf-bi-bar-wrap {
    height: 10px;
    background: rgba(255,255,255,0.05);
    border-radius: 5px;
    overflow: hidden;
}
.sa-perf-bi-bar {
    height: 100%;
    border-radius: 5px;
    transition: width 0.4s;
    min-width: 2px;
}
.sa-perf-bi-rate {
    font-size: 14px;
    font-weight: 700;
    text-align: right;
    color: rgba(220,220,240,0.9);
}
.sa-perf-bi-sessions {
    font-size: 11px;
}
@media (max-width: 700px) {
    .sa-perf-bi-row { grid-template-columns: 140px 1fr 50px; }
    .sa-perf-bi-sessions { display: none; }
}

/* ── Experiment CWV — shared (comparison table + variant detail) ───────── */
.pxp-cwv-val { font-weight: 600; }
.pxp-cwv-val--good { color: #22c55e; }
.pxp-cwv-val--ni   { color: #eab308; }
.pxp-cwv-val--poor { color: #ef4444; }
.pxp-cwv-val--none { color: rgba(220,220,240,0.85); }

.pxp-cwv-sample {
    font-size: 10px;
    font-weight: 400;
    color: rgba(160,160,180,0.6);
    margin-left: 2px;
}

/* Rating distribution bar — used in both comparison table and detail page */
.pxp-cwv-dist {
    display: flex;
    height: 4px;
    border-radius: 2px;
    overflow: hidden;
    background: rgba(255,255,255,0.06);
    margin-top: 6px;
}
.pxp-cwv-dist__seg--good { background: rgba(34,197,94,0.75); }
.pxp-cwv-dist__seg--ni   { background: rgba(234,179,8,0.75); }
.pxp-cwv-dist__seg--poor { background: rgba(239,68,68,0.75); }

/* ── Variant detail — CWV three-up metric grid ─────────────────────────── */
.pxp-cwv-detail-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 12px;
}
.pxp-cwv-detail-metric {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 8px;
    padding: 12px 14px;
}
.pxp-cwv-detail-metric__val {
    display: block;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 3px;
}
.pxp-cwv-detail-metric__label {
    display: block;
    font-size: 11px;
    color: rgba(160,160,180,0.65);
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.pxp-cwv-detail-metric__range {
    margin-top: 5px;
    font-size: 11px;
    color: rgba(160,160,180,0.45);
}

/* Rating bar row in variant detail */
.pxp-cwv-dist-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}
.pxp-cwv-dist-row .pxp-cwv-dist {
    flex: 1;
    height: 8px;
    border-radius: 4px;
    margin-top: 0;
    min-width: 0;
}

/* Supporting metrics (FCP, TTFB) in variant detail */
.pxp-cwv-supporting {
    display: flex;
    gap: 24px;
    font-size: 13px;
    color: rgba(170,170,190,0.65);
    margin-bottom: 4px;
}
.pxp-cwv-supporting strong {
    color: rgba(220,220,240,0.88);
    font-weight: 600;
}

@media (max-width: 640px) {
    .pxp-cwv-detail-grid { grid-template-columns: 1fr 1fr; }
}

/* ── Page Weight — treemap ────────────────────────────────────────────────── */
.sa-treemap-wrap {
    border: 1px solid rgba(255,255,255,0.07);
    border-radius: 8px;
    overflow: hidden;
    background: rgba(0,0,0,0.15);
}
.sa-treemap-svg {
    width: 100%;
    height: auto;
    aspect-ratio: 960 / 420;
    display: block;
}
.sa-treemap-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 18px;
    margin-top: 14px;
}
.sa-treemap-legend__item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: rgba(200,200,220,0.8);
}
.sa-treemap-legend__swatch {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
}
.sa-treemap-legend__label {
    font-weight: 600;
}
.sa-treemap-legend__value {
    color: rgba(200,200,220,0.6);
}
.sa-treemap-legend__pct {
    font-size: 11px;
}

/* ── Page Weight — diagnostics & recommendations ──────────────────────────── */
.sa-diag-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.sa-diag-item {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.07);
    border-left-width: 3px;
    border-radius: 6px;
    padding: 10px 14px;
}
.sa-diag-item__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 4px;
}
.sa-diag-item__title {
    font-size: 13px;
    font-weight: 700;
    color: rgba(230,230,245,0.92);
}
.sa-diag-item__detail {
    margin: 0 0 8px;
    font-size: 12.5px;
    line-height: 1.5;
    color: rgba(190,190,210,0.75);
}
.sa-diag-item__savings {
    display: flex;
    align-items: baseline;
    gap: 8px;
    font-size: 12px;
}
.sa-diag-item__savings-label {
    color: rgba(160,160,180,0.6);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 10px;
}
.sa-diag-item__savings-value {
    font-weight: 700;
    color: rgba(var(--sa-accent),0.95);
}

/* ── Channel Digest page ─────────────────────────────────────────────────────── */

.sa-subnav__tab--portfolio {
    margin-left: auto;
    padding-left: 16px;
    border-left: 1px solid rgba(255,255,255,0.06);
}

.sa-digest-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 10px 0 16px;
}
.sa-digest-meta__info {
    font-size: 0.78rem;
    color: rgba(155,155,175,0.55);
}
.sa-digest-meta__refresh {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 6px;
    color: rgba(200,200,220,0.7);
    font-size: 0.75rem;
    padding: 3px 10px;
    cursor: pointer;
    transition: background 0.12s;
}
.sa-digest-meta__refresh:hover { background: rgba(255,255,255,0.09); }
.sa-digest-meta__refresh:disabled { opacity: 0.4; cursor: default; }

.sa-digest-section { margin-top: 8px; }

.sa-digest-card { position: relative; }
.sa-digest-card__domain {
    display: inline-block;
    font-size: 0.68rem;
    color: rgba(var(--sa-accent),0.65);
    background: rgba(var(--sa-accent),0.08);
    border: 1px solid rgba(var(--sa-accent),0.15);
    border-radius: 4px;
    padding: 1px 6px;
    margin-bottom: 6px;
    font-family: monospace;
    letter-spacing: 0.02em;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Analytics/Analytics.css"],"names":[],"mappings":"AAAA,oFAAoF;;AAEpF;IACI,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,2CAA2C;IAC3C,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,yEAAyE;;IAEzE,gFAAgF;IAChF,6BAA6B;;IAE7B;;;;4EAIwE;IACxE,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;IAClC,kCAAkC;;IAElC,+BAA+B;IAC/B,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;;IAExB,mCAAmC;IACnC,yCAAyC;IACzC,yCAAyC;IACzC,yCAAyC;IACzC,0CAA0C;IAC1C,yCAAyC;AAC7C;;AAEA,kFAAkF;;AAElF;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,mFAAmF;;AAEnF;IACI,uCAAuC;IACvC,qCAAqC;IACrC,kCAAkC;IAClC,gBAAgB;IAChB,kEAAkE;IAClE,aAAa;IACb,sBAAsB;AAC1B;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,yBAAyB,mCAAmC,EAAE;;AAE9D;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,OAAO,wCAAwC,EAAE;IACjD,OAAO,wCAAwC,EAAE;IACjD,OAAO,sCAAsC,EAAE;AACnD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA,yBAAyB,kCAAkC,EAAE,WAAW,EAAE;;AAE1E,eAAe;AACf;IACI,0CAA0C;IAC1C,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,0BAA0B;IAC1B,iCAAiC;IACjC,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,cAAc;IACd,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;AACnB;;AAEA,6BAA6B;AAC7B,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEvE;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,mDAAmD;AACvD;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,+CAA+C;IAC/C,gCAAgC;AACpC;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,kCAAkC;IAClC,eAAe;IACf,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEnE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,uCAAuC;AAC3C;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;AACb;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA,mFAAmF;;AAEnF;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,0CAA0C;IAC1C,4BAA4B;IAC5B,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,cAAc;AAClB;;AAEA,oFAAoF;;AAEpF;IACI,aAAa;IACb,qBAAqB;IACrB,MAAM;IACN,kDAAkD;IAClD,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,gCAAgC,aAAa,EAAE;;AAE/C;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,qBAAqB;IACrB,2CAA2C;IAC3C,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,6BAA6B,eAAe,EAAE;;AAE9C;IACI,+BAA+B;AACnC;;AAEA;IACI,4BAA4B;IAC5B,6CAA6C;IAC7C,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,mFAAmF;;AAEnF,+EAA+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,uCAAuC;IACvC,+BAA+B;IAC/B,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,iCAAiC,0BAA0B,EAAE;;AAE7D,+EAA+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;AAC3C;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA,gFAAgF;;AAEhF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,4DAA4D;IAC5D,QAAQ;AACZ;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gDAAgD;IAChD,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;AAChC;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,yCAAyC;IACzC,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,mFAAmF;;AAEnF;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,qCAAqC;IACrC,2DAA2D;IAC3D,oDAAoD;IACpD,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,0DAA0D;AAC9D;;AAEA;IACI,mEAAmE;IACnE,mCAAmC;AACvC;;AAEA,gDAAgD;AAChD;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS,EAAE,OAAO,EAAE,YAAY;IAChC,UAAU;IACV,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;;;;;uEAKuE;AACvE,wBAAwB,6CAA6C,EAAE;AACvE,wBAAwB,4CAA4C,EAAE;AACtE,2BAA2B,4CAA4C,EAAE;;AAEzE;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,kCAAkC;AACtC;;AAEA,iCAAiC,uCAAuC,EAAE;AAC1E,iCAAiC,sCAAsC,EAAE;AACzE,iCAAiC,sCAAsC,EAAE;;AAEzE;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,cAAc;IACd,uBAAuB;AAC3B;;AAEA,+BAA+B,4BAA4B,EAAE;;AAE7D;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,uBAAuB,2BAA2B,EAAE;AACpD,uBAAuB,4BAA4B,EAAE;;AAErD;IACI,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;;AAEA,mFAAmF;;AAEnF;IACI,oDAAoD;IACpD,2DAA2D;IAC3D,qCAAqC;IACrC,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA,iBAAiB,WAAW,EAAE;;AAE9B;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA,iCAAiC,iCAAiC,EAAE;AACpE,iCAAiC,uCAAuC,EAAE;;AAE1E;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC;;;;;0CAKsC;AAC1C;;AAEA;IACI;;;;0CAIsC;AAC1C;;AAEA,0BAA0B;AAC1B,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE;AACxD,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,kBAAkB,EAAE;AACvC,mBAAmB,oBAAoB,EAAE;AACzC,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,cAAc,EAAE;AACnC,mBAAmB,aAAa,EAAE;AAClC,mBAAmB,kBAAkB,EAAE;;AAEvC;IACI;;QAEI,qCAAqC;QACrC;;;;;;;;6BAQqB;IACzB;IACA;QACI;;;;;;;;6BAQqB;IACzB;AACJ;;AAEA;IACI;;QAEI,0BAA0B;QAC1B;;;;wCAIgC;IACpC;AACJ;;AAEA,mFAAmF;;AAEnF;IACI,oDAAoD;IACpD,2DAA2D;IAC3D,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,wDAAwD;AACxD;IACI,WAAW;IACX,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oCAAoC;IACpC,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,mFAAmF;;AAEnF;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mCAAmC;IACnC,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA,mCAAmC,mBAAmB,EAAE;;AAExD;IACI,gCAAgC;AACpC;AACA;IACI,mCAAmC;AACvC;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;IAClC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,6BAA6B;AACjC;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA,mFAAmF;;AAEnF;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA,mFAAmF;;AAEnF;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,mCAAmC;IACnC,2BAA2B;IAC3B,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA,mFAAmF;;AAEnF;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gDAAgD;IAChD,mBAAmB;AACvB;;AAEA,qBAAqB,kCAAkC,EAAE,mCAAmC,EAAE;AAC9F,qBAAqB,iCAAiC,EAAE,kCAAkC,EAAE,cAAc,EAAE;;AAE5G,mFAAmF;;AAEnF;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA,kBAAkB,iCAAiC,EAAE;;AAErD;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;IAC7C,sCAAsC;IACtC,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;AAC7C;;AAEA,8BAA8B,aAAa,EAAE,mBAAmB,EAAE;;AAElE;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,4BAA4B;IAC5B,4DAA4D;IAC5D,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,oFAAoF;;AAEpF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,8EAA8E;AAC9E;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA;IACI,qCAAqC;AACzC;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,uCAAuC;IACvC,kBAAkB;IAClB,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,2CAA2C;AAC/C;AACA;IACI,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,uCAAuC;AAC3C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA,mCAAmC,4BAA4B,EAAE;AACjE;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,gDAAgD;AACpD;AACA;IACI,kCAAkC;AACtC;AACA;IACI,iCAAiC;IACjC,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,OAAO;AACX;AACA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;IACvC,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;AACnB;AACA,mCAAmC,4BAA4B,EAAE;AACjE;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA,mCAAmC,8BAA8B,EAAE;;AAEnE,gDAAgD;AAChD;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA,sDAAsD;AACtD;IACI,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,mBAAmB,qCAAqC,EAAE;IAC1D,mBAAmB,qCAAqC,EAAE;IAC1D,mBAAmB,qCAAqC,EAAE;IAC1D,mBAAmB,8BAA8B,EAAE;AACvD;;AAEA;IACI,sBAAsB,0BAA0B,EAAE;IAClD,sBAAsB,0BAA0B,EAAE;AACtD;;AAEA;IACI,oDAAoD,qCAAqC,EAAE;IAC3F,mBAAmB,0BAA0B,EAAE;AACnD;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC;;;;;;;uBAOmB;AACvB;;AAEA,oBAAoB,eAAe,OAAO,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AACrF,uBAAuB,eAAe,EAAE;AACxC,oBAAoB,cAAc,QAAQ;AAC1C,qBAAqB,oBAAoB,EAAE;AAC3C,oBAAoB,oBAAoB,EAAE;AAC1C,oBAAoB,mBAAmB,GAAG;AAC1C,oBAAoB,aAAa,SAAS;AAC1C,oBAAoB,kBAAkB,IAAI;AAC1C,oBAAoB,kBAAkB,IAAI;AAC1C,oBAAoB,eAAe,OAAO;AAC1C,oBAAoB,aAAa,SAAS;;AAE1C,+EAA+E;;AAE/E;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,+CAA+C;AACnD;AACA,gCAAgC,mBAAmB,EAAE;;AAErD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,kCAAkC;AACtC;AACA,wBAAwB,4BAA4B,EAAE;AACtD,wBAAwB,6BAA6B,EAAE;;AAEvD,iFAAiF;AACjF;IACI,OAAO,4BAA4B,EAAE;IACrC,OAAO,4BAA4B,EAAE;AACzC;AACA;IACI,kBAAkB;IAClB;;;;;KAKC;IACD,0BAA0B;IAC1B,+CAA+C;IAC/C,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,iFAAiF;;AAEjF;IACI,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,sCAAsC;IACtC,cAAc;AAClB;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,SAAS;IACT,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA,+EAA+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,mBAAmB,aAAa,EAAE,QAAQ,EAAE;AAC5C,yBAAyB,OAAO,EAAE;;AAElC;IACI;QACI,0BAA0B;QAC1B;;2CAEmC;IACvC;IACA,mBAAmB,sBAAsB,EAAE;IAC3C,0BAA0B,QAAQ,EAAE,kBAAkB,EAAE;AAC5D;;AAEA,oFAAoF;;AAEpF;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,qCAAqC;IACrC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,wCAAwC;IACxC,8CAA8C;IAC9C,oBAAoB;IACpB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe,0BAA0B,EAAE;AAC/C;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;AACtC;AACA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,qCAAqC;AACzC;AACA;IACI,UAAU,EAAE,WAAW;IACvB,kBAAkB;IAClB,cAAc;AAClB;AACA,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD,yBAAyB,4BAA4B,EAAE;AACvD,kBAAkB,iBAAiB,EAAE;;AAErC,6BAA6B;AAC7B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;qEACqE;AACrE;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC;;;yBAGqB;AACzB;;AAEA,oBAAoB,eAAe,EAAE,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAChF,uBAAuB,eAAe,EAAE;AACxC,oBAAoB,gBAAgB,MAAM;AAC1C,oBAAoB,cAAc,QAAQ;AAC1C,oBAAoB,oBAAoB,EAAE;AAC1C,oBAAoB,gBAAgB,MAAM;;AAE1C;IACI;QACI,0BAA0B;QAC1B,6DAA6D;IACjE;AACJ;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC;;;;qCAIiC;AACrC;;AAEA,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE;AACxD,mBAAmB,oBAAoB,EAAE;AACzC,mBAAmB,kBAAkB,EAAE;;AAEvC;IACI;QACI,0BAA0B;QAC1B,uEAAuE;IAC3E;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,2DAA2D;IAC3D,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC;;6BAEyB;AAC7B;;AAEA,cAAc,eAAe,EAAE;AAC/B,cAAc,eAAe,EAAE;AAC/B,cAAc,eAAe,EAAE;AAC/B,cAAc,eAAe,EAAE;AAC/B,cAAc,eAAe,EAAE;;AAE/B;IACI;QACI,qCAAqC;QACrC;;;uBAGe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B;8CACsC;IAC1C;AACJ;;AAEA,mFAAmF;;AAEnF;wCACwC;AACxC;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC;;0BAEsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA,wEAAwE;AACxE,2BAA2B,OAAO,EAAE,gBAAgB,EAAE;;AAEtD,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,wCAAwC;IACxC,4EAA4E;IAC5E,+BAA+B;AACnC;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,+CAA+C;IAC/C,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;wEACwE;AACxE;IACI;QACI,0BAA0B;QAC1B;;;qBAGa;IACjB;IACA,uBAAuB,mBAAmB,EAAE;IAC5C,mCAAmC,OAAO,EAAE,YAAY,EAAE;AAC9D;;AAEA;IACI,uBAAuB,sBAAsB,EAAE;IAC/C,mCAAmC,UAAU,EAAE;AACnD;;AAEA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA;;+EAE+E;AAC/E;IACI,OAAO;IACP,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,6DAA6D;AACjE;AACA,oDAAoD,UAAU,EAAE;AAChE,oDAAoD,4BAA4B,EAAE;AAClF,oDAAoD,uCAAuC,EAAE,kBAAkB,EAAE;;AAEjH;qDACqD;AACrD;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,qCAAqC;AACzC;AACA,sCAAsC,cAAc,EAAE;;AAEtD;gFACgF;AAChF;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,mFAAmF;;AAEnF;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,uBAAuB;AAC3B;;AAEA,mFAAmF;;AAEnF;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC;;;;uCAImC;AACvC;;AAEA,sBAAsB,eAAe,QAAQ;AAC7C,sBAAsB,eAAe,QAAQ;AAC7C,sBAAsB,mBAAmB,IAAI;AAC7C,sBAAsB,eAAe,QAAQ;AAC7C,sBAAsB,eAAe,QAAQ;AAC7C,sBAAsB,qBAAqB,EAAE;AAC7C,sBAAsB,gBAAgB,OAAO;AAC7C,sBAAsB,iBAAiB,MAAM;;AAE7C;IACI;QACI,qCAAqC;QACrC;;;;;;+BAMuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B;gFACwE;IAC5E;AACJ;;AAEA,mFAAmF;;AAEnF;IACI,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uCAAuC;IACvC,4CAA4C;IAC5C,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;;IAEI,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;;AAErE;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;IACI,iCAAiC;IACjC,cAAc;IACd,eAAe;AACnB;;AAEA,0BAA0B,WAAW,EAAE,YAAY,EAAE;;AAErD,sBAAsB,OAAO,EAAE,YAAY,EAAE;;AAE7C;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sCAAsC;IACtC,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,0CAA0C;IAC1C,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,sCAAsC,kCAAkC,EAAE;;AAE1E;IACI,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA,8BAA8B,4BAA4B,EAAE;AAC5D,4BAA4B,WAAW,EAAE,YAAY,EAAE;;AAEvD,oFAAoF;;AAEpF,kBAAkB,sBAAsB,EAAE,oBAAoB,EAAE;;AAEhE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,uCAAuC;IACvC,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,4DAA4D,wCAAwC,EAAE,6BAA6B,EAAE;AACrI,gDAAgD,aAAa,EAAE,mBAAmB,EAAE;AACpF,2CAA2C,WAAW,EAAE,YAAY,EAAE;;AAEtE;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;IACpB,eAAe;IACf,UAAU;AACd;;AAEA,gCAAgC,6BAA6B,EAAE;;AAE/D,mFAAmF;;AAEnF;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB,qCAAqC,EAAE;AAC/D;;AAEA;IACI,oBAAoB,0BAA0B,EAAE;AACpD;;AAEA;;6EAE6E;;AAE7E;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,iDAAiD;AACrD;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;IACA;QACI,UAAU;QACV,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,kDAAkD;IACtD;AACJ;;AAEA,oFAAoF;;AAEpF;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B;;;mBAGe;AACnB;;AAEA;IACI,8BAA8B;IAC9B;;;+BAG2B;AAC/B;;AAEA,yBAAyB,eAAe,OAAO;AAC/C,yBAAyB,eAAe,OAAO;AAC/C,yBAAyB,gBAAgB,MAAM;AAC/C,yBAAyB,cAAc,QAAQ;AAC/C,yBAAyB,cAAc,QAAQ;AAC/C,yBAAyB,mBAAmB,GAAG;AAC/C,yBAAyB,iBAAiB,KAAK;AAC/C,yBAAyB,oBAAoB,EAAE;;AAE/C;IACI;QACI,0BAA0B;QAC1B,gDAAgD;IACpD;IACA;QACI,0BAA0B;QAC1B,0DAA0D;IAC9D;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA,kFAAkF;;AAElF;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,mFAAmF;;AAEnF;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,4FAA4F;IAC5F,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA,kFAAkF;;AAElF;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,+CAA+C;IAC/C,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,yCAAyC;IACzC,kCAAkC;IAClC,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA,+EAA+E;AAC/E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,uCAAuC;IACvC,4CAA4C;IAC5C,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;AAChD;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,8EAA8E;;AAE9E,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA,qBAAqB,6BAA6B,EAAE;AACpD;IACI,qBAAqB;IACrB,iBAAiB;IACjB,uCAAuC;IACvC,6CAA6C;IAC7C,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;AACtC;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sCAAsC;IACtC,6CAA6C;IAC7C,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,qBAAqB;IACrB,4BAA4B;IAC5B,mBAAmB;AACvB;AACA,2BAA2B,uCAAuC,EAAE,+BAA+B,EAAE;;AAErG,sBAAsB;AACtB;IACI,aAAa;IACb,MAAM;IACN,mBAAmB;IACnB,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,8CAA8C;IAC9C,eAAe;IACf,YAAY;IACZ,4BAA4B;AAChC;AACA,qBAAqB,kBAAkB,EAAE;AACzC,gBAAgB,mCAAmC,EAAE;AACrD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;AACA,+BAA+B,4BAA4B,EAAE;AAC7D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,6CAA6C;AAC7C,oBAAoB,gBAAgB,EAAE;AACtC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAChC;AACA,8CAA8C,aAAa,EAAE;AAC7D;IACI,YAAY;IACZ,iBAAiB;IACjB,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA,4CAA4C,YAAY,EAAE;AAC1D,4BAA4B,mCAAmC,EAAE;AACjE;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA,8EAA8E;;AAE9E;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,mBAAmB;IACnB,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,MAAM;IACN,eAAe;IACf,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;IAC9C,QAAQ;AACZ;AACA,mCAAmC,kBAAkB,EAAE;AACvD,8BAA8B,gCAAgC,EAAE;AAChE;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;AAC1B;AACA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,YAAY;IACZ,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO,EAAE,MAAM,EAAE,SAAS;IAC1B,+EAA+E;IAC/E,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,4BAA4B;IAC5B,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;AACrB;AACA,gCAAgC,6BAA6B,EAAE;AAC/D,gCAAgC,6BAA6B,EAAE;AAC/D;IACI,SAAS;IACT,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,8EAA8E;;AAE9E;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kCAAkC;IAClC,mBAAmB;IACnB,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,+CAA+C;IAC/C,mBAAmB;AACvB;AACA,qBAAqB,iBAAiB,EAAE;AACxC;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,+CAA+C;IAC/C,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;AACA,sCAAsC,6BAA6B,EAAE;AACrE;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;IAC1B,gCAAgC;IAChC,qCAAqC;IACrC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;AACA,uBAAuB,2BAA2B,GAAG,gBAAgB,EAAE;AACvE,uBAAuB,4BAA4B,EAAE,gBAAgB,EAAE;AACvE,uBAAuB,4BAA4B,EAAE,gBAAgB,EAAE;AACvE;IACI,SAAS;IACT,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA,kFAAkF;;AAElF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,sCAAsC;IACtC,iBAAiB;IACjB,eAAe;IACf,UAAU;AACd;AACA,uBAAuB,cAAc,EAAE;;AAEvC;IACI,aAAa;IACb,QAAQ;IACR,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,kCAAkC;IAClC,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;AACA;IACI,sCAAsC;IACtC,cAAc;IACd,wCAAwC;AAC5C;AACA;IACI,6CAA6C;IAC7C,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;IACvC,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,cAAc;AAClB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,6CAA6C;IAC7C,uCAAuC;IACvC,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,wCAAwC;IACxC,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA,+EAA+E;;AAE/E;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,wDAAwD;IACxD,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,qCAAqC;IACrC,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA,iCAAiC,2BAA2B,EAAE;AAC9D,iCAAiC,4BAA4B,EAAE;;AAE/D,gFAAgF;AAChF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uCAAuC;IACvC,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,+BAA+B;IAC/B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,4BAA4B;IAC5B,mBAAmB;AACvB;AACA,iCAAiC,2BAA2B,EAAE;;AAE9D;IACI,aAAa;IACb,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,kCAAkC;IAClC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,2BAA2B,cAAc,EAAE,gBAAgB,EAAE;AAC7D,2BAA2B,cAAc,EAAE,gBAAgB,EAAE;;AAE7D;IACI,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,kCAAkC;AACtC;AACA,6BAA6B,iCAAiC,EAAE,cAAc,EAAE;AAChF,6BAA6B,gCAAgC,GAAG,cAAc,EAAE;AAChF,6BAA6B,kCAAkC,EAAE,+BAA+B,EAAE;;AAElG;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,2CAA2C;IAC3C,8BAA8B;AAClC;;AAEA,2EAA2E;AAC3E;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,iCAAiC;IACjC,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,4EAA4E;AAC5E;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,iCAAiC;IACjC,+BAA+B;AACnC;;AAEA,4EAA4E;AAC5E;IACI,kCAAkC;IAClC,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA,+EAA+E;;AAE/E;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,oCAAoC;IACpC,eAAe;AACnB;AACA,0BAA0B,cAAc,EAAE;AAC1C;IACI,cAAc;IACd,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA,gFAAgF;AAChF;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA,iFAAiF;AACjF;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,eAAe;IACf,+BAA+B;IAC/B,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,SAAS;AACb;;AAEA,iFAAiF;AACjF;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,+BAA+B;IAC/B,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,kCAAkC;IAClC,gDAAgD;IAChD,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wCAAwC;IACxC,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;AACrB;;AAEA,+EAA+E;AAC/E;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;IACjB,wCAAwC;IACxC,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;;IAEI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,4CAA4C;IAC5C,uCAAuC;IACvC,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAEA,8EAA8E;AAC9E;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA,+EAA+E;AAC/E;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;;IAEI,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gCAAgC;IAChC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA,+EAA+E;AAC/E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,6CAA6C;IAC7C,uCAAuC;IACvC,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;;AAGA,+EAA+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,8CAA8C;IAC9C,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mCAAmC;IACnC,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,qCAAqC;IACrC,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,mCAAmC;IACnC,mCAAmC;IACnC,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,wCAAwC;IACxC,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,8EAA8E;AAC9E;IACI,yCAAyC;IACzC,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,+EAA+E;;AAE/E,qCAAqC;AACrC;IACI,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;IACnB,sBAAsB;AAC1B;AACA,oBAAoB,+BAA+B,EAAE;;AAErD,8CAA8C;AAC9C;IACI,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;AACA,iCAAiC,oCAAoC,EAAE,gBAAgB,EAAE;AACzF,0BAA0B,wCAAwC,EAAE;;AAEpE,yBAAyB;AACzB;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc,0BAA0B,EAAE;AAC9C;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,SAAS;AACb;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;AAChB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;IACpB,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;AACxB;AACA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,oCAAoC;AACxC;AACA;IACI,yCAAyC;IACzC,sCAAsC;IACtC,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA,8BAA8B;AAC9B;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;AACA;8BAC8B,kCAAkC,EAAE;;AAElE;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA,YAAY;AACZ,qBAAqB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AAC1F,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACnE;IACI,gBAAgB;IAChB,YAAY;IACZ,mCAAmC;IACnC,eAAe;IACf,eAAe;IACf,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;AACA,6BAA6B,6BAA6B,EAAE;AAC5D;IACI,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yCAAyC;AAC7C;AACA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,mCAAmC;IACnC,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA,wBAAwB;AACxB,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc,EAAE;AACpF,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACjE;IACI,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA,UAAU;AACV,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AACtG,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AACzF,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACpE,sBAAsB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACnF,sBAAsB,kBAAkB,EAAE,gCAAgC,EAAE,OAAO,EAAE,eAAe,EAAE;AACtG,sBAAsB,kBAAkB,EAAE,qCAAqC,EAAE,WAAW,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACjI,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,iCAAiC,EAAE,WAAW,EAAE,iBAAiB,EAAE,cAAc,EAAE;;AAE/I,iBAAiB,kBAAkB,EAAE,mCAAmC,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAE/G,+EAA+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,8CAA8C;AAClD;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA,6EAA6E;;AAE7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,OAAO;AACX;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sCAAsC;IACtC,eAAe;IACf,0DAA0D;IAC1D,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,uCAAuC;IACvC,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA,8EAA8E;;AAE9E;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,sCAAsC;IACtC,6CAA6C;IAC7C,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,wCAAwC;IACxC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sCAAsC;IACtC,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;IAClC,gCAAgC;IAChC,cAAc;AAClB;;AAEA,8EAA8E;;AAE9E;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;IAC/B,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA,8EAA8E;;AAE9E;IACI,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,gFAAgF;;AAEhF;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mCAAmC;IACnC,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,+CAA+C;IAC/C,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,+EAA+E;;AAE/E;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,+EAA+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;AACnC;;AAEA;IACI,uCAAuC;IACvC,+BAA+B;AACnC;;AAEA,oFAAoF;;AAEpF;IACI,cAAc;IACd,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,cAAc,gBAAgB,EAAE;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qCAAqC;IACrC,eAAe;AACnB;;AAEA,oFAAoF;;AAEpF;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B,0BAA0B,EAAE;IACvD,2BAA2B,8BAA8B,EAAE;IAC3D,2BAA2B,0BAA0B,EAAE;IACvD,2BAA2B,0BAA0B,EAAE;AAC3D;;AAEA;IACI,2BAA2B,0BAA0B,EAAE;IACvD,2BAA2B,0BAA0B,EAAE;IACvD,2BAA2B,0BAA0B,EAAE;IACvD,2BAA2B,0BAA0B,EAAE;IACvD,iBAAiB,SAAS,EAAE,mBAAmB,EAAE;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;;IAEI,WAAW;IACX,OAAO;IACP,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iCAAiC;IACjC,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;AACA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;AACA;IACI,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA,oFAAoF;;AAEpF;IACI,+FAA+F;IAC/F,4CAA4C;IAC5C,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iCAAiC;IACjC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;IACjC,uCAAuC;IACvC,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kCAAkC;IAClC,uCAAuC;IACvC,mBAAmB;IACnB,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;IACnB,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iCAAiC;IACjC,yCAAyC;IACzC,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,eAAe;IACf,qCAAqC;IACrC,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,sCAAsC;IACtC,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;AACtC;AACA,2BAA2B,YAAY,EAAE,sBAAsB,EAAE;AACjE,iCAAiC,gCAAgC,EAAE;AACnE,iCAAiC,gCAAgC,EAAE;AACnE,iCAAiC,gCAAgC,EAAE;AACnE;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,4BAA4B;AAChC;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD,qBAAqB,gCAAgC,EAAE;AACvD;IACI,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;AAChC;AACA,oBAAoB,gBAAgB,EAAE,4BAA4B,EAAE;AACpE,oBAAoB,eAAe,EAAE,eAAe,EAAE;AACtD,sBAAsB,iBAAiB,EAAE;AACzC,8BAA8B,iCAAiC,EAAE;AACjE;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,6BAA6B;IAC7B,wCAAwC;IACxC,mBAAmB;AACvB;AACA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,oBAAoB;AACxB;AACA;IACI,kCAAkC;IAClC,uCAAuC;IACvC,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;AACtC;AACA;IACI,WAAW;IACX,YAAY;IACZ,sHAAsH;IACtH,0BAA0B;IAC1B,mCAAmC;IACnC,kBAAkB;AACtB;AACA;IACI,OAAO,2BAA2B,EAAE;IACpC,OAAO,4BAA4B,EAAE;AACzC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA,2EAA2E;AAC3E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,mBAAmB;AACvB;AACA,2BAA2B,oCAAoC,EAAE,6BAA6B,EAAE;AAChG;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;;AAEA,2EAA2E;AAC3E;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,kBAAkB;AACtB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;AACA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB,8BAA8B,EAAE;IACtD,sBAAsB,8BAA8B,EAAE;IACtD,sBAAsB,8BAA8B,EAAE;AAC1D;AACA;IACI,sBAAsB,0BAA0B,EAAE;IAClD,sBAAsB,8BAA8B,EAAE;IACtD,sBAAsB,0BAA0B,EAAE;AACtD;;AAEA,gFAAgF;AAChF;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,gFAAgF;AAChF;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,gFAAgF;AAChF;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA,gFAAgF;AAChF;IACI,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,uCAAuC;IACvC,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,uCAAuC;IACvC,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA,gFAAgF;AAChF;IACI,kBAAkB;IAClB,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA,gFAAgF;AAChF;IACI,OAAO;IACP,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA,gFAAgF;AAChF;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,6CAA6C;IAC7C,2CAA2C;AAC/C;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,gFAAgF;AAChF;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;AACA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB,qCAAqC,EAAE;IACzD,uBAAuB,aAAa,EAAE;AAC1C;;AAEA,6EAA6E;AAC7E,eAAe,gBAAgB,EAAE;AACjC,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,cAAc,EAAE;AACrC,qBAAqB,6BAA6B,EAAE;;AAEpD;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;AACA,2BAA2B,gCAAgC,EAAE;AAC7D,2BAA2B,gCAAgC,EAAE;AAC7D,2BAA2B,gCAAgC,EAAE;;AAE7D,6EAA6E;AAC7E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,OAAO;IACP,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB,8BAA8B,EAAE;AAC3D;;AAEA,gFAAgF;AAChF;IACI,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,4BAA4B;AAChC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;AACnB;;AAEA,gFAAgF;AAChF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,eAAe;AACnB;AACA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA,mFAAmF;;AAEnF;IACI,iBAAiB;IACjB,kBAAkB;IAClB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;AACA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,4BAA4B;AAChC;AACA,iCAAiC,kCAAkC,EAAE;AACrE,oCAAoC,YAAY,EAAE,eAAe,EAAE;;AAEnE,qBAAqB,eAAe,EAAE;;AAEtC,kBAAkB,kBAAkB,EAAE;AACtC;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kCAAkC;IAClC,uCAAuC;IACvC,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;AAC1B","sourcesContent":["/* ── Design tokens ────────────────────────────────────────────────────────────── */\n\n:root {\n    --sa-surface:    rgba(14, 14, 20, 0.97);\n    --sa-surface-2:  rgba(20, 20, 28, 0.95);\n    --sa-surface-3:  rgba(26, 26, 36, 0.92);\n    --sa-border:     rgba(255, 255, 255, 0.055);\n    --sa-radius:     12px;\n    --sa-radius-lg:  16px;\n    --sa-gap:        20px;\n    --sa-shadow-panel: 0 1px 3px rgba(0,0,0,0.4), 0 8px 24px rgba(0,0,0,0.18);\n\n    /* Brand accent (gold) — used at varying opacity via rgba(var(--sa-accent), X) */\n    --sa-accent:     192, 159, 83;\n\n    /* Gray text ladder (RGB triplets, no alpha — call sites vary opacity).\n       Consolidated from ~34 near-duplicate one-off grays that had organically\n       drifted in by ±10-20 units each with no real difference in intent;\n       these 4 anchors are the dominant exact value already used within each\n       brightness band, so most call sites needed no visual change at all. */\n    --sa-text-dim:       130, 130, 130;\n    --sa-text-muted:     160, 160, 160;\n    --sa-text-secondary: 180, 180, 180;\n    --sa-text:           210, 210, 210;\n\n    /* Per-channel accent palette */\n    --sa-c-green:    #4ade80;\n    --sa-c-blue:     #60a5fa;\n    --sa-c-amber:    #f9bf40;\n    --sa-c-purple:   #a78bfa;\n    --sa-c-teal:     #2dd4bf;\n    --sa-c-red:      #f87171;\n\n    /* Translucent accent backgrounds */\n    --sa-bg-green:   rgba(74, 222, 128, 0.08);\n    --sa-bg-blue:    rgba(96, 165, 250, 0.08);\n    --sa-bg-amber:   rgba(249, 191, 64, 0.08);\n    --sa-bg-purple:  rgba(167, 139, 250, 0.08);\n    --sa-bg-teal:    rgba(45, 212, 191, 0.08);\n}\n\n/* ── Site Analytics report page ─────────────────────────────────────────────── */\n\n.sa-page {\n    padding: 8px 0 72px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n/* ── Live view panel ─────────────────────────────────────────────────────────── */\n\n.sa-live {\n    border: 1px solid rgba(74,222,128,0.15);\n    border-radius: var(--sa-radius, 12px);\n    background: rgba(10, 18, 12, 0.98);\n    overflow: hidden;\n    box-shadow: 0 1px 3px rgba(0,0,0,0.5), 0 8px 24px rgba(0,0,0,0.22);\n    display: flex;\n    flex-direction: column;\n}\n\n/* ── Header ── */\n.sa-live__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 12px 16px;\n    gap: 12px;\n    cursor: pointer;\n    user-select: none;\n    flex-shrink: 0;\n}\n\n.sa-live__header:hover { background: rgba(255,255,255,0.015); }\n\n.sa-live__title {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n}\n\n.sa-live__dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #4ade80;\n    box-shadow: 0 0 0 0 rgba(74,222,128,0.6);\n    animation: sa-pulse 2s ease-out infinite;\n    flex-shrink: 0;\n}\n\n@keyframes sa-pulse {\n    0%   { box-shadow: 0 0 0 0 rgba(74,222,128,0.6); }\n    60%  { box-shadow: 0 0 0 6px rgba(74,222,128,0); }\n    100% { box-shadow: 0 0 0 0 rgba(74,222,128,0); }\n}\n\n.sa-live__label {\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(74,222,128,0.9);\n}\n\n.sa-live__window {\n    font-size: 0.7rem;\n    color: rgba(var(--sa-text-dim),0.6);\n}\n\n.sa-live__right {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.sa-live__countdown {\n    font-size: 0.68rem;\n    color: rgba(var(--sa-text-dim),0.55);\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-live__toggle {\n    background: none;\n    border: none;\n    color: rgba(var(--sa-text-dim),0.55);\n    cursor: pointer;\n    padding: 2px 4px;\n    font-size: 0.7rem;\n    line-height: 1;\n    border-radius: 4px;\n}\n\n.sa-live__toggle:hover { background: rgba(255,255,255,0.06); color: #ccc; }\n\n/* ── Body ── */\n.sa-live__body {\n    border-top: 1px solid rgba(74,222,128,0.1);\n    padding: 14px 16px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    overflow-y: auto;\n}\n\n/* ── Sparkline ── */\n.sa-live__sparkline {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.sa-live__spark-hd {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n}\n\n.sa-live__spark-label {\n    font-size: 0.68rem;\n    font-weight: 500;\n    color: rgba(var(--sa-text-dim),0.6);\n}\n\n.sa-live__spark-peak {\n    font-size: 0.62rem;\n    color: rgba(var(--sa-text-dim),0.5);\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-live__spark-bars {\n    display: flex;\n    align-items: flex-end;\n    gap: 2px;\n    height: 44px;\n}\n\n.sa-live__spark-bar {\n    flex: 1;\n    border-radius: 2px 2px 0 0;\n    background: rgba(74,222,128,0.28);\n    min-height: 2px;\n    transition: height 0.3s ease;\n}\n\n.sa-live__spark-bar--last {\n    background: rgba(74,222,128,0.75);\n}\n\n.sa-live__spark-times {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.6rem;\n    color: rgba(var(--sa-text-dim),0.5);\n}\n\n/* ── 2 × 2 KPI grid ── */\n.sa-live__kpis {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n}\n\n.sa-live__kpi {\n    background: rgba(255,255,255,0.025);\n    border: 1px solid rgba(255,255,255,0.06);\n    border-radius: 8px;\n    padding: 10px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.sa-live__kpi-label {\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: rgba(130,130,145,0.65);\n}\n\n.sa-live__kpi-value {\n    font-size: 1.45rem;\n    font-weight: 700;\n    color: rgba(228,240,228,0.95);\n    line-height: 1;\n    letter-spacing: -0.02em;\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-live__kpi-sub {\n    font-size: 0.62rem;\n    color: rgba(var(--sa-text-dim),0.55);\n    margin-top: 1px;\n}\n\n/* ── Recent events feed ── */\n.sa-live__feed-wrap { display: flex; flex-direction: column; gap: 6px; }\n\n.sa-live__section-title {\n    font-size: 0.65rem;\n    font-weight: 500;\n    color: rgba(110,110,125,0.6);\n    margin: 0;\n}\n\n.sa-live__feed {\n    display: flex;\n    flex-direction: column;\n    max-height: 224px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(255,255,255,0.08) transparent;\n}\n\n.sa-live__event {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    gap: 8px;\n    padding: 5px 0;\n    border-bottom: 1px solid rgba(255,255,255,0.04);\n    animation: sa-fade-in 0.35s ease;\n}\n\n.sa-live__event:last-child { border-bottom: none; }\n\n.sa-live__event--custom .sa-live__event-path {\n    color: rgba(var(--sa-accent),0.8);\n}\n\n.sa-live__event-name {\n    font-family: inherit;\n    font-size: 0.7rem;\n    font-weight: 500;\n    letter-spacing: 0;\n}\n\n@keyframes sa-fade-in {\n    from { opacity: 0; transform: translateY(-3px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n.sa-live__event-path {\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.7rem;\n    color: rgba(170,205,170,0.82);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.sa-live__event-meta {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    flex-shrink: 0;\n}\n\n.sa-live__event-flag {\n    font-size: 0.68rem;\n    color: rgba(150,150,155,0.6);\n}\n\n.sa-live__event-level {\n    font-size: 0.58rem;\n    font-weight: 600;\n    padding: 1px 4px;\n    border-radius: 3px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.sa-live__event-level--full {\n    background: rgba(74,222,128,0.12);\n    color: rgba(74,222,128,0.8);\n}\n\n.sa-live__event-level--minimal {\n    background: rgba(var(--sa-accent),0.1);\n    color: rgba(var(--sa-accent),0.7);\n}\n\n.sa-live__event-time {\n    font-size: 0.62rem;\n    color: rgba(var(--sa-text-dim),0.5);\n    font-variant-numeric: tabular-nums;\n    min-width: 28px;\n    text-align: right;\n}\n\n/* ── Cross-site hosts ── */\n.sa-live__hosts { display: flex; flex-direction: column; gap: 6px; }\n\n.sa-live__conversions-wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n.sa-live__conv-total {\n    margin-left: 6px;\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: rgba(74,222,128,0.7);\n}\n.sa-live__conv-list {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n.sa-live__conv-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 8px;\n    border-radius: 6px;\n    background: rgba(74,222,128,0.06);\n    border: 1px solid rgba(74,222,128,0.12);\n}\n.sa-live__conv-label {\n    font-size: 0.78rem;\n    color: rgba(210,240,220,0.85);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 60%;\n}\n.sa-live__conv-right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n.sa-live__conv-value {\n    font-size: 0.72rem;\n    color: rgba(74,222,128,0.75);\n}\n.sa-live__conv-count {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: rgba(74,222,128,0.9);\n    background: rgba(74,222,128,0.12);\n    padding: 1px 6px;\n    border-radius: 10px;\n}\n.sa-live__conv-empty {\n    font-size: 0.75rem;\n    color: rgba(130,130,150,0.45);\n    margin: 0;\n}\n\n/* ── Countries grid used in Audience page ── */\n.sa-aud-countries-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n    padding: 12px;\n    border-radius: 10px;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n}\n\n/* ── Notices ─────────────────────────────────────────────────────────────────── */\n\n.sa-notice {\n    margin: 0;\n    padding: 18px 22px;\n    border-radius: 12px;\n    font-size: 0.9rem;\n    color: rgba(var(--sa-text-secondary),0.85);\n    background: rgba(0,0,0,0.15);\n    border: 1px solid rgba(255,255,255,0.07);\n}\n\n.sa-notice--error {\n    background: rgba(220,80,80,0.08);\n    border-color: rgba(220,100,100,0.25);\n    color: #f5aeae;\n}\n\n/* ── Analytics section nav — underline tab strip (Vercel/Mixpanel style) ──────── */\n\n.sa-subnav {\n    display: flex;\n    align-items: flex-end;\n    gap: 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n    overflow-x: auto;\n    scrollbar-width: none;\n    flex-wrap: nowrap;\n    margin-bottom: 4px;\n    padding-top: 2px;\n}\n\n.sa-subnav::-webkit-scrollbar { display: none; }\n\n.sa-subnav__tab {\n    flex-shrink: 0;\n    padding: 0 4px 11px;\n    margin-right: 28px;\n    border-bottom: 2px solid transparent;\n    margin-bottom: -1px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: rgba(155, 155, 175, 0.6);\n    text-decoration: none;\n    transition: color 0.12s, border-color 0.12s;\n    white-space: nowrap;\n    line-height: 1;\n    letter-spacing: 0.01em;\n}\n\n.sa-subnav__tab:last-child { margin-right: 0; }\n\n.sa-subnav__tab:hover {\n    color: rgba(215, 215, 235, 0.9);\n}\n\n.sa-subnav__tab--active {\n    color: rgba(249, 191, 64, 1);\n    border-bottom-color: rgba(249, 191, 64, 0.75);\n    font-weight: 600;\n}\n\n.sa-subnav__tab--active:hover {\n    color: rgba(249, 191, 64, 1);\n}\n\n/* ── Dashboard mode badge ────────────────────────────────────────────────────── */\n\n/* ── Foreign-domain warning banner ───────────────────────────────────────── */\n\n.sa-foreign-banner {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    background: rgba(251,191,36,0.07);\n    border: 1px solid rgba(251,191,36,0.22);\n    border-radius: var(--sa-radius);\n    font-size: 0.8rem;\n    color: rgba(var(--sa-text),0.75);\n    margin-bottom: 16px;\n}\n\n.sa-foreign-banner__dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: rgba(251,191,36,0.9);\n    flex-shrink: 0;\n    animation: sa-pulse 2s ease-in-out infinite;\n}\n\n.sa-foreign-banner__text {\n    flex: 1;\n    min-width: 0;\n}\n\n.sa-foreign-banner__text strong {\n    color: rgba(251,191,36,0.9);\n    font-weight: 600;\n}\n\n.sa-foreign-banner__link {\n    font-size: 0.78rem;\n    color: rgba(251,191,36,0.85);\n    text-decoration: none;\n    white-space: nowrap;\n    font-weight: 500;\n    flex-shrink: 0;\n}\n\n.sa-foreign-banner__link:hover { text-decoration: underline; }\n\n/* ── Cross-site tracking settings rows ───────────────────────────────────── */\n\n.sa-foreign-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    border-radius: 8px;\n    margin-bottom: 6px;\n    font-size: 0.82rem;\n}\n\n.sa-foreign-row--pending {\n    background: rgba(251,191,36,0.06);\n    border: 1px solid rgba(251,191,36,0.15);\n}\n\n.sa-foreign-row--approved {\n    background: rgba(52,211,153,0.05);\n    border: 1px solid rgba(52,211,153,0.15);\n}\n\n.sa-foreign-row__dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: rgba(52,211,153,0.8);\n    flex-shrink: 0;\n}\n\n.sa-foreign-row__domain {\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.9);\n    flex: 1;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.sa-foreign-row__meta {\n    font-size: 0.75rem;\n    color: rgba(var(--sa-text-secondary),0.45);\n    white-space: nowrap;\n}\n\n.sa-foreign-row__actions {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n}\n\n.sa-btn--approve {\n    background: rgba(52,211,153,0.15);\n    border-color: rgba(52,211,153,0.3);\n    color: rgba(52,211,153,0.9);\n}\n\n.sa-btn--approve:hover {\n    background: rgba(52,211,153,0.22);\n}\n\n/* ── Mode badge ───────────────────────────────────────────────────────────── */\n\n.sa-mode-badge {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.72rem;\n    color: rgba(120,120,140,0.65);\n}\n\n.sa-mode-badge__dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: rgba(249,191,64,0.7);\n    flex-shrink: 0;\n}\n\n.sa-mode-badge strong {\n    color: rgba(var(--sa-text),0.85);\n    font-weight: 600;\n}\n\n.sa-mode-badge__link {\n    color: rgba(var(--sa-accent),0.65);\n    text-decoration: none;\n    margin-left: 4px;\n}\n\n.sa-mode-badge__link:hover {\n    color: rgba(var(--sa-accent),0.9);\n    text-decoration: underline;\n}\n\n/* ── Business type selector cards (Settings) ─────────────────────────────────── */\n\n.sa-biztype-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 8px;\n}\n\n.sa-biztype-card {\n    background: rgba(255,255,255,0.025);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 10px;\n    padding: 13px 15px;\n    text-align: left;\n    cursor: pointer;\n    transition: border-color 0.14s, background 0.14s;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.sa-biztype-card:hover {\n    background: rgba(255,255,255,0.045);\n    border-color: rgba(255,255,255,0.12);\n}\n\n.sa-biztype-card--active {\n    background: rgba(var(--sa-accent),0.05);\n    border-color: rgba(var(--sa-accent),0.35);\n}\n\n.sa-biztype-card__name {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(200,200,220,0.88);\n}\n\n.sa-biztype-card--active .sa-biztype-card__name {\n    color: rgba(249,191,64,0.95);\n}\n\n.sa-biztype-card__tagline {\n    font-size: 0.69rem;\n    color: rgba(120,120,140,0.65);\n    line-height: 1.45;\n}\n\n.sa-biztype-card__pills {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-top: 5px;\n}\n\n.sa-biztype-card__pill {\n    font-size: 0.6rem;\n    font-weight: 600;\n    padding: 2px 7px;\n    border-radius: 3px;\n    background: rgba(255,255,255,0.06);\n    color: rgba(140,140,160,0.72);\n}\n\n.sa-biztype-card--active .sa-biztype-card__pill {\n    background: rgba(var(--sa-accent),0.1);\n    color: rgba(249,191,64,0.82);\n}\n\n/* ── Meta row ────────────────────────────────────────────────────────────────── */\n\n.sa-meta-row {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.sa-site-key-badge {\n    font-size: 0.72rem;\n    color: rgba(var(--sa-text-dim),0.6);\n}\n\n.sa-site-key-badge code {\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.72rem;\n    color: rgba(var(--sa-text-secondary),0.7);\n    background: rgba(255,255,255,0.05);\n    padding: 1px 6px;\n    border-radius: 4px;\n}\n\n/* ── KPI cards ───────────────────────────────────────────────────────────────── */\n\n.sa-kpi {\n    position: relative;\n    padding: 20px 20px 18px 22px;\n    border-radius: var(--sa-radius, 12px);\n    border: 1px solid var(--sa-border, rgba(255,255,255,0.055));\n    background: var(--sa-surface-3, rgba(26,26,36,0.92));\n    box-shadow: var(--sa-shadow-panel);\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    overflow: hidden;\n    transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.sa-kpi:hover {\n    box-shadow: 0 1px 3px rgba(0,0,0,0.5), 0 12px 32px rgba(0,0,0,0.26);\n    border-color: rgba(255,255,255,0.1);\n}\n\n/* Left accent bar — replaces dated top stripe */\n.sa-kpi::before {\n    content: '';\n    position: absolute;\n    top: 14px; left: 0; bottom: 14px;\n    width: 3px;\n    border-radius: 0 3px 3px 0;\n    background: rgba(249, 191, 64, 0.8);\n}\n\n/* Color carries meaning, not decoration: warn = a metric crossed a bad\n   threshold, live = a healthy/active-right-now metric, revenue = money.\n   Every other KPI card keeps the default gold accent bar/icon above —\n   there used to be a positional rainbow here (2nd card blue, 3rd green,\n   4th purple, purely by slot) plus hardcoded blue/purple/teal variants\n   with no actual meaning; removed in favor of one consistent accent. */\n.sa-kpi--warn::before { background: rgba(248,113,113,0.85) !important; }\n.sa-kpi--live::before { background: rgba(74,222,128,0.85) !important; }\n.sa-kpi--revenue::before { background: rgba(52,211,153,0.85) !important; }\n\n.sa-kpi__head {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n}\n\n.sa-kpi__icon {\n    display: inline-flex;\n    color: rgba(var(--sa-accent),0.65);\n}\n\n.sa-kpi--warn .sa-kpi__icon    { color: rgba(248,113,113,0.7) !important; }\n.sa-kpi--live .sa-kpi__icon    { color: rgba(74,222,128,0.7) !important; }\n.sa-kpi--revenue .sa-kpi__icon { color: rgba(52,211,153,0.7) !important; }\n\n.sa-kpi__icon svg {\n    width: 14px;\n    height: 14px;\n}\n\n.sa-icon {\n    width: 14px;\n    height: 14px;\n    flex-shrink: 0;\n    color: rgba(var(--sa-accent),0.6);\n}\n\n.sa-kpi__label {\n    font-size: 0.72rem;\n    font-weight: 500;\n    letter-spacing: 0;\n    text-transform: none;\n    color: rgba(var(--sa-text-muted),0.7);\n}\n\n.sa-kpi__value {\n    font-size: 2rem;\n    font-weight: 700;\n    color: rgba(240, 240, 252, 0.95);\n    line-height: 1;\n    letter-spacing: -0.03em;\n}\n\n.sa-kpi--warn .sa-kpi__value { color: rgba(252,165,55,0.95); }\n\n.sa-kpi__trend {\n    display: inline-block;\n    margin-left: 8px;\n    font-size: 0.7rem;\n    font-weight: 600;\n    letter-spacing: 0;\n    vertical-align: middle;\n}\n\n.sa-kpi__trend--up   { color: rgba(74,222,128,0.9); }\n.sa-kpi__trend--down { color: rgba(248,113,113,0.9); }\n\n.sa-kpi__sub {\n    font-size: 0.69rem;\n    color: rgba(var(--sa-text-dim),0.6);\n    line-height: 1.4;\n}\n\n.sa-kpi__cross-check {\n    display: block;\n    margin-top: 4px;\n    color: rgba(var(--sa-text-dim),0.5);\n}\n\n/* ── Chart section ───────────────────────────────────────────────────────────── */\n\n.sa-chart-section {\n    background: var(--sa-surface-3, rgba(26,26,36,0.92));\n    border: 1px solid var(--sa-border, rgba(255,255,255,0.055));\n    border-radius: var(--sa-radius, 12px);\n    padding: 22px 24px 20px;\n    box-shadow: var(--sa-shadow-panel);\n}\n\n.sa-area-chart { width: 100%; }\n\n.sa-chart-section__hd {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    gap: 12px;\n}\n\n.sa-chart-section__title {\n    margin: 0;\n    font-size: 0.82rem;\n    font-weight: 600;\n    letter-spacing: 0;\n    text-transform: none;\n    color: rgba(var(--sa-text),0.9);\n    display: flex;\n    align-items: center;\n    gap: 7px;\n}\n\n.sa-chart-section__period {\n    font-size: 0.69rem;\n    color: rgba(130,130,150,0.6);\n    white-space: nowrap;\n}\n\n.sa-chart {\n    width: 100%;\n    height: auto;\n    position: relative;\n}\n\n.sa-chart--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.875rem;\n    color: rgba(var(--sa-text-dim),0.6);\n}\n\n.sa-chart__legend {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 8px;\n    font-size: 0.7rem;\n    color: rgba(var(--sa-text-dim),0.65);\n}\n\n.sa-chart__legend-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 2px;\n    flex-shrink: 0;\n}\n\n.sa-chart__legend-dot--full    { background: rgba(74,222,128,0.75); }\n.sa-chart__legend-dot--minimal { background: rgba(var(--sa-accent),0.55); }\n\n.sa-trend-insights {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.sa-trend-insights__chip {\n    font-size: 0.72rem;\n    color: rgba(var(--sa-text-muted),0.75);\n    background: rgba(255,255,255,0.04);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 8px;\n    padding: 4px 10px;\n}\n\n.sa-trend-insights__chip b {\n    color: #ececec;\n    font-weight: 700;\n}\n\n/* ── Dashboard grid ──────────────────────────────────────────────────────────── */\n\n.sa-dashboard-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-areas:\n        \"kpi1   kpi2    kpi3      kpi4\"\n        \"chart  chart   chart     live\"\n        \"pages  pages   consent   countries\"\n        \"brows  brows   utm       utm\"\n        \"os     os      screens   screens\";\n}\n\n.sa-dashboard-grid--no-utm {\n    grid-template-areas:\n        \"kpi1   kpi2    kpi3      kpi4\"\n        \"chart  chart   chart     live\"\n        \"pages  pages   consent   countries\"\n        \"brows  brows   os        screens\";\n}\n\n/* Grid area assignments */\n.sa-ga-kpi0      { grid-area: kpi0; }\n.sa-ga-kpi1      { grid-area: kpi1; }\n.sa-ga-kpi2      { grid-area: kpi2; }\n.sa-ga-kpi3      { grid-area: kpi3; }\n.sa-ga-kpi4      { grid-area: kpi4; }\n.sa-ga-kpi5      { grid-area: kpi5; }\n.sa-ga-chart     { grid-area: chart; align-self: start; }\n.sa-ga-live      { grid-area: live; }\n.sa-ga-pages     { grid-area: pages; }\n.sa-ga-consent   { grid-area: consent; }\n.sa-ga-countries { grid-area: countries; }\n.sa-ga-brows     { grid-area: brows; }\n.sa-ga-utm       { grid-area: utm; }\n.sa-ga-os        { grid-area: os; }\n.sa-ga-screens   { grid-area: screens; }\n\n@media (max-width: 1100px) {\n    .sa-dashboard-grid,\n    .sa-dashboard-grid--no-utm {\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-areas:\n            \"kpi1    kpi2\"\n            \"kpi3    kpi4\"\n            \"chart   chart\"\n            \"live    live\"\n            \"pages   pages\"\n            \"consent countries\"\n            \"brows   utm\"\n            \"os      screens\";\n    }\n    .sa-dashboard-grid--no-utm {\n        grid-template-areas:\n            \"kpi1    kpi2\"\n            \"kpi3    kpi4\"\n            \"chart   chart\"\n            \"live    live\"\n            \"pages   pages\"\n            \"consent countries\"\n            \"brows   brows\"\n            \"os      screens\";\n    }\n}\n\n@media (max-width: 620px) {\n    .sa-dashboard-grid,\n    .sa-dashboard-grid--no-utm {\n        grid-template-columns: 1fr;\n        grid-template-areas:\n            \"kpi1\" \"kpi2\" \"kpi3\" \"kpi4\"\n            \"chart\" \"live\"\n            \"pages\" \"consent\" \"countries\"\n            \"brows\" \"utm\" \"os\" \"screens\";\n    }\n}\n\n/* ── Generic panel card ──────────────────────────────────────────────────────── */\n\n.sa-panel {\n    background: var(--sa-surface-3, rgba(26,26,36,0.92));\n    border: 1px solid var(--sa-border, rgba(255,255,255,0.055));\n    border-radius: var(--sa-radius, 12px);\n    padding: 20px 22px;\n    box-shadow: var(--sa-shadow-panel);\n}\n\n.sa-panel__title {\n    margin: 0 0 14px;\n    font-size: 0.78rem;\n    font-weight: 600;\n    letter-spacing: 0;\n    text-transform: none;\n    color: rgba(var(--sa-text),0.85);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n/* Divider between stacked sub-sections within a panel */\n.sa-panel__divider {\n    height: 1px;\n    background: rgba(255,255,255,0.06);\n    margin: 14px 0;\n}\n\n.sa-panel__sub-title {\n    margin: 0 0 10px;\n    font-size: 0.69rem;\n    font-weight: 600;\n    letter-spacing: 0;\n    text-transform: none;\n    color: rgba(var(--sa-text-dim),0.6);\n}\n\n.sa-panel__consent-note {\n    font-size: 0.62rem;\n    font-weight: 500;\n    color: rgba(var(--sa-text-dim),0.55);\n    text-transform: none;\n    letter-spacing: 0;\n    margin-left: 4px;\n}\n\n.sa-panel__footer-link {\n    display: inline-block;\n    margin-top: 12px;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: rgba(var(--sa-accent),0.9);\n    text-decoration: none;\n}\n\n.sa-panel__footer-link:hover {\n    text-decoration: underline;\n}\n\n.sa-table__link {\n    color: rgba(var(--sa-accent),0.9);\n    text-decoration: none;\n    font-weight: 600;\n}\n\n.sa-table__link:hover {\n    text-decoration: underline;\n}\n\n/* ── Tables ──────────────────────────────────────────────────────────────────── */\n\n.sa-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n}\n\n.sa-table th {\n    text-align: left;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-dim),0.6);\n    padding: 0 8px 8px 0;\n    border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n\n.sa-table td {\n    padding: 7px 8px 7px 0;\n    color: rgba(var(--sa-text),0.88);\n    border-bottom: 1px solid rgba(255,255,255,0.04);\n    vertical-align: middle;\n}\n\n.sa-table tbody tr:last-child td { border-bottom: none; }\n\n.sa-table tbody tr {\n    transition: background 0.1s ease;\n}\n.sa-table tbody tr:hover td {\n    background: rgba(255,255,255,0.025);\n}\n\n.sa-table__num {\n    text-align: right !important;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n    color: rgba(var(--sa-text),0.75);\n}\n\n.sa-table__path {\n    max-width: 200px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.77rem;\n    color: rgba(180,210,180,0.85);\n}\n\n.sa-table__bar {\n    width: 72px;\n    padding-left: 10px !important;\n}\n\n/* ── Table pager ─────────────────────────────────────────────────────────────── */\n\n.sa-pager {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    margin-top: 10px;\n}\n\n.sa-pager__label {\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text-muted),0.75);\n    white-space: nowrap;\n}\n\n/* ── Mini bar ────────────────────────────────────────────────────────────────── */\n\n.sa-mini-bar {\n    height: 5px;\n    border-radius: 3px;\n    background: rgba(255,255,255,0.05);\n    overflow: hidden;\n}\n\n.sa-mini-bar__fill {\n    height: 100%;\n    border-radius: 3px;\n    transition: width 0.3s ease;\n}\n\n/* ── Consent + device bars ───────────────────────────────────────────────────── */\n\n.sa-consent-list {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n}\n\n.sa-consent-row {\n    display: grid;\n    grid-template-columns: max-content 1fr 32px;\n    align-items: center;\n    gap: 10px;\n}\n\n.sa-consent-row__label {\n    font-size: 0.78rem;\n    color: rgba(185,185,185,0.85);\n    white-space: nowrap;\n}\n\n.sa-consent-row__pct {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.7);\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-bar {\n    height: 8px;\n    border-radius: 4px;\n    background: rgba(255,255,255,0.05);\n    overflow: hidden;\n    display: flex;\n}\n\n.sa-bar__seg {\n    height: 100%;\n    transition: width 0.3s ease;\n}\n\n/* ── World map ───────────────────────────────────────────────────────────────── */\n\n.sa-map {\n    margin-bottom: 14px;\n}\n\n.sa-map__inner {\n    width: 100%;\n    height: 100%;\n    min-height: 220px;\n    border-radius: 8px;\n    overflow: hidden;\n    background: rgba(0,0,0,0.12);\n    border: 1px solid rgba(255,255,255,0.05);\n}\n\n.sa-map__caption {\n    margin: 6px 2px 0;\n    font-size: 0.72rem;\n    color: rgba(var(--sa-text-muted),0.65);\n}\n\n.sa-map--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 160px;\n    font-size: 0.875rem;\n    color: rgba(var(--sa-text-dim),0.6);\n    background: rgba(0,0,0,0.1);\n    border: 1px solid rgba(255,255,255,0.05);\n    border-radius: 8px;\n}\n\n/* ── Copy button ─────────────────────────────────────────────────────────────── */\n\n.sa-copy-btn {\n    padding: 5px 13px;\n    border-radius: 8px;\n    border: 1px solid rgba(255,255,255,0.12);\n    background: rgba(255,255,255,0.05);\n    color: rgba(var(--sa-text),0.9);\n    font-size: 0.8rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s;\n    white-space: nowrap;\n}\n\n.sa-copy-btn:hover { background: rgba(255,255,255,0.09); border-color: rgba(255,255,255,0.2); }\n.sa-copy-btn--done { background: rgba(74,222,128,0.12); border-color: rgba(74,222,128,0.3); color: #6ee7a0; }\n\n/* ── Setup / empty state card ────────────────────────────────────────────────── */\n\n.sa-setup {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 16px;\n    padding: 56px 32px;\n    border-radius: 16px;\n    border: 1px dashed rgba(255,255,255,0.1);\n    background: rgba(0,0,0,0.1);\n}\n\n.sa-setup__icon { color: rgba(var(--sa-accent),0.8); }\n\n.sa-setup__icon svg {\n    width: 36px;\n    height: 36px;\n}\n\n.sa-setup__title {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: #ececec;\n}\n\n.sa-setup__body {\n    margin: 0;\n    max-width: 520px;\n    font-size: 0.9rem;\n    line-height: 1.65;\n    color: rgba(175,175,175,0.85);\n}\n\n.sa-setup__loading {\n    margin: 0;\n    font-size: 0.875rem;\n    color: rgba(var(--sa-text-muted),0.65);\n}\n\n.sa-setup__gen-btn {\n    display: inline-flex;\n    align-items: center;\n    padding: 10px 24px;\n    border-radius: 10px;\n    border: 1px solid rgba(var(--sa-accent),0.45);\n    background: rgba(var(--sa-accent),0.1);\n    color: rgba(227,200,130,0.95);\n    font-size: 0.9rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s;\n}\n\n.sa-setup__gen-btn:hover:not(:disabled) {\n    background: rgba(var(--sa-accent),0.2);\n    border-color: rgba(var(--sa-accent),0.65);\n}\n\n.sa-setup__gen-btn:disabled { opacity: 0.45; cursor: not-allowed; }\n\n.sa-setup__snippet-wrap {\n    width: 100%;\n    max-width: 640px;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.sa-setup__snippet-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.sa-setup__snippet-label {\n    font-size: 0.7rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-accent),0.8);\n}\n\n.sa-setup__snippet {\n    margin: 0;\n    padding: 14px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(255,255,255,0.07);\n    background: rgba(0,0,0,0.28);\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.78rem;\n    line-height: 1.7;\n    color: #c9e9a0;\n    white-space: pre-wrap;\n    word-break: break-all;\n}\n\n.sa-setup__hint {\n    margin: 0;\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text-dim),0.65);\n    line-height: 1.5;\n}\n\n.sa-setup__hint code {\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.82em;\n    background: rgba(255,255,255,0.07);\n    border-radius: 4px;\n    padding: 1px 5px;\n    color: #d4b896;\n}\n\n/* ── Overview bento layout ────────────────────────────────────────────────────── */\n\n.sa-overview {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n/* KPI strip — equal-width cards, expands to 6 when quality-leads is present */\n.sa-kpi-strip-wrap {\n    position: relative;\n}\n.sa-kpi-strip {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 12px;\n}\n.sa-kpi-strip--4 {\n    grid-template-columns: repeat(4, 1fr);\n}\n.sa-kpi-strip--6 {\n    grid-template-columns: repeat(6, 1fr);\n}\n\n.sa-customize-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    margin-top: 8px;\n    padding: 4px 10px;\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 6px;\n    background: transparent;\n    color: rgba(180,180,200,0.6);\n    font-size: 0.72rem;\n    cursor: pointer;\n    transition: color 0.15s, border-color 0.15s;\n}\n.sa-customize-btn:hover {\n    color: rgba(200,200,220,0.9);\n    border-color: rgba(255,255,255,0.2);\n}\n\n.sa-customize-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 200;\n    background: rgba(0,0,0,0.45);\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    padding-top: 120px;\n}\n.sa-customize-panel {\n    background: #1e1e2e;\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 12px;\n    width: 340px;\n    padding: 20px;\n    box-shadow: 0 20px 60px rgba(0,0,0,0.6);\n}\n.sa-customize-panel__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 6px;\n}\n.sa-customize-panel__title {\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: rgba(220,220,240,0.95);\n}\n.sa-customize-panel__close {\n    background: none;\n    border: none;\n    color: rgba(180,180,200,0.5);\n    font-size: 0.85rem;\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n.sa-customize-panel__close:hover { color: rgba(220,220,240,0.9); }\n.sa-customize-panel__sub {\n    font-size: 0.75rem;\n    color: rgba(150,150,175,0.6);\n    margin: 0 0 14px;\n}\n.sa-customize-panel__list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 16px;\n}\n.sa-customize-panel__item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 10px;\n    border-radius: 8px;\n    cursor: pointer;\n    border: 1px solid transparent;\n    transition: background 0.12s, border-color 0.12s;\n}\n.sa-customize-panel__item:hover {\n    background: rgba(255,255,255,0.04);\n}\n.sa-customize-panel__item--on {\n    background: rgba(96,165,250,0.07);\n    border-color: rgba(96,165,250,0.2);\n}\n.sa-customize-panel__check {\n    width: 15px;\n    height: 15px;\n    flex-shrink: 0;\n    accent-color: rgba(96,165,250,0.9);\n    cursor: pointer;\n}\n.sa-customize-panel__item-label {\n    font-size: 0.82rem;\n    font-weight: 500;\n    color: rgba(210,210,230,0.9);\n    flex: 1;\n}\n.sa-customize-panel__item-desc {\n    font-size: 0.72rem;\n    color: rgba(140,140,165,0.55);\n}\n.sa-customize-panel__actions {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n}\n.sa-customize-panel__reset {\n    padding: 6px 12px;\n    border-radius: 6px;\n    border: 1px solid rgba(255,255,255,0.1);\n    background: transparent;\n    color: rgba(160,160,185,0.7);\n    font-size: 0.78rem;\n    cursor: pointer;\n}\n.sa-customize-panel__reset:hover { color: rgba(200,200,220,0.9); }\n.sa-customize-panel__apply {\n    padding: 6px 14px;\n    border-radius: 6px;\n    border: none;\n    background: rgba(96,165,250,0.85);\n    color: #fff;\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n.sa-customize-panel__apply:hover { background: rgba(96,165,250,1); }\n\n/* Row 1: main chart (60 %) + live feed (40 %) */\n.sa-overview-main {\n    display: grid;\n    grid-template-columns: 3fr 2fr;\n    gap: 12px;\n    align-items: start;\n}\n\n/* Row 2: world-map (wide) | top countries | devices */\n.sa-overview-geo {\n    display: grid;\n    grid-template-columns: 2.2fr 2fr 1.5fr;\n    gap: 12px;\n    align-items: start;\n}\n\n/* Row 3: traffic sources | top pages */\n.sa-overview-bottom {\n    display: grid;\n    grid-template-columns: 5fr 4fr;\n    gap: 12px;\n    align-items: start;\n}\n\n@media (max-width: 1200px) {\n    .sa-kpi-strip    { grid-template-columns: repeat(3, 1fr); }\n    .sa-kpi-strip--4 { grid-template-columns: repeat(2, 1fr); }\n    .sa-kpi-strip--6 { grid-template-columns: repeat(3, 1fr); }\n    .sa-overview-geo { grid-template-columns: 1fr 1fr; }\n}\n\n@media (max-width: 900px) {\n    .sa-overview-main   { grid-template-columns: 1fr; }\n    .sa-overview-bottom { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 680px) {\n    .sa-kpi-strip, .sa-kpi-strip--4, .sa-kpi-strip--6 { grid-template-columns: repeat(2, 1fr); }\n    .sa-overview-geo { grid-template-columns: 1fr; }\n}\n\n/* ── Audience sub-page grid ──────────────────────────────────────────────────── */\n\n.sa-audience-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-areas:\n        \"kpis       kpis\"\n        \"nvr        nvr\"\n        \"interests  interests\"\n        \"countries  countries\"\n        \"browsers   os\"\n        \"screens    devices\"\n        \"lang       tz\";\n}\n\n.sa-aud-kpis      { grid-area: kpis;      display: flex; gap: 12px; flex-wrap: wrap; }\n.sa-aud-kpis .sa-kpi { flex: 1 1 200px; }\n.sa-aud-nvr       { grid-area: nvr;       }\n.sa-aud-interests  { grid-area: interests; }\n.sa-aud-countries { grid-area: countries; }\n.sa-aud-browsers  { grid-area: browsers;  }\n.sa-aud-os        { grid-area: os;        }\n.sa-aud-devices   { grid-area: devices;   }\n.sa-aud-screens   { grid-area: screens;   }\n.sa-aud-lang      { grid-area: lang;      }\n.sa-aud-tz        { grid-area: tz;        }\n\n/* ── Interest rule rows (engagement-scored on/off-topic split) ───────────── */\n\n.sa-int-rules-list {\n    display: flex;\n    flex-direction: column;\n}\n\n.sa-int-rule-row {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 11px 0;\n    border-bottom: 1px solid rgba(255,255,255,0.05);\n}\n.sa-int-rule-row:last-of-type { border-bottom: none; }\n\n.sa-int-rule-row__header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.sa-int-rule-row__label {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba(220,230,245,0.9);\n    flex: 1;\n    min-width: 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.sa-int-rule-row__stats {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    font-size: 0.78rem;\n    color: rgba(180,180,200,0.5);\n    flex-shrink: 0;\n}\n.sa-int-rule-row__score {\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-int-rule-row__bar {\n    height: 8px;\n    background: rgba(255,255,255,0.06);\n    border-radius: 4px;\n    overflow: hidden;\n}\n.sa-int-rule-row__bar-on {\n    height: 100%;\n    background: rgba(16,185,129,0.55);\n    border-radius: 4px;\n    transition: width 0.4s ease;\n    min-width: 2px;\n}\n\n.sa-int-rule-row__legend {\n    display: flex;\n    gap: 14px;\n    font-size: 0.75rem;\n    font-variant-numeric: tabular-nums;\n}\n.sa-int-rule-row__on  { color: rgba(16,185,129,0.75); }\n.sa-int-rule-row__off { color: rgba(180,180,200,0.38); }\n\n/* ── Skeleton / shimmer loader ─────────────────────────────────────────────── */\n@keyframes sa-shimmer {\n    0%   { background-position: -200% 0; }\n    100% { background-position:  200% 0; }\n}\n.sa-skeleton {\n    border-radius: 4px;\n    background: linear-gradient(\n        90deg,\n        rgba(255,255,255,0.04) 25%,\n        rgba(255,255,255,0.09) 50%,\n        rgba(255,255,255,0.04) 75%\n    );\n    background-size: 200% 100%;\n    animation: sa-shimmer 1.5s ease-in-out infinite;\n    flex-shrink: 0;\n}\n.sa-skeleton-rows {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    padding: 4px 0;\n}\n.sa-skeleton-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n/* ── Shared dark-theme form primitives (interest rules, etc.) ──────────────── */\n\n.ia-input {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 6px;\n    color: rgba(220,230,245,0.9);\n    font-size: 0.83rem;\n    padding: 7px 10px;\n    width: 100%;\n    outline: none;\n    box-sizing: border-box;\n    transition: border-color 0.15s;\n}\n.ia-input::placeholder {\n    color: rgba(180,180,200,0.35);\n}\n.ia-input:focus {\n    border-color: rgba(var(--sa-accent),0.5);\n}\n\n.ia-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    border-radius: 6px;\n    font-size: 0.82rem;\n    font-weight: 600;\n    padding: 7px 14px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: opacity 0.15s;\n}\n.ia-btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n}\n.ia-btn--primary {\n    background: rgba(var(--sa-accent),0.7);\n    color: #111118;\n}\n.ia-btn--primary:not(:disabled):hover {\n    background: rgba(var(--sa-accent),0.9);\n}\n\n.sa-interest-form {\n    display: grid;\n    grid-template-columns: 1fr 1fr auto auto;\n    gap: 10px;\n    align-items: end;\n    margin-top: 4px;\n}\n\n@media (max-width: 700px) {\n    .sa-interest-form {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n\n/* ── Error boundary inline card ──────────────────────────────────────────── */\n\n.sa-boundary-error {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 14px;\n    border-radius: 6px;\n    background: rgba(239,68,68,0.08);\n    border: 1px solid rgba(239,68,68,0.2);\n    color: rgba(252,165,165,0.85);\n    font-size: 13px;\n}\n.sa-boundary-error__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: rgba(239,68,68,0.25);\n    color: rgba(252,165,165,0.9);\n    font-size: 11px;\n    font-weight: 700;\n    flex-shrink: 0;\n}\n\n.sa-aud-nvr-bars { display: flex; gap: 8px; }\n.sa-aud-nvr-bars > div { flex: 1; }\n\n@media (max-width: 620px) {\n    .sa-audience-grid {\n        grid-template-columns: 1fr;\n        grid-template-areas:\n            \"kpis\" \"nvr\" \"interests\" \"countries\" \"browsers\" \"os\"\n            \"devices\" \"screens\" \"lang\" \"tz\";\n    }\n    .sa-aud-nvr-bars { flex-direction: column; }\n    .sa-int-rule-row__stats { gap: 5px; font-size: 0.72rem; }\n}\n\n/* ── User flow diagram ────────────────────────────────────────────────────────── */\n\n.sa-flow-scroll {\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding-bottom: 4px;\n}\n\n.sa-flow-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n    margin-bottom: 14px;\n}\n\n.sa-flow-tabs {\n    display: flex;\n    gap: 4px;\n    background: rgba(255, 255, 255, 0.04);\n    border-radius: 8px;\n    padding: 3px;\n}\n\n.sa-flow-tab {\n    background: transparent;\n    border: none;\n    color: rgba(var(--sa-text-secondary),0.7);\n    font-size: 0.76rem;\n    padding: 6px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.sa-flow-tab.--active {\n    background: rgba(var(--sa-accent), 0.18);\n    color: rgba(230, 210, 160, 0.95);\n}\n\n.sa-flow-clear {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    margin-bottom: 10px;\n    padding: 5px 12px;\n    background: rgba(var(--sa-accent), 0.14);\n    border: 1px solid rgba(var(--sa-accent), 0.35);\n    border-radius: 999px;\n    color: rgba(230, 210, 160, 0.95);\n    font-size: 0.75rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.sa-flow-clear:hover {\n    background: rgba(var(--sa-accent), 0.22);\n}\n\n.sa-flow-trace-loading {\n    display: inline-block;\n    margin-bottom: 10px;\n    margin-left: 8px;\n    font-size: 0.75rem;\n    color: rgba(var(--sa-text-secondary),0.6);\n}\n\n/* ── Google Analytics sub-page stack ─────────────────────────────────────────── */\n\n.sa-ga4-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.ga4-two-col {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px;\n}\n\n@media (max-width: 700px) {\n    .ga4-two-col { grid-template-columns: 1fr; }\n}\n\n/* New vs Returning */\n.ga4-nvr {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.ga4-nvr__bar-track {\n    display: flex;\n    height: 8px;\n    border-radius: 4px;\n    overflow: hidden;\n    background: rgba(255,255,255,0.05);\n}\n.ga4-nvr__bar-new {\n    background: rgba(96,165,250,0.55);\n    border-radius: 4px 0 0 4px;\n    transition: width 0.4s ease;\n}\n.ga4-nvr__bar-ret {\n    background: rgba(52,211,153,0.45);\n    border-radius: 0 4px 4px 0;\n    transition: width 0.4s ease;\n}\n.ga4-nvr__legend {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text-muted),0.7);\n}\n.ga4-nvr__dot {\n    width: 8px; height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n.ga4-nvr__dot--new { background: rgba(96,165,250,0.7); }\n.ga4-nvr__dot--ret { background: rgba(52,211,153,0.6); }\n.ga4-nvr__label strong { color: rgba(210,215,230,0.9); }\n.ga4-nvr__label { margin-right: 8px; }\n\n/* Channel table inline bar */\n.ga4-ch-bar-cell {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 140px;\n}\n.ga4-ch-bar-track {\n    flex: 1;\n    height: 5px;\n    background: rgba(255,255,255,0.05);\n    border-radius: 3px;\n    overflow: hidden;\n}\n.ga4-ch-bar-fill {\n    height: 100%;\n    background: rgba(145,158,180,0.35);\n    border-radius: 3px;\n    transition: width 0.3s ease;\n}\n.ga4-ch-bar-pct {\n    font-size: 0.72rem;\n    color: rgba(145,158,180,0.55);\n    white-space: nowrap;\n    min-width: 36px;\n    text-align: right;\n}\n\n/* ── Search Console sub-page stack ───────────────────────────────────────────── */\n\n.sa-gsc-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n/* Generic KPI row — a flat strip of KpiCards, for pages (Search Console,\n   Audience, Acquisition) that don't need a named-grid-area layout. */\n.sa-kpi-row {\n    display: flex;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.sa-kpi-row .sa-kpi {\n    flex: 1 1 200px;\n}\n\n/* ── Acquisition sub-page grid ───────────────────────────────────────────────── */\n\n.sa-acq-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-areas:\n        \"kpis      kpis\"\n        \"pages     utm\"\n        \"referrers hosts\";\n}\n\n.sa-acq-kpis      { grid-area: kpis; display: flex; gap: 12px; flex-wrap: wrap; }\n.sa-acq-kpis .sa-kpi { flex: 1 1 200px; }\n.sa-acq-pages     { grid-area: pages;     }\n.sa-acq-utm       { grid-area: utm;       }\n.sa-acq-referrers { grid-area: referrers; }\n.sa-acq-hosts     { grid-area: hosts;     }\n\n@media (max-width: 760px) {\n    .sa-acq-grid {\n        grid-template-columns: 1fr;\n        grid-template-areas: \"kpis\" \"pages\" \"utm\" \"referrers\" \"hosts\";\n    }\n}\n\n/* ── Ad Spend sub-page grid ──────────────────────────────────────────────────── */\n\n.sa-as-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n    grid-template-columns: repeat(3, 1fr);\n    grid-template-areas:\n        \"kpi0      kpi1      kpi2\"\n        \"chart     chart     chart\"\n        \"platforms platforms platforms\"\n        \"domains   domains   domains\";\n}\n\n.sa-as-kpi0      { grid-area: kpi0; }\n.sa-as-kpi1      { grid-area: kpi1; }\n.sa-as-kpi2      { grid-area: kpi2; }\n.sa-as-chart     { grid-area: chart; align-self: start; }\n.sa-as-platforms { grid-area: platforms; }\n.sa-as-domains   { grid-area: domains; }\n\n@media (max-width: 760px) {\n    .sa-as-grid {\n        grid-template-columns: 1fr;\n        grid-template-areas: \"kpi0\" \"kpi1\" \"kpi2\" \"chart\" \"platforms\" \"domains\";\n    }\n}\n\n.sa-channel-cards {\n    display: grid;\n    gap: 14px;\n    grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));\n    margin-top: 12px;\n}\n\n.sa-channel-card {\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.06);\n    border-radius: 10px;\n    padding: 12px 14px 14px;\n}\n\n.sa-channel-card__title {\n    margin: 0 0 10px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.85);\n}\n\n.sa-channel-card__tiles {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 6px;\n    margin-bottom: 10px;\n}\n\n.sa-channel-tile {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding: 8px 10px;\n    border-radius: 8px;\n    border: none;\n    background: rgba(255,255,255,0.05);\n    cursor: pointer;\n    text-align: left;\n    font: inherit;\n}\n\n.sa-channel-tile--active {\n    box-shadow: 0 0 0 1px rgba(255,255,255,0.15) inset;\n}\n\n.sa-channel-tile--active .sa-channel-tile__label,\n.sa-channel-tile--active .sa-channel-tile__value {\n    color: #fff;\n}\n\n.sa-channel-tile--static {\n    cursor: default;\n}\n\n.sa-channel-tile__label {\n    font-size: 0.62rem;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-secondary),0.7);\n}\n\n.sa-channel-tile__value {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: rgba(230,230,230,0.92);\n}\n\n@media (max-width: 620px) {\n    .sa-channel-card__tiles {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n/* ── Consent sub-page grid ───────────────────────────────────────────────────── */\n\n.sa-consent-page-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-areas:\n        \"kpi1 kpi2 kpi3 kpi4\"\n        \"bars bars bars bars\";\n}\n\n.sa-cg-kpi1 { grid-area: kpi1; }\n.sa-cg-kpi2 { grid-area: kpi2; }\n.sa-cg-kpi3 { grid-area: kpi3; }\n.sa-cg-kpi4 { grid-area: kpi4; }\n.sa-cg-bars { grid-area: bars; }\n\n@media (max-width: 1100px) {\n    .sa-consent-page-grid {\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-areas:\n            \"kpi1 kpi2\"\n            \"kpi3 kpi4\"\n            \"bars bars\";\n    }\n}\n\n@media (max-width: 620px) {\n    .sa-consent-page-grid {\n        grid-template-columns: 1fr;\n        grid-template-areas:\n            \"kpi1\" \"kpi2\" \"kpi3\" \"kpi4\" \"bars\";\n    }\n}\n\n/* ── Heatmap sub-page grid ───────────────────────────────────────────────────── */\n\n/* Screenshot is the hero — fixed 340 px sidebar holds data panels;\n   viewport takes all remaining width. */\n.sa-heatmap-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n    grid-template-columns: 1fr 340px;\n    grid-template-areas:\n        \"controls controls\"\n        \"viewport sidecar\";\n}\n\n.sa-heatmap__controls {\n    grid-area: controls;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n/* Path selector stretches to fill available space in the controls row */\n.sa-heatmap__path-select { flex: 1; min-width: 180px; }\n\n/* ── Viewport — the hero screenshot area ── */\n.sa-heatmap__viewport {\n    grid-area: viewport;\n    display: flex;\n    flex-direction: column;\n    border-radius: 12px;\n    overflow: hidden;\n    background: rgba(0,0,0,0.22);\n    border: 1px solid rgba(255,255,255,0.07);\n    /* Always fill most of the screen so the screenshot is the main attraction */\n    min-height: calc(100vh - 210px);\n}\n\n/* Thin amber label strip — replaces the heavy panel h3 */\n.sa-heatmap__viewport-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 11px 16px;\n    font-size: 0.78rem;\n    font-weight: 500;\n    color: rgba(var(--sa-accent),0.85);\n    border-bottom: 1px solid rgba(255,255,255,0.06);\n    flex-shrink: 0;\n}\n\n/* ── Data sidebar ── */\n.sa-heatmap__sidecar {\n    grid-area: sidecar;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n/* ≤ 1500px — covers all 13\" MacBook variants (1280–1470 px logical).\n   Viewport is full-width hero; sidecar panels sit side-by-side below. */\n@media (max-width: 1500px) {\n    .sa-heatmap-grid {\n        grid-template-columns: 1fr;\n        grid-template-areas:\n            \"controls\"\n            \"viewport\"\n            \"sidecar\";\n    }\n    .sa-heatmap__sidecar { flex-direction: row; }\n    .sa-heatmap__sidecar > .sa-panel { flex: 1; min-width: 0; }\n}\n\n@media (max-width: 900px) {\n    .sa-heatmap__sidecar { flex-direction: column; }\n    .sa-heatmap__sidecar > .sa-panel { flex: none; }\n}\n\n.sa-select {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 8px;\n    color: rgba(var(--sa-text),0.9);\n    font-size: 0.82rem;\n    padding: 7px 10px;\n    min-width: 220px;\n}\n\n.sa-heatmap__device-tabs {\n    display: flex;\n    gap: 4px;\n    background: rgba(255,255,255,0.04);\n    border-radius: 8px;\n    padding: 3px;\n}\n\n.sa-heatmap__device-tab {\n    background: transparent;\n    border: none;\n    color: rgba(var(--sa-text-secondary),0.7);\n    font-size: 0.76rem;\n    padding: 6px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.sa-heatmap__device-tab.--active {\n    background: rgba(var(--sa-accent),0.18);\n    color: rgba(230,210,160,0.95);\n}\n\n/* frame-outer fills the viewport panel via flex: 1; the parent's min-height\n   is the floor. min-height: 0 overrides the browser default so flexbox can\n   actually shrink it when the viewport panel is smaller than the screenshot. */\n.sa-heatmap__frame-outer {\n    flex: 1;\n    min-height: 0;\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(var(--sa-accent),0.35) rgba(0,0,0,0.18);\n}\n.sa-heatmap__frame-outer::-webkit-scrollbar       { width: 5px; }\n.sa-heatmap__frame-outer::-webkit-scrollbar-track { background: rgba(0,0,0,0.18); }\n.sa-heatmap__frame-outer::-webkit-scrollbar-thumb { background: rgba(var(--sa-accent),0.35); border-radius: 3px; }\n\n/* Positioning context for the SVG overlay — no overflow: hidden so the\n   scroll container (frame-outer) handles clipping. */\n.sa-heatmap__frame-wrap {\n    position: relative;\n    width: 100%;\n}\n\n.sa-heatmap__frame-img {\n    display: block;\n    width: 100%;\n    height: auto;\n    pointer-events: none;\n    user-select: none;\n}\n\n.sa-heatmap__frame-fallback {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 24px;\n    font-size: 0.8rem;\n    color: rgba(var(--sa-text-muted),0.6);\n}\n.sa-heatmap__frame-fallback.--error { color: #f5aeae; }\n\n/* Height is injected via inline style (JS calculates rendered image height)\n   so the viewBox maps precisely to the full image, not just the visible area. */\n.sa-heatmap__overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    pointer-events: none;\n}\n\n.sa-scroll-funnel {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n}\n\n/* ── Recording player ────────────────────────────────────────────────────────── */\n\n.sa-recording-player {\n    width: 100%;\n    min-height: 520px;\n    display: flex;\n    justify-content: center;\n}\n\n/* ── Bots sub-page grid ──────────────────────────────────────────────────────── */\n\n.sa-bots-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-areas:\n        \"kpi1  kpi2  category   category\"\n        \"list  list  list       list\"\n        \"asns  asns  suspicious suspicious\"\n        \"pages pages recent     recent\";\n}\n\n.sa-bots-kpi1       { grid-area: kpi1;       }\n.sa-bots-kpi2       { grid-area: kpi2;       }\n.sa-bots-category   { grid-area: category;   }\n.sa-bots-list       { grid-area: list;       }\n.sa-bots-asns       { grid-area: asns;       }\n.sa-bots-suspicious { grid-area: suspicious; }\n.sa-bots-pages      { grid-area: pages;      }\n.sa-bots-recent     { grid-area: recent;     }\n\n@media (max-width: 1100px) {\n    .sa-bots-grid {\n        grid-template-columns: repeat(2, 1fr);\n        grid-template-areas:\n            \"kpi1       kpi2\"\n            \"category   category\"\n            \"list       list\"\n            \"asns       suspicious\"\n            \"pages      pages\"\n            \"recent     recent\";\n    }\n}\n\n@media (max-width: 620px) {\n    .sa-bots-grid {\n        grid-template-columns: 1fr;\n        grid-template-areas:\n            \"kpi1\" \"kpi2\" \"category\" \"list\" \"asns\" \"suspicious\" \"pages\" \"recent\";\n    }\n}\n\n/* ── Conversions section (ConversionsPanel, embedded on the Overview page) ───── */\n\n.sa-section {\n    background: rgba(26,26,30,0.75);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 14px;\n    padding: 18px 20px;\n    box-shadow: 0 2px 12px rgba(0,0,0,0.18);\n}\n\n.sa-panel__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 14px;\n}\n\n.sa-section__title {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-muted),0.65);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.sa-panel__sub {\n    color: rgba(var(--sa-text-dim),0.55);\n    font-size: 0.82rem;\n    margin: 0;\n}\n\n.sa-add-event-btn {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background: rgba(var(--sa-accent),0.12);\n    border: 1px solid rgba(var(--sa-accent),0.3);\n    color: rgba(230,210,160,0.95);\n    font-size: 0.78rem;\n    font-weight: 600;\n    padding: 7px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.sa-add-event-btn:hover {\n    background: rgba(var(--sa-accent),0.2);\n}\n\n.sa-event-form {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 14px;\n    margin-bottom: 14px;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 10px;\n}\n\n.sa-event-form__input,\n.sa-event-form__select {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 8px;\n    color: rgba(var(--sa-text),0.9);\n    font-size: 0.82rem;\n    padding: 7px 10px;\n}\n\n.sa-event-form__input {\n    flex: 1;\n    min-width: 160px;\n}\n\n.sa-event-form__submit {\n    background: rgba(var(--sa-accent),0.55);\n    border: none;\n    color: #1a1a1e;\n    font-weight: 600;\n    font-size: 0.82rem;\n    padding: 7px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.sa-event-form__submit:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.sa-event-form__hint {\n    flex-basis: 100%;\n    margin: 2px 0 0;\n    font-size: 0.76rem;\n    color: rgba(var(--sa-accent),0.85);\n}\n\n.sa-events-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.sa-event-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 12px 4px;\n    border-bottom: 1px solid rgba(255,255,255,0.05);\n}\n\n.sa-event-row:last-child { border-bottom: none; }\n\n.sa-event-row__icon {\n    color: rgba(var(--sa-accent),0.8);\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.sa-event-row__icon svg { width: 18px; height: 18px; }\n\n.sa-event-row__body { flex: 1; min-width: 0; }\n\n.sa-event-row__top {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.sa-event-row__name {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.92);\n}\n\n.sa-event-row__kind {\n    font-size: 0.62rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-muted),0.65);\n    background: rgba(255,255,255,0.05);\n    padding: 2px 6px;\n    border-radius: 4px;\n}\n\n.sa-event-row__unregistered {\n    font-size: 0.68rem;\n    color: rgba(220,160,60,0.85);\n}\n\n.sa-event-row__stats {\n    display: flex;\n    gap: 14px;\n    margin-top: 4px;\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text-secondary),0.75);\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-event-row__consent-note {\n    color: rgba(var(--sa-text-dim),0.55);\n}\n\n.sa-event-row__toggles {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-top: 6px;\n    margin-left: -8px;\n}\n\n.sa-event-row__snippet-toggle {\n    background: none;\n    border: none;\n    color: rgba(150,180,220,0.75);\n    font-size: 0.72rem;\n    padding: 6px 8px;\n    min-height: 32px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.sa-event-row__snippet-toggle:hover { background: rgba(255,255,255,0.06); }\n\n.sa-event-row__snippet {\n    margin-top: 6px;\n    padding: 8px 10px;\n    background: rgba(0,0,0,0.25);\n    border-radius: 6px;\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.74rem;\n    color: rgba(180,210,180,0.85);\n    overflow-x: auto;\n}\n\n.sa-event-row__payloads {\n    margin-top: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.sa-event-row__payloads-empty {\n    font-size: 0.74rem;\n    color: rgba(var(--sa-text-muted),0.65);\n}\n\n.sa-event-row__payload {\n    padding: 8px 10px;\n    background: rgba(0,0,0,0.25);\n    border-radius: 6px;\n}\n\n.sa-event-row__payload-meta {\n    display: flex;\n    gap: 10px;\n    font-size: 0.68rem;\n    color: rgba(var(--sa-text-muted),0.7);\n    font-variant-numeric: tabular-nums;\n    margin-bottom: 4px;\n}\n\n.sa-event-row__payload-path {\n    color: rgba(150,180,220,0.75);\n    overflow-wrap: anywhere;\n}\n\n.sa-event-row__payload-data {\n    margin: 0;\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.74rem;\n    color: rgba(180,210,180,0.85);\n    overflow-x: auto;\n}\n\n.sa-event-row__delete {\n    background: none;\n    border: none;\n    color: rgba(200,120,120,0.6);\n    cursor: pointer;\n    padding: 4px;\n    flex-shrink: 0;\n}\n\n.sa-event-row__delete:hover { color: rgba(230,140,140,0.9); }\n.sa-event-row__delete svg { width: 16px; height: 16px; }\n\n/* ── Funnel builder ───────────────────────────────────────────────────────────── */\n\n.sa-funnel-form { flex-direction: column; align-items: stretch; }\n\n.sa-funnel-form__steps {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n}\n\n.sa-funnel-form__step {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.sa-funnel-form__step-index {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: rgba(var(--sa-accent),0.16);\n    color: rgba(230,210,160,0.95);\n    font-size: 0.72rem;\n    font-weight: 700;\n}\n\n.sa-funnel-form__step-actions {\n    display: flex;\n    gap: 4px;\n    margin-left: auto;\n}\n\n.sa-funnel-form__step-actions button {\n    background: none;\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 6px;\n    color: rgba(var(--sa-text),0.8);\n    font-size: 0.78rem;\n    padding: 4px 7px;\n    cursor: pointer;\n}\n\n.sa-funnel-form__step-actions button:hover:not(:disabled) { border-color: rgba(var(--sa-accent),0.4); color: rgba(230,210,160,0.95); }\n.sa-funnel-form__step-actions button:disabled { opacity: 0.35; cursor: not-allowed; }\n.sa-funnel-form__step-actions button svg { width: 14px; height: 14px; }\n\n.sa-funnel-form__actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 4px;\n}\n\n.sa-funnel-form__cancel {\n    background: none;\n    border: none;\n    color: rgba(150,180,220,0.75);\n    font-size: 0.8125rem;\n    cursor: pointer;\n    padding: 0;\n}\n\n.sa-funnel-form__cancel:hover { color: rgba(180,205,235,0.95); }\n\n/* ── Quality leads KPI (only rendered once lead quality is configured) ───────── */\n\n.sa-lead-kpi-wrap {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n}\n\n.sa-lead-kpi-wrap > .sa-kpi {\n    grid-column: span 1;\n}\n\n@media (max-width: 1100px) {\n    .sa-lead-kpi-wrap { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 620px) {\n    .sa-lead-kpi-wrap { grid-template-columns: 1fr; }\n}\n\n/* ── Conversions sub-page submenu (same visual language as the app's\n   Settings sidebar — vertical list, gold inset-left-border active state —\n   scoped to this page instead of the global fixed SideNav) ─────────────── */\n\n.sa-conv-layout {\n    display: flex;\n    align-items: flex-start;\n    gap: 24px;\n}\n\n.sa-conv-submenu {\n    flex: 0 0 180px;\n    position: sticky;\n    top: 16px;\n}\n\n.sa-conv-submenu__list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.sa-conv-submenu__item {\n    margin: 0;\n}\n\n.sa-conv-submenu__link {\n    display: block;\n    width: 100%;\n    text-align: left;\n    appearance: none;\n    border: none;\n    background: transparent;\n    color: rgba(var(--sa-text-muted),0.75);\n    font-size: 0.82rem;\n    font-weight: 600;\n    padding: 9px 12px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.sa-conv-submenu__link:hover:not(.--active) {\n    background-color: rgba(255,255,255,0.06);\n    color: rgb(255,255,255);\n}\n\n.sa-conv-submenu__link.--active {\n    background: rgba(255,255,255,0.08);\n    color: rgb(255,255,255);\n    box-shadow: inset 3px 0 0 0 rgb(var(--sa-accent));\n}\n\n.sa-conv-submenu-content {\n    flex: 1;\n    min-width: 0;\n}\n\n@media (max-width: 900px) {\n    .sa-conv-layout {\n        flex-direction: column;\n        gap: 12px;\n    }\n    .sa-conv-submenu {\n        flex: none;\n        width: 100%;\n        position: static;\n    }\n    .sa-conv-submenu__list {\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n    .sa-conv-submenu__link.--active {\n        box-shadow: inset 0 -3px 0 0 rgb(var(--sa-accent));\n    }\n}\n\n/* ── Conversions sub-page grid ────────────────────────────────────────────────── */\n\n.sa-conv-grid {\n    display: grid;\n    gap: 12px;\n    align-items: start;\n}\n\n.sa-conv-grid--overview {\n    grid-template-columns: 1fr 1fr;\n    grid-template-areas:\n        \"kpi1  kpi2\"\n        \"trend trend\"\n        \"map   map\";\n}\n\n.sa-conv-grid--deepdive {\n    grid-template-columns: 1fr 1fr;\n    grid-template-areas:\n        \"ttc         channels\"\n        \"funnel      funnel\"\n        \"campaigns   campaigns\";\n}\n\n.sa-conv-kpi1          { grid-area: kpi1;      }\n.sa-conv-kpi2          { grid-area: kpi2;      }\n.sa-conv-trend         { grid-area: trend;     }\n.sa-conv-map           { grid-area: map;       }\n.sa-conv-ttc           { grid-area: ttc;       }\n.sa-conv-channels      { grid-area: channels;  }\n.sa-conv-funnel-panel  { grid-area: funnel;    }\n.sa-conv-campaigns     { grid-area: campaigns; }\n\n@media (max-width: 900px) {\n    .sa-conv-grid--overview {\n        grid-template-columns: 1fr;\n        grid-template-areas: \"kpi1\" \"kpi2\" \"trend\" \"map\";\n    }\n    .sa-conv-grid--deepdive {\n        grid-template-columns: 1fr;\n        grid-template-areas: \"ttc\" \"channels\" \"funnel\" \"campaigns\";\n    }\n}\n\n.sa-map__mode-toggle {\n    margin-left: auto;\n    display: inline-flex;\n    gap: 2px;\n    padding: 2px;\n    border-radius: 8px;\n    background: rgba(255,255,255,0.04);\n    border: 1px solid rgba(255,255,255,0.07);\n}\n\n.sa-map__mode-toggle button {\n    appearance: none;\n    border: none;\n    background: transparent;\n    color: rgba(var(--sa-text-muted),0.7);\n    font-size: 0.66rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    padding: 4px 9px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.sa-map__mode-toggle button.is-active {\n    background: rgba(var(--sa-accent),0.18);\n    color: #e8d9b5;\n}\n\n/* ── Time-to-convert breakdown ──────────────────────────────────────────────── */\n\n.sa-ttc-row {\n    grid-template-columns: 90px 1fr 40px;\n}\n\n.sa-ttc-note {\n    margin: 12px 0 0;\n}\n\n.sa-funnel-note {\n    margin: 12px 0 0;\n}\n\n/* ── Checkout funnel ─────────────────────────────────────────────────────────── */\n\n.sa-funnel-step {\n    margin-top: 4px;\n}\n\n.sa-funnel-step__dropoff {\n    font-size: 0.68rem;\n    font-weight: 600;\n    color: rgba(239,120,120,0.8);\n    padding: 4px 0 4px 4px;\n}\n\n.sa-funnel-step__row {\n    display: grid;\n    grid-template-columns: 130px 1fr 90px;\n    align-items: center;\n    gap: 10px;\n}\n\n.sa-funnel-step__label {\n    font-size: 0.8rem;\n    color: rgba(var(--sa-text),0.9);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.sa-funnel-step__track {\n    height: 22px;\n    border-radius: 6px;\n    background: rgba(255,255,255,0.05);\n    overflow: hidden;\n}\n\n.sa-funnel-step__fill {\n    height: 100%;\n    min-width: 3px;\n    border-radius: 6px;\n    background: linear-gradient(90deg, rgba(var(--sa-accent),0.85), rgba(var(--sa-accent),0.55));\n    transition: width 0.3s ease;\n}\n\n.sa-funnel-step__value {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.85);\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-funnel-step__pct {\n    font-weight: 500;\n    color: rgba(var(--sa-text-muted),0.65);\n    margin-left: 4px;\n}\n\n/* ── Campaign table (expandable rows) ───────────────────────────────────────── */\n\n.sa-campaign-row {\n    cursor: pointer;\n}\n\n.sa-campaign-row:hover td {\n    background: rgba(255,255,255,0.02);\n}\n\n.sa-campaign-row--flat {\n    cursor: default;\n}\n\n.sa-campaign-row--flat:hover td {\n    background: transparent;\n}\n\n.sa-campaign-row__toggle {\n    width: 20px;\n    padding-right: 0 !important;\n}\n\n.sa-campaign-row__toggle .sa-icon {\n    transition: transform 0.15s ease;\n}\n\n.sa-campaign-row__chevron--open {\n    transform: rotate(-180deg);\n}\n\n.sa-campaign-row__detail td {\n    border-bottom: 1px solid rgba(255,255,255,0.04);\n    padding-top: 0;\n    padding-bottom: 10px;\n}\n\n.sa-campaign-events {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.sa-campaign-event-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.72rem;\n    color: rgba(var(--sa-text-secondary),0.8);\n    background: rgba(255,255,255,0.04);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 999px;\n    padding: 3px 10px 3px 12px;\n}\n\n.sa-campaign-event-chip b {\n    color: #ececec;\n    font-weight: 700;\n}\n/* ─── GA4 server-side badge ──────────────────────────────────────────────── */\n.ga4-ss-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 3px 10px;\n    background: rgba(var(--sa-accent),0.12);\n    border: 1px solid rgba(var(--sa-accent),0.3);\n    border-radius: 20px;\n    font-size: 0.71rem;\n    font-weight: 600;\n    color: rgba(var(--sa-accent),0.95);\n    letter-spacing: 0.01em;\n}\n\n/* Platform breakdown */\n.ga4-platform-breakdown {\n    margin-top: 16px;\n    padding-top: 14px;\n    border-top: 1px solid rgba(255,255,255,0.06);\n}\n.ga4-platform-breakdown__title {\n    margin: 0 0 10px;\n    font-size: 0.72rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: rgba(145,158,180,0.65);\n}\n.ga4-platform-breakdown__rows {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n.ga4-pb-row {\n    display: grid;\n    grid-template-columns: 160px 1fr 52px 70px;\n    align-items: center;\n    gap: 10px;\n    font-size: 0.8rem;\n}\n.ga4-pb-row__name {\n    color: rgba(185,195,215,0.85);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.ga4-pb-row--ss .ga4-pb-row__name {\n    color: rgba(var(--sa-accent),0.9);\n    font-weight: 600;\n}\n.ga4-pb-row__ss-icon {\n    margin-right: 4px;\n}\n.ga4-pb-row__ss-hint {\n    font-size: 0.7rem;\n    font-weight: 400;\n    color: rgba(140,145,200,0.65);\n    margin-left: 4px;\n}\n.ga4-pb-row__bar-wrap {\n    height: 8px;\n    background: rgba(255,255,255,0.05);\n    border-radius: 4px;\n    overflow: hidden;\n}\n.ga4-pb-row__bar {\n    height: 100%;\n    border-radius: 4px;\n    transition: width 0.3s ease;\n}\n.ga4-pb-row__share {\n    text-align: right;\n    color: rgba(145,160,185,0.75);\n    font-size: 0.75rem;\n}\n.ga4-pb-row__count {\n    text-align: right;\n    color: rgba(185,195,215,0.7);\n    font-size: 0.75rem;\n    font-variant-numeric: tabular-nums;\n}\n\n/* ─── Channel Analytics Redesigned Layout ───────────────────────────────── */\n\n/* Compact page header */\n.ca-page-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n}\n.ca-page-header__left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n.ca-page-header__title {\n    margin: 0;\n    font-size: 1.15rem;\n    font-weight: 700;\n    color: rgba(235,240,255,0.96);\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.ca-page-header__channel {\n    color: rgba(200,210,240,0.9);\n    font-weight: 600;\n}\n.ca-back-btn {\n    background: none;\n    border: none;\n    padding: 0;\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: rgba(145,160,200,0.75);\n    cursor: pointer;\n    white-space: nowrap;\n    transition: color 0.12s;\n}\n.ca-back-btn:hover { color: rgba(200,210,240,0.95); }\n.ca-compare-pill {\n    display: inline-block;\n    padding: 3px 10px;\n    background: rgba(var(--sa-accent),0.12);\n    border: 1px solid rgba(var(--sa-accent),0.25);\n    border-radius: 20px;\n    font-size: 0.71rem;\n    color: rgba(var(--sa-accent),0.95);\n}\n.ca-reconcile-link {\n    display: inline-block;\n    padding: 6px 14px;\n    background: rgba(var(--sa-accent),0.1);\n    border: 1px solid rgba(var(--sa-accent),0.25);\n    border-radius: 8px;\n    font-size: 0.77rem;\n    font-weight: 600;\n    color: rgba(var(--sa-accent),0.95);\n    text-decoration: none;\n    transition: background 0.13s;\n    white-space: nowrap;\n}\n.ca-reconcile-link:hover { background: rgba(var(--sa-accent),0.18); color: rgba(var(--sa-accent),1); }\n\n/* Consent KPI strip */\n.ca-kpi-strip {\n    display: flex;\n    gap: 0;\n    margin-bottom: 16px;\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 12px;\n    overflow: hidden;\n}\n.ca-kpi {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 12px 8px;\n    border-right: 1px solid rgba(255,255,255,0.06);\n    cursor: default;\n    min-width: 0;\n    transition: background 0.12s;\n}\n.ca-kpi:last-child { border-right: none; }\n.ca-kpi:hover { background: rgba(255,255,255,0.035); }\n.ca-kpi__value {\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: rgba(232,236,248,0.95);\n    letter-spacing: -0.025em;\n    line-height: 1.1;\n    white-space: nowrap;\n}\n.ca-kpi--warn .ca-kpi__value { color: rgba(252,165,50,0.92); }\n.ca-kpi__label {\n    font-size: 0.64rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(140,155,180,0.6);\n    margin-top: 3px;\n    text-align: center;\n    line-height: 1.2;\n}\n.ca-kpi__compare {\n    margin-top: 3px;\n    font-size: 0.7rem;\n}\n\n/* Table section header with inline toolbar */\n.ca-table-section { margin-bottom: 0; }\n.ca-table-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n}\n.ca-table-toolbar {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n/* Collapsed context section */\n.ca-context-details {\n    margin: 16px 0 4px;\n}\n.ca-context-summary {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 14px;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 10px;\n    cursor: pointer;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(170,180,210,0.8);\n    list-style: none;\n    user-select: none;\n    transition: background 0.12s;\n}\n.ca-context-summary::-webkit-details-marker { display: none; }\n.ca-context-summary::before {\n    content: \"▸\";\n    font-size: 0.7rem;\n    color: rgba(140,155,180,0.5);\n    transition: transform 0.15s;\n}\ndetails[open] .ca-context-summary::before { content: \"▾\"; }\n.ca-context-summary:hover { background: rgba(255,255,255,0.055); }\n.ca-context-summary__hint {\n    font-size: 0.69rem;\n    font-weight: 400;\n    color: rgba(130,145,170,0.55);\n    margin-left: 4px;\n}\n.ca-context-details[open] .ca-context-summary {\n    border-radius: 10px 10px 0 0;\n    border-bottom: none;\n}\n\n/* ─── GA4 Coverage & Blindspots ─────────────────────────────────────────── */\n\n.ga4-coverage {\n    margin: 20px 0 0;\n    padding: 16px 20px;\n    background: rgba(255,255,255,0.025);\n    border-radius: 10px;\n    border: 1px solid rgba(255,255,255,0.07);\n}\n.ga4-coverage__header {\n    display: flex;\n    align-items: baseline;\n    gap: 10px;\n    margin-bottom: 14px;\n}\n.ga4-coverage__title {\n    margin: 0;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-accent),0.9);\n}\n.ga4-coverage__subtitle {\n    font-size: 0.72rem;\n    color: rgba(140,155,180,0.65);\n}\n.ga4-coverage__metrics {\n    display: flex;\n    gap: 0;\n    flex-wrap: wrap;\n    margin-bottom: 14px;\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 8px;\n    overflow: hidden;\n}\n.ga4-coverage__metric {\n    flex: 1;\n    min-width: 90px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px 12px;\n    border-right: 1px solid rgba(255,255,255,0.07);\n    gap: 3px;\n}\n.ga4-coverage__metric:last-child { border-right: none; }\n.ga4-coverage__metric--dark { background: rgba(239,68,68,0.05); }\n.ga4-coverage__metric-value {\n    font-size: 1.05rem;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    color: rgba(235,240,255,0.95);\n    letter-spacing: -0.01em;\n}\n.ga4-coverage__metric--dark .ga4-coverage__metric-value {\n    color: rgba(239,68,68,0.85);\n}\n.ga4-coverage__metric-label {\n    font-size: 0.67rem;\n    color: rgba(140,155,180,0.7);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n/* Stacked bar */\n.ga4-coverage__bar-track {\n    position: relative;\n    height: 10px;\n    background: rgba(239,68,68,0.2);\n    border-radius: 6px;\n    overflow: hidden;\n    margin-bottom: 6px;\n}\n.ga4-coverage__bar-fill {\n    position: absolute;\n    left: 0; top: 0; bottom: 0;\n    background: linear-gradient(90deg, rgba(74,222,128,0.75), rgba(34,197,94,0.65));\n    border-radius: 6px;\n    transition: width 0.4s ease;\n    min-width: 2px;\n}\n.ga4-coverage__bar-legend {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 10px;\n    font-size: 0.7rem;\n}\n.ga4-coverage__legend-consent::before {\n    content: \"■\";\n    color: rgba(74,222,128,0.75);\n    margin-right: 4px;\n}\n.ga4-coverage__legend-dark::before {\n    content: \"■\";\n    color: rgba(239,68,68,0.4);\n    margin-right: 4px;\n}\n.ga4-coverage__legend-consent { color: rgba(165,185,215,0.75); }\n.ga4-coverage__legend-dark    { color: rgba(165,185,215,0.75); }\n.ga4-coverage__note {\n    margin: 0;\n    font-size: 0.71rem;\n    color: rgba(130,145,170,0.6);\n    line-height: 1.5;\n}\n\n/* ─── GA4 Channel Cross-reference ───────────────────────────────────────── */\n\n.ga4-xref {\n    margin: 20px 0 0;\n    padding: 16px 20px 12px;\n    background: rgba(255,255,255,0.02);\n    border-radius: 10px;\n    border: 1px solid rgba(255,255,255,0.07);\n}\n.ga4-xref__header {\n    display: flex;\n    align-items: baseline;\n    gap: 10px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n}\n.ga4-xref__title {\n    margin: 0;\n    font-size: 0.75rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-accent),0.9);\n}\n.ga4-xref__subtitle {\n    font-size: 0.69rem;\n    color: rgba(130,145,170,0.55);\n}\n.ga4-xref__scroll {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    margin-bottom: 10px;\n}\n.ga4-xref__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.78rem;\n}\n.ga4-xref__th {\n    padding: 6px 10px;\n    text-align: left;\n    font-size: 0.68rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba(140,155,180,0.7);\n    border-bottom: 1px solid rgba(255,255,255,0.08);\n    white-space: nowrap;\n}\n.ga4-xref__th--num { text-align: right; }\n.ga4-xref__td {\n    padding: 7px 10px;\n    color: rgba(215,225,245,0.85);\n    border-bottom: 1px solid rgba(255,255,255,0.04);\n    vertical-align: middle;\n}\n.ga4-xref__td--num {\n    text-align: right;\n    font-variant-numeric: tabular-nums;\n}\n.ga4-xref__td--channels {\n    font-size: 0.72rem;\n    color: rgba(180,195,225,0.7);\n    max-width: 220px;\n}\n.ga4-xref__row--blind {\n    background: rgba(239,68,68,0.04);\n}\n.ga4-xref__row--blind .ga4-xref__td { color: rgba(220,230,250,0.85); }\n.ga4-xref__blind-badge {\n    display: inline-block;\n    font-size: 0.6rem;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: rgba(239,68,68,0.9);\n    background: rgba(239,68,68,0.12);\n    border: 1px solid rgba(239,68,68,0.3);\n    border-radius: 4px;\n    padding: 1px 5px;\n    margin-right: 6px;\n    vertical-align: middle;\n}\n.ga4-xref__no-match {\n    color: rgba(130,145,170,0.45);\n    font-style: italic;\n}\n.ga4-xref__cov--low  { color: rgba(239,68,68,0.85);  font-weight: 600; }\n.ga4-xref__cov--mid  { color: rgba(251,191,36,0.85); font-weight: 600; }\n.ga4-xref__cov--high { color: rgba(74,222,128,0.85); font-weight: 600; }\n.ga4-xref__note {\n    margin: 0;\n    font-size: 0.7rem;\n    color: rgba(120,135,160,0.55);\n    line-height: 1.5;\n}\n\n/* ── Page Experiments — visual editor ───────────────────────────────────────── */\n\n.pxp-editor {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    height: calc(100vh - 160px);\n    min-height: 500px;\n}\n\n.pxp-editor--results {\n    height: auto;\n    min-height: 0;\n}\n\n.pxp-editor__toolbar {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n\n.pxp-back-link {\n    appearance: none;\n    border: none;\n    background: transparent;\n    color: rgba(var(--sa-text-muted),0.75);\n    font-size: 0.8rem;\n    cursor: pointer;\n    padding: 0;\n}\n.pxp-back-link:hover { color: #ececec; }\n\n.pxp-variant-tabs {\n    display: flex;\n    gap: 4px;\n    flex: 1;\n    flex-wrap: wrap;\n}\n\n.pxp-mode-tabs {\n    display: flex;\n    gap: 4px;\n}\n\n.pxp-settings-row {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n    margin-bottom: 12px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(26,26,30,0.75);\n}\n\n.pxp-goal-field {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.pxp-goal-field__label {\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-muted),0.65);\n    white-space: nowrap;\n}\n\n.pxp-settings-row__status {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-left: auto;\n}\n\n.pxp-status-note {\n    font-size: 0.78rem;\n    font-weight: 500;\n    color: rgba(var(--sa-text-secondary),0.8);\n    white-space: nowrap;\n}\n\n.pxp-variant-tab {\n    appearance: none;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.03);\n    color: rgba(var(--sa-text-secondary),0.8);\n    font-size: 0.78rem;\n    font-weight: 600;\n    padding: 6px 12px;\n    border-radius: 7px;\n    cursor: pointer;\n    outline: none;\n}\n.pxp-variant-tab.--active {\n    background: rgba(var(--sa-accent),0.2);\n    color: #e8d9b5;\n    border-color: rgba(var(--sa-accent),0.3);\n}\n.pxp-variant-tab:focus-visible {\n    outline: 2px solid rgba(var(--sa-accent),0.5);\n    outline-offset: 2px;\n}\n.pxp-variant-tab--add {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    color: rgba(var(--sa-text-dim),0.7);\n    border-style: dashed;\n}\n\n.pxp-editor__body {\n    display: flex;\n    gap: 12px;\n    flex: 1;\n    min-height: 0;\n}\n\n.pxp-editor__canvas {\n    flex: 1;\n    min-width: 0;\n    border-radius: 12px;\n    overflow: hidden;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(20,20,24,0.6);\n}\n\n.pxp-editor__iframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n    background: #fff;\n}\n\n.pxp-editor__panel {\n    flex: 0 0 300px;\n    overflow-y: auto;\n    padding: 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(26,26,30,0.75);\n}\n\n.pxp-launch-btn {\n    appearance: none;\n    border: 1px solid rgba(74,222,128,0.35);\n    background: rgba(74,222,128,0.12);\n    color: #b6f2c8;\n    font-size: 0.78rem;\n    font-weight: 600;\n    padding: 8px 14px;\n    border-radius: 8px;\n    cursor: pointer;\n}\n.pxp-launch-btn--pause {\n    border-color: rgba(220,100,100,0.35);\n    background: rgba(220,80,80,0.1);\n    color: #f0a3a3;\n}\n.pxp-launch-btn:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.pxp-select-btn {\n    display: block;\n    width: 100%;\n    appearance: none;\n    border: 1px solid rgba(var(--sa-accent),0.35);\n    background: rgba(var(--sa-accent),0.12);\n    color: #e8d9b5;\n    font-size: 0.8rem;\n    font-weight: 600;\n    padding: 9px 12px;\n    border-radius: 8px;\n    cursor: pointer;\n    margin-bottom: 14px;\n}\n.pxp-select-btn.--active {\n    background: rgba(var(--sa-accent),0.3);\n}\n.pxp-select-btn:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.pxp-inspector {\n    margin-bottom: 16px;\n    padding-bottom: 14px;\n    border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n\n.pxp-inspector__selector {\n    font-family: \"SF Mono\",\"Fira Code\",\"Cascadia Code\",monospace;\n    font-size: 0.72rem;\n    color: rgba(180,210,180,0.85);\n    background: rgba(255,255,255,0.04);\n    padding: 6px 8px;\n    border-radius: 6px;\n    margin: 0 0 12px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.pxp-inspector__label {\n    display: block;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-dim),0.6);\n    margin-bottom: 6px;\n}\n\n.pxp-changes-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.pxp-style-panel {\n    margin-bottom: 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.pxp-style-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.pxp-style-field {\n    display: grid;\n    grid-template-columns: 100px 1fr;\n    align-items: center;\n    gap: 8px;\n}\n\n.pxp-style-field__label {\n    font-size: 0.74rem;\n    color: rgba(var(--sa-text-secondary),0.8);\n}\n\n.pxp-style-field__input {\n    width: 100%;\n}\n\n.pxp-style-field__color {\n    width: 36px;\n    height: 26px;\n    padding: 0;\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: 6px;\n    background: transparent;\n    cursor: pointer;\n}\n\n.pxp-style-field__range {\n    width: 100%;\n}\n\n.pxp-style-field__range-value {\n    grid-column: 2;\n    font-size: 0.68rem;\n    color: rgba(var(--sa-text-dim),0.7);\n    margin-top: -4px;\n}\n\n/* ── Results / report panel ──────────────────────────────────────────────── */\n\n.pxp-report {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.pxp-report__pages {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    padding: 12px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(26,26,30,0.75);\n}\n\n.pxp-report__page {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    font-size: 0.82rem;\n}\n\n.pxp-report__page-name {\n    font-weight: 600;\n    color: #ececec;\n    flex-shrink: 0;\n}\n\n.pxp-report__page-url {\n    color: rgba(var(--sa-accent),0.85);\n    font-family: monospace;\n    font-size: 0.78rem;\n    overflow-wrap: anywhere;\n}\n\n.pxp-report__page-name--link {\n    cursor: pointer;\n    text-decoration: underline dotted rgba(236,236,236,0.35);\n    text-underline-offset: 3px;\n}\n\n.pxp-report__page-name--link:hover {\n    color: rgba(var(--sa-accent),0.95);\n}\n\n.pxp-report__variant-name {\n    cursor: pointer;\n}\n\n.pxp-report__variant-name:hover {\n    color: rgba(var(--sa-accent),0.95);\n}\n\n.sa-infotip {\n    display: inline-flex;\n    margin-left: 5px;\n    color: rgba(var(--sa-text-muted),0.6);\n    font-size: 0.9em;\n    line-height: 1;\n    cursor: help;\n    vertical-align: middle;\n}\n\n.sa-infotip:hover {\n    color: rgba(var(--sa-accent),0.9);\n}\n\n.sa-benchmark-note {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    margin-top: 6px;\n    font-size: 0.72rem;\n    color: rgba(var(--sa-text-dim),0.75);\n}\n\n.sa-benchmark-note__diff {\n    font-weight: 700;\n}\n\n.sa-benchmark-note__diff--up   { color: rgba(74,222,128,0.9); }\n.sa-benchmark-note__diff--down { color: rgba(248,113,113,0.9); }\n\n/* ── Variant detail page ──────────────────────────────────────────────────── */\n.pxp-detail__title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.pxp-detail__section-title {\n    margin: 22px 0 10px;\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.85);\n}\n\n.pxp-detail-stats {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n}\n\n.pxp-detail-stat {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    padding: 12px 10px;\n    border-radius: 10px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.03);\n    text-align: center;\n}\n\n.pxp-detail-stat__value {\n    font-size: 1.15rem;\n    font-weight: 700;\n    color: #ececec;\n}\n\n.pxp-detail-stat__label {\n    font-size: 0.68rem;\n    color: rgba(var(--sa-text-muted),0.7);\n}\n\n.pxp-detail-clicks {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.pxp-detail-clicks__row {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    font-size: 0.8rem;\n    padding: 8px 10px;\n    border-radius: 8px;\n    background: rgba(255,255,255,0.03);\n}\n\n.pxp-detail-clicks__selector {\n    color: rgba(var(--sa-accent),0.9);\n    font-size: 0.76rem;\n    flex-shrink: 0;\n}\n\n.pxp-detail-clicks__text {\n    color: rgba(var(--sa-text-secondary),0.75);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n}\n\n.pxp-detail-clicks__n {\n    margin-left: auto;\n    color: rgba(var(--sa-text),0.6);\n    font-size: 0.72rem;\n    flex-shrink: 0;\n}\n\n/* ── Enhanced click table ──────────────────────────────────────────────── */\n.pxp-clicks-table {\n    min-width: 560px;\n}\n\n.pxp-clicks-table td {\n    vertical-align: middle;\n}\n\n.pxp-clicks-table .pxp-detail-clicks__selector {\n    display: inline;\n    margin-right: 5px;\n}\n\n.pxp-clicks-table .pxp-detail-clicks__text {\n    display: inline;\n    font-size: 0.73rem;\n    color: rgba(var(--sa-text-secondary),0.65);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n    vertical-align: middle;\n}\n\n.pxp-clicks-table__page {\n    white-space: nowrap;\n}\n\n.pxp-clicks-table__path {\n    font-family: monospace;\n    font-size: 0.75rem;\n    color: rgba(136,176,232,0.85);\n    white-space: nowrap;\n}\n\n.pxp-clicks-table__pos {\n    white-space: nowrap;\n}\n\n.pxp-clicks-table__pos-chip {\n    font-size: 0.72rem;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.pxp-clicks-table__pos-pct {\n    font-size: 0.66rem;\n    font-weight: 400;\n    opacity: 0.6;\n    font-variant-numeric: tabular-nums;\n}\n\n.pxp-clicks-table__n {\n    position: relative;\n    font-variant-numeric: tabular-nums;\n    min-width: 90px;\n}\n\n.pxp-clicks-table__bar-wrap {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    padding: 0 12px;\n    pointer-events: none;\n}\n\n.pxp-clicks-table__bar {\n    height: 3px;\n    border-radius: 2px;\n    background: rgba(var(--sa-accent),0.35);\n    min-width: 2px;\n    position: absolute;\n    bottom: 6px;\n    left: 12px;\n    transition: width 0.3s;\n}\n\n.pxp-report__filters {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.pxp-report__filter {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 16px;\n    border-radius: 12px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(26,26,30,0.75);\n    color: rgba(var(--sa-accent),0.85);\n}\n\n.pxp-report__filter-text {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.pxp-report__filter-value {\n    font-size: 0.82rem;\n    font-weight: 600;\n    color: #ececec;\n}\n\n.pxp-report__filter-label {\n    font-size: 0.68rem;\n    color: rgba(var(--sa-text-muted),0.65);\n}\n\n.pxp-report__card {\n    background: rgba(26,26,30,0.75);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 14px;\n    padding: 18px 20px;\n    box-shadow: 0 2px 12px rgba(0,0,0,0.18);\n}\n\n.pxp-report__card-head {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 14px;\n}\n\n.pxp-report__metric-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 26px;\n    height: 22px;\n    padding: 0 6px;\n    border-radius: 6px;\n    font-size: 0.7rem;\n    font-weight: 700;\n    color: #4a3a12;\n    background: rgba(var(--sa-accent),0.85);\n}\n\n.pxp-report__metric-title {\n    margin: 0;\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: #ececec;\n}\n\n.pxp-collecting {\n    margin-bottom: 16px;\n    padding: 14px 16px;\n    border-radius: 10px;\n    background: rgba(252,165,55,0.06);\n    border: 1px solid rgba(252,165,55,0.18);\n}\n\n.pxp-collecting__head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.8rem;\n    color: rgba(230,200,150,0.9);\n    margin-bottom: 10px;\n}\n.pxp-collecting__head .sa-icon { color: rgba(252,165,55,0.8); }\n\n.pxp-collecting__track {\n    display: flex;\n    gap: 3px;\n    height: 8px;\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.pxp-collecting__seg {\n    height: 100%;\n    border-radius: 3px;\n}\n\n.pxp-report__table-scroll {\n    overflow-x: auto;\n}\n\n.pxp-report__table {\n    min-width: 640px;\n}\n\n.pxp-report__variant-dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 8px;\n}\n\n.pxp-report__baseline-chip,\n.pxp-report__collecting-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    margin-left: 8px;\n    padding: 2px 7px;\n    border-radius: 5px;\n    font-size: 0.64rem;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n    background: rgba(255,255,255,0.06);\n    color: rgba(var(--sa-text-muted),0.75);\n}\n\n.pxp-report__table td .pxp-report__collecting-chip {\n    margin-left: 0;\n    text-transform: none;\n    font-weight: 600;\n    letter-spacing: 0;\n}\n\n.pxp-report__uplift--pos { color: #86e7a4; font-weight: 600; }\n.pxp-report__uplift--neg { color: #f0a3a3; font-weight: 600; }\n\n.pxp-report__prob {\n    display: inline-flex;\n    padding: 2px 8px;\n    border-radius: 999px;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n}\n.pxp-report__prob--good    { background: rgba(74,222,128,0.15); color: #86e7a4; }\n.pxp-report__prob--bad     { background: rgba(239,68,68,0.15);  color: #f0a3a3; }\n.pxp-report__prob--neutral { background: rgba(255,255,255,0.06); color: rgba(var(--sa-text),0.8); }\n\n.pxp-report__total-row td {\n    font-weight: 700;\n    color: rgba(var(--sa-text),0.9);\n    border-top: 1px solid rgba(255,255,255,0.1);\n    border-bottom: none !important;\n}\n\n/* ── Engagement comparison table ─────────────────────────────────────── */\n.pxp-engagement-table {\n    min-width: 420px;\n}\n\n.pxp-engagement-table__metric {\n    font-size: 0.8rem;\n    color: rgba(var(--sa-text),0.8);\n}\n\n.pxp-engagement-table__target {\n    font-size: 0.75rem;\n    color: rgba(var(--sa-accent),0.7);\n    font-variant-numeric: tabular-nums;\n}\n\n.pxp-engagement-table__cell {\n    font-variant-numeric: tabular-nums;\n    position: relative;\n}\n\n.pxp-engagement-table__winner {\n    font-weight: 700;\n    color: #f2f2f2;\n}\n\n.pxp-engagement-table__best-chip {\n    display: inline-block;\n    margin-left: 5px;\n    padding: 1px 5px;\n    border-radius: 4px;\n    font-size: 0.62rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    background: rgba(74,222,128,0.18);\n    color: #86e7a4;\n    vertical-align: middle;\n}\n\n.pxp-target-pass {\n    color: #86e7a4;\n    margin-right: 4px;\n    font-size: 0.8rem;\n}\n\n.pxp-target-fail {\n    color: #f0a3a3;\n    margin-right: 4px;\n    font-size: 0.8rem;\n}\n\n/* ── Targets edit button ──────────────────────────────────────────────── */\n.pxp-targets-edit-btn {\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: 7px;\n    padding: 5px 12px;\n    color: rgba(var(--sa-text),0.7);\n    font-size: 0.75rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.pxp-targets-edit-btn:hover {\n    background: rgba(255,255,255,0.1);\n    color: rgba(var(--sa-text),0.9);\n}\n\n/* ── Targets inline editor ────────────────────────────────────────────── */\n.pxp-targets-editor {\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 10px;\n    padding: 14px 16px;\n    margin-bottom: 16px;\n}\n\n.pxp-targets-editor__hint {\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text-secondary),0.6);\n    margin: 0 0 12px;\n}\n\n.pxp-targets-editor__grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n    gap: 10px;\n    margin-bottom: 14px;\n}\n\n.pxp-targets-editor__field {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.pxp-targets-editor__label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text-secondary),0.65);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n}\n\n.pxp-targets-editor__input-wrap {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.pxp-targets-editor__input {\n    background: rgba(255,255,255,0.07);\n    border: 1px solid rgba(255,255,255,0.14);\n    border-radius: 6px;\n    padding: 5px 8px;\n    color: #f2f2f2;\n    font-size: 0.8rem;\n    width: 80px;\n    outline: none;\n    font-variant-numeric: tabular-nums;\n}\n\n.pxp-targets-editor__input:focus {\n    border-color: rgba(255,255,255,0.28);\n}\n\n.pxp-targets-editor__unit {\n    font-size: 0.75rem;\n    color: rgba(var(--sa-text-muted),0.5);\n}\n\n.pxp-targets-editor__actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n/* ── Graph tabs + charts ─────────────────────────────────────────────────── */\n\n.pxp-graph-tabs {\n    display: flex;\n    gap: 18px;\n    margin-bottom: 14px;\n    border-bottom: 1px solid rgba(255,255,255,0.08);\n}\n\n.pxp-graph-tab {\n    appearance: none;\n    border: none;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 0 2px 10px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text-muted),0.7);\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n}\n.pxp-graph-tab .sa-icon { color: inherit; }\n.pxp-graph-tab.--active {\n    color: #e8d9b5;\n    border-bottom-color: rgba(var(--sa-accent),0.85);\n}\n\n.pxp-graph {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.pxp-graph-scroll {\n    overflow-x: auto;\n}\n\n.pxp-graph__svg {\n    width: 100%;\n    min-width: 560px;\n    height: auto;\n    display: block;\n}\n\n.pxp-graph__legend {\n    display: flex;\n    gap: 16px;\n    flex-wrap: wrap;\n}\n\n.pxp-graph__legend-item {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.76rem;\n    color: rgba(var(--sa-text-secondary),0.85);\n}\n\n.pxp-graph__legend-dot {\n    width: 9px;\n    height: 9px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n/* ── Traffic split panel ──────────────────────────────────────────────────── */\n.pxp-split-panel {\n    padding: 20px 24px;\n    margin-bottom: 16px;\n    background: rgba(26,26,30,0.75);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 14px;\n}\n\n.pxp-split-panel__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 14px;\n}\n\n.pxp-split-panel__title {\n    display: flex;\n    align-items: center;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #ececec;\n}\n\n.pxp-split-panel__total {\n    font-size: 0.85rem;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    color: rgba(134,231,164,0.9);\n}\n\n.pxp-split-panel__total--bad {\n    color: rgba(240,163,163,0.9);\n}\n\n.pxp-split-panel__rows {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.pxp-split-panel__row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.pxp-split-panel__label {\n    flex: 1;\n    font-size: 0.82rem;\n    color: rgba(var(--sa-text),0.9);\n}\n\n.pxp-split-panel__input {\n    width: 70px;\n    margin: 0;\n    text-align: right;\n}\n\n.pxp-split-panel__pct-sign {\n    color: rgba(var(--sa-text-muted),0.7);\n    font-size: 0.82rem;\n}\n\n.pxp-split-panel__hint {\n    margin: 10px 0 0;\n    font-size: 0.76rem;\n    color: rgba(240,163,163,0.85);\n}\n\n.pxp-split-panel__actions {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    margin-top: 14px;\n}\n\n/* ── URL split test panel ──────────────────────────────────────────────────── */\n.pxp-url-split-panel {\n    padding: 24px;\n}\n\n.pxp-url-split-variants {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.pxp-url-split-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: rgba(255,255,255,0.04);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 8px;\n    padding: 14px 16px;\n}\n\n.pxp-url-split-row__meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 130px;\n    flex-shrink: 0;\n}\n\n.pxp-url-split-row__label {\n    font-weight: 600;\n    font-size: 14px;\n    color: rgba(255,255,255,0.9);\n}\n\n.pxp-url-split-row__label-input {\n    font-weight: 600;\n    font-size: 14px;\n    width: 140px;\n    margin: 0;\n    flex-shrink: 0;\n}\n\n.pxp-url-split-row__control-note {\n    flex: 1;\n    font-size: 13px;\n    color: rgba(var(--sa-text),0.7);\n    margin: 0;\n}\n\n.pxp-url-split-row__control-note code {\n    color: rgba(var(--sa-text),0.9);\n    font-family: monospace;\n    font-size: 12px;\n}\n\n.pxp-url-split-row__input {\n    flex: 1;\n    margin: 0;\n}\n\n/* ── Test type tag in list ─────────────────────────────────────────────────── */\n.sa-event-row__tag {\n    display: inline-flex;\n    align-items: center;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    color: rgba(var(--sa-text),0.7);\n    background: rgba(255,255,255,0.07);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 4px;\n    padding: 2px 7px;\n    text-transform: uppercase;\n}\n\n/* ── Create form: test type selector ──────────────────────────────────────── */\n.sa-event-form__type-row {\n    display: flex;\n    gap: 10px;\n    margin: 4px 0;\n}\n\n.sa-event-form__type-opt {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    padding: 10px 14px;\n    border-radius: 8px;\n    border: 1.5px solid rgba(255,255,255,0.1);\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.8);\n    background: rgba(255,255,255,0.03);\n    transition: border-color 0.15s, background 0.15s;\n    user-select: none;\n}\n\n.sa-event-form__type-opt input[type=\"radio\"] {\n    display: none;\n}\n\n.sa-event-form__type-opt--active {\n    border-color: rgba(var(--sa-accent),0.7);\n    background: rgba(var(--sa-accent),0.08);\n    color: rgba(255,255,255,0.95);\n}\n\n.sa-event-form__type-hint {\n    font-size: 11px;\n    font-weight: 400;\n    color: rgba(var(--sa-text-secondary),0.6);\n}\n\n.sa-event-form__type-opt--active .sa-event-form__type-hint {\n    color: rgba(var(--sa-text-secondary),0.8);\n}\n\n/* ── Create form: whole-site wildcard toggle ──────────────────────────────── */\n.sa-event-form__checkbox {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    margin: -2px 0 4px;\n    font-size: 12.5px;\n    font-weight: 500;\n    color: rgba(var(--sa-text),0.75);\n    cursor: pointer;\n    user-select: none;\n}\n\n/* ── Cohort retention matrix ─────────────────────────────────────────────── */\n.sa-cohorts-wrap {\n    width: 100%;\n}\n\n.sa-cohort-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n    white-space: nowrap;\n}\n\n.sa-cohort-table th,\n.sa-cohort-table td {\n    padding: 6px 10px;\n    border: 1px solid rgba(255,255,255,0.06);\n    text-align: center;\n    color: rgba(220,230,245,0.85);\n}\n\n.sa-cohort-table th {\n    background: rgba(255,255,255,0.04);\n    font-weight: 600;\n    font-size: 0.78rem;\n    color: rgba(160,174,192,0.8);\n}\n\n.sa-cohort-table__week {\n    text-align: left !important;\n    min-width: 90px;\n}\n\n.sa-cohort-table__size {\n    text-align: right !important;\n    color: rgba(160,174,192,0.7);\n    min-width: 60px;\n}\n\n.sa-cohort-table__cell {\n    min-width: 54px;\n    border-radius: 0;\n    font-size: 0.8rem;\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-cohort-legend {\n    margin-top: 12px;\n    font-size: 0.78rem;\n    color: rgba(160,174,192,0.6);\n}\n\n.sa-panel__sub {\n    font-size: 0.8rem;\n    color: rgba(160,174,192,0.6);\n    margin: 0 0 14px;\n    line-height: 1.5;\n}\n\n/* ── Analytics alerts ────────────────────────────────────────────────────── */\n.sa-alerts-grid {\n    display: grid;\n    grid-template-columns: 1fr 400px;\n    gap: 20px;\n    align-items: start;\n}\n\n@media (max-width: 960px) {\n    .sa-alerts-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.sa-alert-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.sa-alert-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 16px;\n    padding: 12px 14px;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 8px;\n}\n\n.sa-alert-edit-form {\n    width: 100%;\n    border-top: 1px solid rgba(255,255,255,0.07);\n    padding-top: 14px;\n    margin-top: 4px;\n}\n\n.sa-alert-edit-form__grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 12px;\n}\n\n.sa-alert-edit-form__actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 12px;\n}\n\n.sa-alert-row--disabled {\n    opacity: 0.5;\n}\n\n.sa-alert-row__meta {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 0;\n}\n\n.sa-alert-row__name {\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba(220,230,245,0.9);\n}\n\n.sa-alert-row__rule {\n    font-size: 0.78rem;\n    color: rgba(160,174,192,0.7);\n}\n\n.sa-alert-row__last {\n    font-size: 0.75rem;\n    color: rgba(160,174,192,0.45);\n}\n\n.sa-alert-row__actions {\n    display: flex;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.sa-alert-form {\n    position: sticky;\n    top: 70px;\n}\n\n.sa-alert-form__fields {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.sa-form-label {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: rgba(160,174,192,0.8);\n}\n\n.sa-form-select,\n.sa-form-input {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: 6px;\n    padding: 7px 10px;\n    color: rgba(220,230,245,0.9);\n    font-size: 0.85rem;\n    outline: none;\n    width: 100%;\n}\n\n.sa-form-select:focus,\n.sa-form-input:focus {\n    border-color: rgba(var(--sa-accent),0.5);\n}\n\n.sa-form-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.83rem;\n    color: rgba(200,210,225,0.75);\n    cursor: pointer;\n}\n\n.sa-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 16px;\n    border-radius: 6px;\n    border: 1px solid rgba(var(--sa-accent),0.4);\n    background: rgba(var(--sa-accent),0.12);\n    color: rgba(var(--sa-accent),0.95);\n    font-size: 0.83rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s;\n}\n\n.sa-btn:hover:not(:disabled) {\n    background: rgba(var(--sa-accent),0.22);\n}\n\n.sa-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.sa-btn--sm {\n    padding: 5px 10px;\n    font-size: 0.77rem;\n}\n\n.sa-btn--ghost {\n    border-color: rgba(180,180,180,0.15);\n    background: transparent;\n    color: rgba(var(--sa-text-secondary),0.5);\n}\n\n.sa-btn--ghost:hover:not(:disabled) {\n    background: rgba(180,180,180,0.08);\n    color: rgba(var(--sa-text-secondary),0.75);\n}\n\n.sa-btn--danger {\n    border-color: rgba(239,68,68,0.35);\n    background: rgba(239,68,68,0.08);\n    color: rgba(239,68,68,0.85);\n}\n\n.sa-btn--danger:hover:not(:disabled) {\n    background: rgba(239,68,68,0.16);\n}\n\n/* ── Attribution comparison panel ───────────────────────────────────────── */\n.sa-attr-comparison {\n    grid-column: 1 / -1;\n}\n\n.sa-attr-cols {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n}\n\n@media (max-width: 700px) {\n    .sa-attr-cols {\n        grid-template-columns: 1fr;\n    }\n}\n\n.sa-attr-col {\n    min-width: 0;\n}\n\n/* ── Consent impact estimator ────────────────────────────────────────────── */\n.sa-consent-impact {\n    grid-column: 1 / -1;\n}\n\n.sa-ci-kpis {\n    display: flex;\n    gap: 28px;\n    flex-wrap: wrap;\n    margin-bottom: 18px;\n}\n\n.sa-ci-kpi {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 120px;\n}\n\n.sa-ci-kpi__label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(160,174,192,0.7);\n}\n\n.sa-ci-kpi__value {\n    font-size: 1.4rem;\n    font-weight: 700;\n    color: rgba(220,230,245,0.95);\n    font-variant-numeric: tabular-nums;\n}\n\n.sa-ci-kpi__note {\n    font-size: 0.75rem;\n    color: rgba(239,68,68,0.65);\n}\n\n.sa-ci-bar-wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.sa-ci-bar {\n    display: flex;\n    height: 18px;\n    border-radius: 4px;\n    overflow: hidden;\n    background: rgba(255,255,255,0.05);\n}\n\n.sa-ci-bar__observed {\n    background: rgba(74,222,128,0.55);\n    transition: width 0.4s ease;\n}\n\n.sa-ci-bar__hidden {\n    background: rgba(239,68,68,0.35);\n    transition: width 0.4s ease;\n}\n\n.sa-ci-bar-labels {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.74rem;\n    color: rgba(160,174,192,0.5);\n}\n\n/* ── Segment filter bar ──────────────────────────────────────────────────── */\n.sa-seg-filter {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    padding: 10px 0 2px;\n}\n\n.sa-seg-filter__label {\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: rgba(160,174,192,0.55);\n    white-space: nowrap;\n}\n\n.sa-seg-filter__select,\n.sa-seg-filter__country {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 5px;\n    padding: 5px 8px;\n    color: rgba(210,220,235,0.85);\n    font-size: 0.78rem;\n    outline: none;\n    cursor: pointer;\n}\n\n.sa-seg-filter__country {\n    width: 90px;\n    text-transform: uppercase;\n}\n\n.sa-seg-filter__select:focus,\n.sa-seg-filter__country:focus {\n    border-color: rgba(var(--sa-accent),0.4);\n}\n\n.sa-seg-filter__clear {\n    padding: 4px 10px;\n    border-radius: 5px;\n    border: 1px solid rgba(239,68,68,0.3);\n    background: rgba(239,68,68,0.07);\n    color: rgba(239,68,68,0.8);\n    font-size: 0.76rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.sa-seg-filter__clear:hover {\n    background: rgba(239,68,68,0.14);\n}\n\n/* ── Ad Spend sync bar ───────────────────────────────────────────────────── */\n.sa-as-sync-bar {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 4px;\n}\n\n.sa-as-sync-btn {\n    padding: 5px 12px;\n    border-radius: 5px;\n    border: 1px solid rgba(var(--sa-accent),0.35);\n    background: rgba(var(--sa-accent),0.08);\n    color: rgba(var(--sa-accent),0.85);\n    font-size: 0.78rem;\n    font-weight: 600;\n    cursor: pointer;\n}\n\n.sa-as-sync-btn:hover:not(:disabled) {\n    background: rgba(var(--sa-accent),0.16);\n}\n\n.sa-as-sync-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.sa-as-sync-msg {\n    font-size: 0.78rem;\n    color: rgba(160,174,192,0.65);\n}\n\n\n/* ── Saved Reports (My Reports list page) ────────────────────────────────── */\n\n.sa-reports-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    gap: 16px;\n}\n\n.sa-reports-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 14px;\n}\n\n.sa-report-card {\n    background: rgba(26,26,30,0.75);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 12px;\n    padding: 16px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n    transition: border-color .15s, box-shadow .15s;\n    min-height: 200px;\n    box-shadow: 0 2px 10px rgba(0,0,0,0.2);\n}\n\n.sa-report-card:hover {\n    border-color: rgba(var(--sa-accent),0.35);\n    box-shadow: 0 4px 18px rgba(0,0,0,0.28);\n}\n\n.sa-report-card__type {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.67rem;\n    color: rgba(var(--sa-text-dim),0.6);\n    font-weight: 700;\n    letter-spacing: .07em;\n    text-transform: uppercase;\n}\n\n.sa-report-card__name {\n    font-size: 0.92rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.9);\n    line-height: 1.3;\n}\n\n.sa-report-card__meta {\n    font-size: 0.74rem;\n    color: rgba(var(--sa-text-muted),0.6);\n}\n\n.sa-report-card__preview {\n    flex: 1;\n    display: flex;\n    border-radius: 6px;\n    overflow: hidden;\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.06);\n    min-height: 72px;\n    margin-top: 4px;\n}\n\n.sa-report-card__footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 2px;\n}\n\n.sa-report-card__date {\n    font-size: 0.70rem;\n    color: rgba(var(--sa-text-dim),0.5);\n}\n\n.sa-report-card__actions {\n    display: flex;\n    gap: 5px;\n}\n\n.sa-report-card__action-btn {\n    font-size: 0.70rem;\n    padding: 3px 8px;\n    border-radius: 4px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.04);\n    color: rgba(var(--sa-text-muted),0.7);\n    cursor: pointer;\n    transition: background .12s, color .12s;\n}\n\n.sa-report-card__action-btn:hover {\n    background: rgba(255,255,255,0.09);\n    color: rgba(var(--sa-text),0.9);\n}\n\n.sa-report-card__action-btn--del {\n    border-color: rgba(220,80,80,0.2);\n    color: rgba(220,100,100,0.65);\n}\n\n.sa-report-card__action-btn--del:hover {\n    background: rgba(220,80,80,0.08);\n    color: rgba(245,140,140,0.9);\n}\n\n.sa-report-card--new {\n    border-style: dashed;\n    border-color: rgba(255,255,255,0.1);\n    background: rgba(255,255,255,0.015);\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 5px;\n}\n\n.sa-report-card--new:hover {\n    border-color: rgba(var(--sa-accent),0.3);\n    background: rgba(var(--sa-accent),0.04);\n}\n\n.sa-report-card--new__plus {\n    font-size: 1.8rem;\n    line-height: 1;\n    color: rgba(var(--sa-text-muted),0.4);\n}\n\n.sa-report-card--new:hover .sa-report-card--new__plus {\n    color: rgba(var(--sa-accent),0.7);\n}\n\n.sa-report-card--new__label {\n    font-size: 0.84rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text-muted),0.6);\n}\n\n.sa-report-card--new:hover .sa-report-card--new__label {\n    color: rgba(var(--sa-accent),0.85);\n}\n\n.sa-reports-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 60px 20px;\n    text-align: center;\n}\n\n.sa-reports-empty__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 14px;\n    color: rgba(var(--sa-accent),0.45);\n}\n\n.sa-reports-empty__title {\n    font-size: 1rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.85);\n    margin-bottom: 6px;\n}\n\n.sa-reports-empty__sub {\n    font-size: 0.82rem;\n    color: rgba(var(--sa-text-muted),0.6);\n    max-width: 340px;\n    line-height: 1.5;\n}\n\n/* ── sa-btn--primary (gold filled) ──────────────────────────────────────── */\n.sa-btn--primary {\n    border-color: rgba(var(--sa-accent),0.55);\n    background: rgba(var(--sa-accent),0.18);\n    color: rgba(var(--sa-accent),1);\n}\n\n.sa-btn--primary:hover:not(:disabled) {\n    background: rgba(var(--sa-accent),0.28);\n}\n\n/* ── Report Builder ──────────────────────────────────────────────────────── */\n\n/* Back link inside StickyPageTitle */\n.sa-rb-back {\n    background: none;\n    border: none;\n    color: rgba(var(--sa-text-muted),0.65);\n    cursor: pointer;\n    font-size: 0.82rem;\n    font-weight: 500;\n    padding: 0;\n    white-space: nowrap;\n    transition: color .12s;\n}\n.sa-rb-back:hover { color: rgba(var(--sa-text),0.9); }\n\n/* Report name input inside the sticky title */\n.sa-rb-name-input {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 6px;\n    padding: 5px 10px;\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.9);\n    outline: none;\n    width: 280px;\n    transition: border-color .15s;\n}\n.sa-rb-name-input::placeholder { color: rgba(var(--sa-text-dim),0.45); font-weight: 400; }\n.sa-rb-name-input:focus { border-color: rgba(var(--sa-accent),0.4); }\n\n/* Two-column page grid */\n.sa-rb-grid {\n    display: grid;\n    grid-template-columns: 260px 1fr;\n    gap: 16px;\n    align-items: start;\n}\n\n@media (max-width: 860px) {\n    .sa-rb-grid { grid-template-columns: 1fr; }\n}\n\n/* Config column: panels stack naturally, sticky on desktop */\n.sa-rb-config-col {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    position: sticky;\n    top: 70px;\n}\n\n/* Preview column: panels stack naturally */\n.sa-rb-preview-col {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    min-width: 0;\n}\n\n/* Save / cancel actions block */\n.sa-rb-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n/* Chart type grid */\n.sa-rb-chart-types {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 4px;\n}\n\n.sa-rb-ct-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    padding: 8px 4px 7px;\n    border-radius: 6px;\n    border: 1px solid rgba(255,255,255,0.07);\n    background: rgba(255,255,255,0.03);\n    color: rgba(var(--sa-text-muted),0.65);\n    cursor: pointer;\n    font-size: 0.63rem;\n    font-weight: 600;\n    letter-spacing: .02em;\n    transition: all .12s;\n}\n.sa-rb-ct-btn:hover {\n    background: rgba(255,255,255,0.06);\n    color: rgba(var(--sa-text),0.88);\n    border-color: rgba(255,255,255,0.12);\n}\n.sa-rb-ct-btn--active {\n    border-color: rgba(var(--sa-accent),0.45);\n    background: rgba(var(--sa-accent),0.1);\n    color: rgba(var(--sa-accent),0.95);\n}\n.sa-rb-ct-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 18px;\n    height: 18px;\n}\n\n/* Metrics & breakdown lists */\n.sa-rb-metric-list,\n.sa-rb-breakdown-list {\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n.sa-rb-metric-item,\n.sa-rb-breakdown-item {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    padding: 5px 4px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background .1s;\n}\n.sa-rb-metric-item:hover,\n.sa-rb-breakdown-item:hover { background: rgba(255,255,255,0.04); }\n\n.sa-rb-check {\n    width: 15px;\n    height: 15px;\n    border-radius: 3px;\n    border: 1px solid rgba(255,255,255,0.15);\n    background: rgba(255,255,255,0.03);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.6rem;\n    font-weight: 700;\n    color: rgba(var(--sa-accent),0.9);\n    flex-shrink: 0;\n    transition: all .1s;\n}\n.sa-rb-check--on {\n    background: rgba(var(--sa-accent),0.15);\n    border-color: rgba(var(--sa-accent),0.5);\n}\n.sa-rb-radio {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 1px solid rgba(255,255,255,0.15);\n    background: rgba(255,255,255,0.03);\n    flex-shrink: 0;\n    position: relative;\n    transition: all .1s;\n}\n.sa-rb-radio--sel {\n    border-color: rgba(var(--sa-accent),0.55);\n    background: rgba(var(--sa-accent),0.1);\n}\n.sa-rb-radio--sel::after {\n    content: \"\";\n    position: absolute;\n    inset: 3px;\n    border-radius: 50%;\n    background: rgba(var(--sa-accent),0.9);\n}\n.sa-rb-metric-label {\n    font-size: 0.81rem;\n    color: rgba(var(--sa-text),0.75);\n}\n\n/* Filters */\n.sa-rb-filter-rows { display: flex; flex-direction: column; gap: 6px; margin-bottom: 8px; }\n.sa-rb-filter-row  { display: flex; align-items: center; gap: 4px; }\n.sa-rb-filter-remove {\n    background: none;\n    border: none;\n    color: rgba(var(--sa-text-dim),0.5);\n    cursor: pointer;\n    font-size: 1rem;\n    padding: 0 2px;\n    line-height: 1;\n    transition: color .1s;\n}\n.sa-rb-filter-remove:hover { color: rgba(220,100,100,0.75); }\n.sa-rb-add-filter {\n    font-size: 0.76rem;\n    color: rgba(var(--sa-text-muted),0.55);\n    background: none;\n    border: 1px dashed rgba(255,255,255,0.09);\n    border-radius: 5px;\n    padding: 5px 10px;\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n    transition: color .12s, border-color .12s;\n}\n.sa-rb-add-filter:hover {\n    color: rgba(var(--sa-accent),0.8);\n    border-color: rgba(var(--sa-accent),0.25);\n}\n\n/* KPI strip above the main chart */\n.sa-rb-kpi-strip {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n.sa-rb-kpi {\n    background: rgba(26,26,30,0.75);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 10px;\n    padding: 12px 16px;\n    min-width: 110px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.18);\n}\n.sa-rb-kpi__label {\n    font-size: 0.63rem;\n    letter-spacing: .08em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-dim),0.6);\n    font-weight: 700;\n}\n.sa-rb-kpi__value {\n    font-size: 1.45rem;\n    font-weight: 700;\n    color: rgba(var(--sa-text),0.92);\n    margin-top: 4px;\n    letter-spacing: -.01em;\n}\n\n/* KPI grid (kpi chart type) */\n.sa-rb-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 12px;\n}\n\n/* Horizontal bar rows */\n.sa-rb-bar-chart { display: flex; flex-direction: column; gap: 7px; padding: 4px 0; }\n.sa-rb-bar-row   { display: flex; align-items: center; gap: 8px; }\n.sa-rb-bar-label {\n    font-size: 0.77rem;\n    color: rgba(var(--sa-text-muted),0.7);\n    width: 90px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n.sa-rb-bar-track {\n    flex: 1;\n    height: 5px;\n    border-radius: 3px;\n    background: rgba(255,255,255,0.07);\n    overflow: hidden;\n}\n.sa-rb-bar-fill {\n    height: 100%;\n    border-radius: 3px;\n    background: rgba(var(--sa-accent),0.75);\n    transition: width .35s;\n}\n.sa-rb-bar-val {\n    font-size: 0.77rem;\n    color: rgba(var(--sa-text-muted),0.7);\n    width: 54px;\n    text-align: right;\n    flex-shrink: 0;\n}\n\n/* Donut */\n.sa-rb-donut-wrap   { display: flex; align-items: center; gap: 28px; padding: 8px 0; flex-wrap: wrap; }\n.sa-rb-donut-legend { display: flex; flex-direction: column; gap: 8px; min-width: 220px; }\n.sa-rb-donut-row    { display: flex; align-items: center; gap: 8px; }\n.sa-rb-donut-dot    { width: 9px; height: 9px; border-radius: 50%; flex-shrink: 0; }\n.sa-rb-donut-label  { font-size: 0.81rem; color: rgba(var(--sa-text),0.85); flex: 1; min-width: 80px; }\n.sa-rb-donut-count  { font-size: 0.77rem; color: rgba(var(--sa-text-muted),0.6); width: 52px; text-align: right; flex-shrink: 0; }\n.sa-rb-donut-pct    { font-size: 0.77rem; font-weight: 700; color: rgba(var(--sa-accent),0.9); width: 38px; text-align: right; flex-shrink: 0; }\n\n.sa-rb-no-data { font-size: 0.82rem; color: rgba(var(--sa-text-dim),0.5); padding: 24px 0; text-align: center; }\n\n/* ── Template library ────────────────────────────────────────────────────── */\n\n.sa-tpl-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 0;\n}\n\n.sa-tpl-body {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.sa-tpl-category__label {\n    font-size: 0.67rem;\n    font-weight: 700;\n    letter-spacing: .09em;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n}\n\n.sa-tpl-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 10px;\n}\n\n.sa-tpl-card {\n    background: rgba(255,255,255,0.025);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 10px;\n    padding: 14px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    transition: background .12s, border-color .12s;\n}\n\n.sa-tpl-card:hover {\n    background: rgba(var(--sa-accent),0.06);\n    border-color: rgba(var(--sa-accent),0.25);\n}\n\n.sa-tpl-card__header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 2px;\n}\n\n.sa-tpl-card__icon {\n    display: flex;\n    align-items: center;\n    opacity: 0.85;\n}\n\n.sa-tpl-card__cat {\n    font-size: 0.63rem;\n    font-weight: 700;\n    letter-spacing: .07em;\n    text-transform: uppercase;\n}\n\n.sa-tpl-card__name {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: rgba(var(--sa-text),0.9);\n    line-height: 1.25;\n}\n\n.sa-tpl-card__desc {\n    font-size: 0.75rem;\n    color: rgba(var(--sa-text-muted),0.6);\n    line-height: 1.45;\n}\n\n.sa-tpl-card__meta {\n    font-size: 0.70rem;\n    color: rgba(var(--sa-text-dim),0.5);\n    margin-top: 2px;\n}\n\n.sa-tpl-card__use {\n    font-size: 0.73rem;\n    font-weight: 600;\n    color: rgba(var(--sa-accent),0.7);\n    margin-top: 4px;\n    opacity: 0;\n    transition: opacity .12s;\n}\n\n.sa-tpl-card:hover .sa-tpl-card__use {\n    opacity: 1;\n}\n\n/* ── Template library controls (search + tabs) ─────────────────────────── */\n\n.sa-tpl-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 14px;\n    flex-wrap: wrap;\n}\n\n.sa-tpl-tabs {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n    flex: 1;\n}\n\n.sa-tpl-tab {\n    background: transparent;\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 6px;\n    padding: 4px 10px;\n    font-size: 0.75rem;\n    font-weight: 500;\n    color: rgba(var(--sa-text-muted),0.65);\n    cursor: pointer;\n    transition: background .12s, border-color .12s, color .12s;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    white-space: nowrap;\n}\n\n.sa-tpl-tab:hover {\n    background: rgba(255,255,255,0.04);\n    color: rgba(var(--sa-text),0.85);\n    border-color: rgba(255,255,255,0.14);\n}\n\n.sa-tpl-tab--active {\n    background: rgba(var(--sa-accent),0.12);\n    border-color: rgba(var(--sa-accent),0.35);\n    color: rgba(var(--sa-accent),0.9);\n}\n\n.sa-tpl-tab__count {\n    font-size: 0.65rem;\n    background: rgba(255,255,255,0.07);\n    border-radius: 20px;\n    padding: 1px 5px;\n    color: rgba(var(--sa-text-dim),0.6);\n}\n\n.sa-tpl-tab--active .sa-tpl-tab__count {\n    background: rgba(var(--sa-accent),0.18);\n    color: rgba(var(--sa-accent),0.7);\n}\n\n.sa-tpl-search {\n    background: rgba(255,255,255,0.04);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 6px;\n    padding: 5px 10px;\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text),0.85);\n    outline: none;\n    width: 180px;\n    transition: border-color .12s, background .12s;\n}\n\n.sa-tpl-search::placeholder {\n    color: rgba(var(--sa-text-dim),0.45);\n}\n\n.sa-tpl-search:focus {\n    border-color: rgba(var(--sa-accent),0.35);\n    background: rgba(var(--sa-accent),0.04);\n}\n\n/* ── Report View (sa-rv-*) ──────────────────────────────────────────────── */\n\n.sa-rv-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    flex-wrap: wrap;\n    margin-bottom: 16px;\n}\n\n.sa-rv-meta {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    min-width: 0;\n}\n\n.sa-rv-meta__chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    align-items: center;\n}\n\n.sa-rv-meta__updated {\n    font-size: 0.72rem;\n    color: rgba(var(--sa-text-dim),0.5);\n}\n\n.sa-rv-chip {\n    display: inline-flex;\n    align-items: center;\n    background: rgba(var(--sa-accent),0.1);\n    border: 1px solid rgba(var(--sa-accent),0.22);\n    border-radius: 20px;\n    padding: 3px 9px;\n    font-size: 0.72rem;\n    font-weight: 500;\n    color: rgba(var(--sa-accent),0.85);\n    white-space: nowrap;\n}\n\n.sa-rv-chip--dim {\n    background: rgba(255,255,255,0.04);\n    border-color: rgba(255,255,255,0.08);\n    color: rgba(var(--sa-text-muted),0.65);\n}\n\n.sa-rv-chip--filter {\n    background: rgba(99,179,237,0.08);\n    border-color: rgba(99,179,237,0.2);\n    color: rgba(99,179,237,0.75);\n}\n\n.sa-rv-actions {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.sa-rv-kpi-strip {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 10px;\n    margin-bottom: 16px;\n}\n\n.sa-rv-kpi {\n    background: rgba(26,26,30,0.75);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 10px;\n    padding: 14px 16px;\n}\n\n.sa-rv-kpi__label {\n    font-size: 0.63rem;\n    font-weight: 700;\n    letter-spacing: .08em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-dim),0.6);\n    margin-bottom: 6px;\n}\n\n.sa-rv-kpi__value {\n    font-size: 1.55rem;\n    font-weight: 700;\n    color: rgba(var(--sa-text),0.92);\n    letter-spacing: -.01em;\n}\n\n.sa-rv-bar-chart {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.sa-rv-bar-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.sa-rv-bar-label {\n    width: 120px;\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text-muted),0.75);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.sa-rv-bar-track {\n    flex: 1;\n    height: 7px;\n    background: rgba(255,255,255,0.06);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.sa-rv-bar-fill {\n    height: 100%;\n    background: rgba(var(--sa-accent),0.7);\n    border-radius: 4px;\n    transition: width .3s ease;\n}\n\n.sa-rv-bar-val {\n    width: 52px;\n    text-align: right;\n    font-size: 0.78rem;\n    font-variant-numeric: tabular-nums;\n    color: rgba(var(--sa-text),0.75);\n    flex-shrink: 0;\n}\n\n/* ── Report Builder — metric groups + ad notice ─────────────────────────── */\n\n.sa-rb-metric-group-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    letter-spacing: .09em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-dim),0.5);\n    padding: 4px 0 2px;\n    margin-bottom: 2px;\n    border-top: 1px solid rgba(255,255,255,0.05);\n}\n\n.sa-rb-metric-group-label:first-of-type {\n    border-top: none;\n    padding-top: 0;\n}\n\n.sa-rb-metric-group-badge {\n    font-size: 0.58rem;\n    font-weight: 500;\n    letter-spacing: 0;\n    text-transform: none;\n    background: rgba(239,68,68,0.1);\n    border: 1px solid rgba(239,68,68,0.2);\n    color: rgba(239,68,68,0.65);\n    border-radius: 20px;\n    padding: 1px 5px;\n}\n\n.sa-rb-ad-notice {\n    background: rgba(239,68,68,0.06);\n    border: 1px solid rgba(239,68,68,0.18);\n    border-radius: 8px;\n    padding: 10px 14px;\n    font-size: 0.78rem;\n    color: rgba(var(--sa-text),0.7);\n    margin-bottom: 4px;\n}\n\n.sa-rb-ad-notice strong {\n    color: rgba(239,68,68,0.8);\n    font-weight: 600;\n}\n\n/* ── Report builder hint text ───────────────────────────────────────────── */\n\n.sa-rb-hint {\n    font-size: 0.73rem;\n    color: rgba(var(--sa-text-dim),0.55);\n    line-height: 1.5;\n    margin: 0 0 10px;\n}\n\n/* ── Conversion Attribution table ─────────────────────────────────────────── */\n\n.sa-attr-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.82rem;\n}\n\n.sa-attr-th {\n    text-align: left;\n    padding: 8px 12px;\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: rgba(var(--sa-text-dim),0.6);\n    border-bottom: 1px solid rgba(255,255,255,0.07);\n    white-space: nowrap;\n}\n\n.sa-attr-td {\n    padding: 10px 12px;\n    border-bottom: 1px solid rgba(255,255,255,0.04);\n    color: rgba(var(--sa-text),0.85);\n    vertical-align: middle;\n}\n\n.sa-attr-row:last-child .sa-attr-td {\n    border-bottom: none;\n}\n\n.sa-attr-row:hover .sa-attr-td {\n    background: rgba(255,255,255,0.02);\n}\n\n/* ── Small action button variant ─────────────────────────────────────────── */\n\n.sa-btn--sm {\n    padding: 3px 10px;\n    font-size: 0.75rem;\n}\n\n/* ── Ad Spend toolbar (currency picker + sync) ───────────────────────────── */\n\n.sa-as-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.sa-currency-picker {\n    display: flex;\n    gap: 4px;\n    background: rgba(255,255,255,0.04);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 8px;\n    padding: 3px;\n}\n\n.sa-currency-btn {\n    padding: 4px 11px;\n    border-radius: 5px;\n    background: transparent;\n    border: none;\n    color: rgba(var(--sa-text-secondary),0.6);\n    font-size: 12px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.15s, color 0.15s;\n    letter-spacing: 0.02em;\n}\n\n.sa-currency-btn:hover {\n    background: rgba(255,255,255,0.06);\n    color: rgba(var(--sa-text),0.9);\n}\n\n.sa-currency-btn--active {\n    background: rgba(var(--sa-accent),0.18);\n    color: rgba(var(--sa-accent),1);\n}\n\n/* ── Forms dashboard ──────────────────────────────────────────────────────────── */\n\n.sa-form-id {\n    display: block;\n    font-size: 13px;\n    color: rgba(210,210,220,0.9);\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 280px;\n}\n\n.sa-table-scroll {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 680px) {\n    .sa-form-id { max-width: 160px; }\n}\n\n.sa-rage__detail {\n    max-width: 220px;\n    line-height: 1.4;\n}\n.sa-rage__id {\n    display: block;\n    font-size: 11px;\n    font-family: monospace;\n    color: rgba(var(--sa-accent),0.9);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n}\n.sa-rage__cls {\n    display: block;\n    font-size: 11px;\n    font-family: monospace;\n    color: rgba(100,210,160,0.8);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 200px;\n}\n.sa-rage__none {\n    color: rgba(120,120,140,0.5);\n    font-size: 12px;\n}\n\n.sa-form-action {\n    display: block;\n    font-size: 11px;\n    color: rgba(var(--sa-text-muted),0.6);\n    margin-top: 2px;\n}\n\n/* ── Forms page grid ──────────────────────────────────────────────────────────── */\n\n.sa-forms-grid {\n    display: grid;\n    gap: 14px;\n    margin-bottom: 14px;\n    min-width: 0;\n}\n\n.sa-forms-grid > * {\n    min-width: 0;\n    overflow: hidden;\n}\n\n.sa-forms-grid--main {\n    grid-template-columns: 3fr 2fr;\n}\n\n.sa-forms-grid--bottom {\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.sa-forms-grid--insights {\n    grid-template-columns: 3fr 2fr;\n}\n\n.sa-forms-grid--acq {\n    grid-template-columns: 3fr 2fr;\n}\n\n@media (max-width: 1100px) {\n    .sa-forms-grid--main     { grid-template-columns: 1fr; }\n    .sa-forms-grid--bottom   { grid-template-columns: 1fr 1fr; }\n    .sa-forms-grid--insights { grid-template-columns: 1fr; }\n    .sa-forms-grid--acq      { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 680px) {\n    .sa-forms-grid--main     { grid-template-columns: 1fr; }\n    .sa-forms-grid--bottom   { grid-template-columns: 1fr; }\n    .sa-forms-grid--insights { grid-template-columns: 1fr; }\n    .sa-forms-grid--acq      { grid-template-columns: 1fr; }\n    .sa-forms-grid { gap: 10px; margin-bottom: 10px; }\n}\n\n.sa-section-divider {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 24px 0 4px;\n    color: rgba(var(--sa-text-muted),0.6);\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n.sa-section-divider::before,\n.sa-section-divider::after {\n    content: \"\";\n    flex: 1;\n    height: 1px;\n    background: rgba(255,255,255,0.07);\n}\n\n.sa-field-name {\n    font-family: monospace;\n    font-size: 12px;\n    color: rgba(var(--sa-accent),0.9);\n    background: rgba(var(--sa-accent),0.08);\n    padding: 1px 5px;\n    border-radius: 3px;\n}\n\n.sa-error-type {\n    display: inline-block;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    padding: 2px 6px;\n    border-radius: 4px;\n    white-space: nowrap;\n}\n.sa-error-type--validation {\n    color: rgba(234,179,8,0.95);\n    background: rgba(234,179,8,0.1);\n}\n.sa-error-type--network {\n    color: rgba(239,68,68,0.95);\n    background: rgba(239,68,68,0.1);\n}\n.sa-error-type--server {\n    color: rgba(249,115,22,0.95);\n    background: rgba(249,115,22,0.1);\n}\n\n.sa-muted {\n    color: rgba(120,120,140,0.5);\n    font-size: 12px;\n}\n\n.sa-http-desc {\n    display: block;\n    font-size: 11px;\n    color: rgba(var(--sa-text-muted),0.65);\n    margin-top: 2px;\n    line-height: 1.3;\n}\n\n.sa-panel__desc {\n    font-size: 12px;\n    color: rgba(var(--sa-text-muted),0.65);\n    margin: -4px 0 12px;\n}\n\n.sa-table__page {\n    font-size: 11px;\n    color: rgba(var(--sa-text-muted),0.7);\n    max-width: 280px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.sa-empty {\n    color: rgba(var(--sa-text-muted),0.6);\n    font-size: 13px;\n    padding: 32px 0;\n    text-align: center;\n}\n\n.sa-loading {\n    color: rgba(var(--sa-text-muted),0.6);\n    font-size: 13px;\n    padding: 32px 0;\n    text-align: center;\n}\n\n/* ── Auto-collected / enhanced measurement block ──────────────────────────────── */\n\n.sa-enhanced-block {\n    background: linear-gradient(135deg, rgba(var(--sa-accent),0.08) 0%, rgba(16,185,129,0.05) 100%);\n    border: 1px solid rgba(var(--sa-accent),0.2);\n    border-radius: 12px;\n    padding: 18px 20px 16px;\n    margin-bottom: 24px;\n}\n\n.sa-enhanced-block__head {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 14px;\n}\n\n.sa-enhanced-block__sparkle {\n    font-size: 18px;\n    line-height: 1;\n    color: rgba(var(--sa-accent),0.9);\n    flex-shrink: 0;\n    margin-top: 1px;\n}\n\n.sa-enhanced-block__titles {\n    flex: 1;\n    min-width: 0;\n}\n\n.sa-enhanced-block__title {\n    display: block;\n    font-size: 13px;\n    font-weight: 600;\n    color: rgba(220,220,230,0.95);\n    margin-bottom: 3px;\n}\n\n.sa-enhanced-block__sub {\n    display: block;\n    font-size: 11.5px;\n    color: rgba(var(--sa-text-muted),0.7);\n    line-height: 1.4;\n}\n\n.sa-enhanced-block__badge {\n    flex-shrink: 0;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    color: rgba(var(--sa-accent),0.9);\n    background: rgba(var(--sa-accent),0.12);\n    border: 1px solid rgba(var(--sa-accent),0.25);\n    border-radius: 4px;\n    padding: 2px 7px;\n    align-self: center;\n}\n\n.sa-enhanced-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n\n.sa-auto-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 4px 10px 4px 7px;\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 20px;\n    font-size: 12px;\n    color: rgba(var(--sa-text),0.9);\n    white-space: nowrap;\n    transition: background 0.15s, border-color 0.15s;\n    cursor: default;\n}\n\n.sa-auto-chip:hover {\n    background: rgba(255,255,255,0.08);\n    border-color: rgba(255,255,255,0.16);\n}\n\n.sa-auto-chip--dim {\n    opacity: 0.45;\n}\n\n.sa-auto-chip--dim:hover {\n    opacity: 0.65;\n}\n\n.sa-auto-chip--more {\n    cursor: pointer;\n    color: rgba(var(--sa-accent),0.9);\n    border-color: rgba(var(--sa-accent),0.25);\n    background: rgba(var(--sa-accent),0.07);\n    font-weight: 500;\n}\n\n.sa-auto-chip--more:hover {\n    background: rgba(var(--sa-accent),0.14);\n    border-color: rgba(var(--sa-accent),0.4);\n}\n\n.sa-auto-chip__icon {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.sa-auto-chip__label {\n    font-size: 12px;\n}\n\n.sa-auto-chip__count {\n    font-size: 11px;\n    font-weight: 600;\n    color: rgba(160,160,175,0.8);\n    margin-left: 1px;\n}\n\n.sa-panel__head--mt {\n    margin-top: 8px;\n}\n\n/* ── Performance dashboard ────────────────────────────────────────────── */\n.sa-perf-cwv-row {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n    margin-bottom: 14px;\n}\n.sa-perf-cwv-card {\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-top-width: 3px;\n    border-radius: 8px;\n    padding: 18px 20px 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n.sa-perf-cwv-card__label {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(180,180,200,0.6);\n}\n.sa-perf-cwv-card__value {\n    font-size: 2rem;\n    font-weight: 700;\n    line-height: 1.1;\n    letter-spacing: -0.02em;\n}\n.sa-perf-cwv-card__rating {\n    font-size: 12px;\n    font-weight: 600;\n}\n.sa-perf-cwv-card__desc {\n    margin-top: 6px;\n    font-size: 11px;\n    color: rgba(var(--sa-text-muted),0.6);\n    line-height: 1.4;\n}\n.sa-perf-timing-row {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n    margin-bottom: 14px;\n}\n.sa-perf-timing-card {\n    background: rgba(255,255,255,0.02);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 6px;\n    padding: 12px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n.sa-perf-timing-card__label {\n    font-size: 13px;\n    font-weight: 700;\n    color: rgba(200,200,220,0.85);\n}\n.sa-perf-timing-card__sub {\n    font-size: 10px;\n    color: rgba(var(--sa-text-muted),0.55);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n.sa-perf-timing-card__value {\n    margin-top: 4px;\n    font-size: 15px;\n    font-weight: 600;\n}\n.sa-perf-rating-wrap {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n.sa-perf-rating-bar {\n    display: flex;\n    height: 10px;\n    border-radius: 5px;\n    overflow: hidden;\n    background: rgba(255,255,255,0.06);\n}\n.sa-perf-rating-bar__seg { height: 100%; transition: width 0.3s; }\n.sa-perf-rating-bar__seg--good { background: rgba(34,197,94,0.75); }\n.sa-perf-rating-bar__seg--ni   { background: rgba(234,179,8,0.75); }\n.sa-perf-rating-bar__seg--poor { background: rgba(239,68,68,0.75); }\n.sa-perf-rating-legend {\n    display: flex;\n    gap: 20px;\n    font-size: 12px;\n    color: rgba(160,160,180,0.7);\n}\n.sa-perf-dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 5px;\n    vertical-align: middle;\n}\n.sa-perf-dot--good { background: rgba(34,197,94,0.75); }\n.sa-perf-dot--ni   { background: rgba(234,179,8,0.75); }\n.sa-perf-dot--poor { background: rgba(239,68,68,0.75); }\n.sa-perf-empty {\n    padding: 40px 24px;\n    text-align: center;\n    color: rgba(160,160,180,0.7);\n}\n.sa-perf-empty h3 { margin: 0 0 10px; color: rgba(200,200,220,0.8); }\n.sa-perf-empty p  { margin: 0 0 8px; font-size: 14px; }\n.sa-table__sortable { user-select: none; }\n.sa-table__sortable--active { color: rgba(var(--sa-accent),0.9); }\n.sa-perf-badge {\n    display: inline-block;\n    font-size: 10px;\n    padding: 1px 6px;\n    border-radius: 4px;\n    background: rgba(255,255,255,0.07);\n    color: rgba(180,180,200,0.75);\n    border: 1px solid rgba(255,255,255,0.08);\n    white-space: nowrap;\n}\n.sa-perf-badge--warn {\n    background: rgba(234,179,8,0.1);\n    color: rgba(234,179,8,0.8);\n    border-color: rgba(234,179,8,0.2);\n}\n.sa-table-pager {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 8px 4px 2px;\n}\n.sa-table-pager__btn {\n    background: rgba(255,255,255,0.07);\n    border: 1px solid rgba(255,255,255,0.1);\n    border-radius: 6px;\n    color: rgba(200,200,220,0.85);\n    font-size: 16px;\n    line-height: 1;\n    padding: 2px 10px 4px;\n    cursor: pointer;\n}\n.sa-table-pager__btn:disabled {\n    opacity: 0.3;\n    cursor: default;\n}\n.sa-table-pager__btn:not(:disabled):hover {\n    background: rgba(255,255,255,0.13);\n}\n.sa-table-pager__info {\n    font-size: 12px;\n    color: rgba(160,160,180,0.7);\n    min-width: 40px;\n    text-align: center;\n}\n.sa-perf-thumb {\n    display: block;\n    width: 88px;\n    height: 56px;\n    object-fit: cover;\n    border-radius: 5px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.04);\n}\n.sa-perf-thumb-shimmer {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0.07) 50%, rgba(255,255,255,0.03) 100%);\n    background-size: 200% 100%;\n    animation: sa-shimmer 1.6s infinite;\n    border-radius: 3px;\n}\n@keyframes sa-shimmer {\n    0%   { background-position: 200% 0; }\n    100% { background-position: -200% 0; }\n}\n.sa-perf-thumb-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 88px;\n    height: 56px;\n    border-radius: 5px;\n    border: 1px solid rgba(255,255,255,0.08);\n    background: rgba(255,255,255,0.04);\n    font-size: 11px;\n    color: rgba(200,200,220,0.4);\n    font-family: monospace;\n}\n/* ── Country detail back bar ─────────────────────────────────────────── */\n.sa-perf-back {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    padding: 10px 0 4px;\n}\n.sa-perf-back__btn {\n    background: none;\n    border: 1px solid rgba(255,255,255,0.12);\n    border-radius: 6px;\n    color: rgba(200,200,220,0.7);\n    cursor: pointer;\n    font-size: 13px;\n    padding: 5px 12px;\n    transition: border-color 0.15s, color 0.15s;\n    white-space: nowrap;\n}\n.sa-perf-back__btn:hover { border-color: rgba(255,255,255,0.28); color: rgba(220,220,240,0.95); }\n.sa-perf-back__title {\n    font-size: 18px;\n    font-weight: 700;\n    color: rgba(220,220,240,0.9);\n    display: flex;\n    align-items: center;\n}\n\n/* ── 2-column panel grid ─────────────────────────────────────────────── */\n.sa-perf-2col {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n    gap: 20px;\n    align-items: start;\n}\n\n/* ── Sparkline trend grid ─────────────────────────────────────────────── */\n.sa-perf-sparklines {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n}\n.sa-perf-sparkline-card {\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 8px;\n    padding: 14px 16px 10px;\n}\n.sa-perf-sparkline-card__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    margin-bottom: 10px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    color: rgba(200,200,220,0.55);\n}\n\n@media (max-width: 1000px) {\n    .sa-perf-cwv-row    { grid-template-columns: 1fr 1fr; }\n    .sa-perf-timing-row { grid-template-columns: 1fr 1fr; }\n    .sa-perf-sparklines { grid-template-columns: 1fr 1fr; }\n}\n@media (max-width: 600px) {\n    .sa-perf-cwv-row    { grid-template-columns: 1fr; }\n    .sa-perf-timing-row { grid-template-columns: 1fr 1fr; }\n    .sa-perf-sparklines { grid-template-columns: 1fr; }\n}\n\n/* ── Section labels ───────────────────────────────────────────────────────── */\n.sa-perf-section-label {\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: rgba(160,160,180,0.45);\n    margin-bottom: 8px;\n    padding-left: 2px;\n}\n\n/* ── Period-over-period delta chip ────────────────────────────────────────── */\n.sa-perf-delta {\n    display: inline-block;\n    font-size: 13px;\n    font-weight: 600;\n    margin-left: 8px;\n    vertical-align: middle;\n}\n.sa-perf-cwv-card__value .sa-perf-delta {\n    font-size: 14px;\n}\n.sa-perf-timing-card__value .sa-perf-delta {\n    font-size: 11px;\n    margin-left: 5px;\n}\n\n/* ── Sparkline band chart label ───────────────────────────────────────────── */\n.sa-perf-sparkline-p75 {\n    font-size: 9px;\n    opacity: 0.5;\n    font-weight: 400;\n}\n\n/* ── Percentile range bar ─────────────────────────────────────────────────── */\n.sa-pctile-range-wrap {\n    position: relative;\n    height: 10px;\n    background: rgba(255,255,255,0.04);\n    border-radius: 3px;\n    overflow: visible;\n    min-width: 100px;\n}\n.sa-pctile-range-bg {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    border-radius: 3px;\n    overflow: hidden;\n}\n.sa-pctile-range-bar {\n    position: absolute;\n    top: 1px;\n    bottom: 1px;\n    background: rgba(var(--sa-accent),0.35);\n    border-radius: 2px;\n    min-width: 3px;\n}\n.sa-pctile-range-tick {\n    position: absolute;\n    top: -1px;\n    bottom: -1px;\n    width: 2px;\n    background: rgba(var(--sa-accent),0.85);\n    border-radius: 1px;\n    transform: translateX(-50%);\n}\n\n/* ── PageTable LCP range bar ──────────────────────────────────────────────── */\n.sa-page-lcp-bar {\n    position: relative;\n    height: 8px;\n    background: rgba(255,255,255,0.06);\n    border-radius: 3px;\n    min-width: 80px;\n    overflow: visible;\n}\n\n/* ── LongTask total-block horizontal bar ──────────────────────────────────── */\n.sa-blocker-bar-wrap {\n    flex: 1;\n    height: 6px;\n    background: rgba(255,255,255,0.06);\n    border-radius: 3px;\n    overflow: hidden;\n    min-width: 40px;\n    max-width: 80px;\n}\n.sa-blocker-bar {\n    height: 100%;\n    border-radius: 3px;\n    transition: width 0.3s;\n    min-width: 2px;\n}\n\n/* ── Scope / data-gap notes ───────────────────────────────────────────────── */\n.sa-perf-scope-note {\n    font-size: 11px;\n    color: rgba(150,150,170,0.6);\n    margin: 0 0 10px;\n    font-style: italic;\n}\n.sa-perf-gap-panel {\n    border-color: rgba(234,179,8,0.12) !important;\n    background: rgba(234,179,8,0.03) !important;\n}\n.sa-perf-gap-panel .sa-panel__title {\n    color: rgba(234,179,8,0.65);\n}\n.sa-perf-gap-panel code {\n    font-size: 11px;\n    background: rgba(255,255,255,0.06);\n    padding: 1px 4px;\n    border-radius: 3px;\n}\n\n/* ── Business impact ──────────────────────────────────────────────────────── */\n.sa-perf-bi-empty {\n    padding: 16px 0 8px;\n    color: rgba(150,150,170,0.75);\n    font-size: 13px;\n    line-height: 1.5;\n}\n.sa-perf-bi-empty code {\n    font-size: 11px;\n    background: rgba(255,255,255,0.07);\n    padding: 1px 5px;\n    border-radius: 3px;\n    color: rgba(200,200,220,0.7);\n}\n.sa-perf-bi-callout {\n    background: rgba(34,197,94,0.06);\n    border: 1px solid rgba(34,197,94,0.14);\n    border-radius: 8px;\n    padding: 10px 14px;\n    font-size: 13px;\n    color: rgba(190,220,200,0.9);\n    margin-bottom: 16px;\n    line-height: 1.5;\n}\n.sa-perf-bi-callout--neutral {\n    background: rgba(234,179,8,0.05);\n    border-color: rgba(234,179,8,0.14);\n    color: rgba(220,200,160,0.8);\n}\n.sa-perf-bi-rows {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n.sa-perf-bi-row {\n    display: grid;\n    grid-template-columns: 170px 1fr 56px 180px;\n    align-items: center;\n    gap: 14px;\n}\n.sa-perf-bi-label {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    font-size: 13px;\n    font-weight: 600;\n}\n.sa-perf-bi-bar-wrap {\n    height: 10px;\n    background: rgba(255,255,255,0.05);\n    border-radius: 5px;\n    overflow: hidden;\n}\n.sa-perf-bi-bar {\n    height: 100%;\n    border-radius: 5px;\n    transition: width 0.4s;\n    min-width: 2px;\n}\n.sa-perf-bi-rate {\n    font-size: 14px;\n    font-weight: 700;\n    text-align: right;\n    color: rgba(220,220,240,0.9);\n}\n.sa-perf-bi-sessions {\n    font-size: 11px;\n}\n@media (max-width: 700px) {\n    .sa-perf-bi-row { grid-template-columns: 140px 1fr 50px; }\n    .sa-perf-bi-sessions { display: none; }\n}\n\n/* ── Experiment CWV — shared (comparison table + variant detail) ───────── */\n.pxp-cwv-val { font-weight: 600; }\n.pxp-cwv-val--good { color: #22c55e; }\n.pxp-cwv-val--ni   { color: #eab308; }\n.pxp-cwv-val--poor { color: #ef4444; }\n.pxp-cwv-val--none { color: rgba(220,220,240,0.85); }\n\n.pxp-cwv-sample {\n    font-size: 10px;\n    font-weight: 400;\n    color: rgba(160,160,180,0.6);\n    margin-left: 2px;\n}\n\n/* Rating distribution bar — used in both comparison table and detail page */\n.pxp-cwv-dist {\n    display: flex;\n    height: 4px;\n    border-radius: 2px;\n    overflow: hidden;\n    background: rgba(255,255,255,0.06);\n    margin-top: 6px;\n}\n.pxp-cwv-dist__seg--good { background: rgba(34,197,94,0.75); }\n.pxp-cwv-dist__seg--ni   { background: rgba(234,179,8,0.75); }\n.pxp-cwv-dist__seg--poor { background: rgba(239,68,68,0.75); }\n\n/* ── Variant detail — CWV three-up metric grid ─────────────────────────── */\n.pxp-cwv-detail-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    margin-bottom: 12px;\n}\n.pxp-cwv-detail-metric {\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 8px;\n    padding: 12px 14px;\n}\n.pxp-cwv-detail-metric__val {\n    display: block;\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 3px;\n}\n.pxp-cwv-detail-metric__label {\n    display: block;\n    font-size: 11px;\n    color: rgba(160,160,180,0.65);\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n.pxp-cwv-detail-metric__range {\n    margin-top: 5px;\n    font-size: 11px;\n    color: rgba(160,160,180,0.45);\n}\n\n/* Rating bar row in variant detail */\n.pxp-cwv-dist-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n.pxp-cwv-dist-row .pxp-cwv-dist {\n    flex: 1;\n    height: 8px;\n    border-radius: 4px;\n    margin-top: 0;\n    min-width: 0;\n}\n\n/* Supporting metrics (FCP, TTFB) in variant detail */\n.pxp-cwv-supporting {\n    display: flex;\n    gap: 24px;\n    font-size: 13px;\n    color: rgba(170,170,190,0.65);\n    margin-bottom: 4px;\n}\n.pxp-cwv-supporting strong {\n    color: rgba(220,220,240,0.88);\n    font-weight: 600;\n}\n\n@media (max-width: 640px) {\n    .pxp-cwv-detail-grid { grid-template-columns: 1fr 1fr; }\n}\n\n/* ── Page Weight — treemap ────────────────────────────────────────────────── */\n.sa-treemap-wrap {\n    border: 1px solid rgba(255,255,255,0.07);\n    border-radius: 8px;\n    overflow: hidden;\n    background: rgba(0,0,0,0.15);\n}\n.sa-treemap-svg {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 960 / 420;\n    display: block;\n}\n.sa-treemap-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 18px;\n    margin-top: 14px;\n}\n.sa-treemap-legend__item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: rgba(200,200,220,0.8);\n}\n.sa-treemap-legend__swatch {\n    width: 10px;\n    height: 10px;\n    border-radius: 3px;\n    flex-shrink: 0;\n}\n.sa-treemap-legend__label {\n    font-weight: 600;\n}\n.sa-treemap-legend__value {\n    color: rgba(200,200,220,0.6);\n}\n.sa-treemap-legend__pct {\n    font-size: 11px;\n}\n\n/* ── Page Weight — diagnostics & recommendations ──────────────────────────── */\n.sa-diag-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n.sa-diag-item {\n    background: rgba(255,255,255,0.03);\n    border: 1px solid rgba(255,255,255,0.07);\n    border-left-width: 3px;\n    border-radius: 6px;\n    padding: 10px 14px;\n}\n.sa-diag-item__head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    margin-bottom: 4px;\n}\n.sa-diag-item__title {\n    font-size: 13px;\n    font-weight: 700;\n    color: rgba(230,230,245,0.92);\n}\n.sa-diag-item__detail {\n    margin: 0 0 8px;\n    font-size: 12.5px;\n    line-height: 1.5;\n    color: rgba(190,190,210,0.75);\n}\n.sa-diag-item__savings {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    font-size: 12px;\n}\n.sa-diag-item__savings-label {\n    color: rgba(160,160,180,0.6);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    font-size: 10px;\n}\n.sa-diag-item__savings-value {\n    font-weight: 700;\n    color: rgba(var(--sa-accent),0.95);\n}\n\n/* ── Channel Digest page ─────────────────────────────────────────────────────── */\n\n.sa-subnav__tab--portfolio {\n    margin-left: auto;\n    padding-left: 16px;\n    border-left: 1px solid rgba(255,255,255,0.06);\n}\n\n.sa-digest-meta {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 10px 0 16px;\n}\n.sa-digest-meta__info {\n    font-size: 0.78rem;\n    color: rgba(155,155,175,0.55);\n}\n.sa-digest-meta__refresh {\n    background: rgba(255,255,255,0.05);\n    border: 1px solid rgba(255,255,255,0.08);\n    border-radius: 6px;\n    color: rgba(200,200,220,0.7);\n    font-size: 0.75rem;\n    padding: 3px 10px;\n    cursor: pointer;\n    transition: background 0.12s;\n}\n.sa-digest-meta__refresh:hover { background: rgba(255,255,255,0.09); }\n.sa-digest-meta__refresh:disabled { opacity: 0.4; cursor: default; }\n\n.sa-digest-section { margin-top: 8px; }\n\n.sa-digest-card { position: relative; }\n.sa-digest-card__domain {\n    display: inline-block;\n    font-size: 0.68rem;\n    color: rgba(var(--sa-accent),0.65);\n    background: rgba(var(--sa-accent),0.08);\n    border: 1px solid rgba(var(--sa-accent),0.15);\n    border-radius: 4px;\n    padding: 1px 6px;\n    margin-bottom: 6px;\n    font-family: monospace;\n    letter-spacing: 0.02em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
